export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Monetary amount in cents */
  MoneyCents: { input: any; output: any; }
  /** Percentage as decimal (0 = 0%, 1 = 100%) */
  Percent: { input: any; output: any; }
  /** Date in format 'YYYY-MM-DD' */
  SimpleDate: { input: string; output: string; }
  /** ISO date string */
  Timestamp: { input: number | string; output: number | string; }
};

export type AccountSizeWidgetParams = {
  __typename?: 'AccountSizeWidgetParams';
  filter?: Maybe<PolicyFilterOutput>;
};

export type AccountSizeWidgetParamsInput = {
  filter?: InputMaybe<PolicyFilter>;
};

export enum AccountsReportEntity {
  AccountExecutive = 'ACCOUNT_EXECUTIVE',
  AccountManager = 'ACCOUNT_MANAGER',
  Carrier = 'CARRIER',
  Department = 'DEPARTMENT',
  Industry = 'INDUSTRY',
  PolicyType = 'POLICY_TYPE',
  Producer = 'PRODUCER',
  Product = 'PRODUCT'
}

export type AccountsWidgetParams = {
  __typename?: 'AccountsWidgetParams';
  filter?: Maybe<PolicyFilterOutput>;
};

export type AccountsWidgetParamsInput = {
  filter?: InputMaybe<PolicyFilter>;
};

export type Activities = {
  __typename?: 'Activities';
  activityKpi?: Maybe<ActivityKpiComparisonResult>;
  activityLeaderboardByDepartment: Array<ActivityLeaderboardResult>;
  activityLeaderboardByEmployee: Array<ActivityLeaderboardResult>;
  activityTrends: ActivityTrends;
  byClient: ActivitiesPaginatedResult;
  code?: Maybe<ActivityCode>;
  filterValues: ActivityFilterValuesResult;
  list: ActivitiesPaginatedResult;
  overdueStatisticsPerDuration: Array<ActivityOverduePerDuration>;
  topActivities: Array<TopActivitiesResult>;
};


export type ActivitiesActivityKpiArgs = {
  filter?: InputMaybe<PolicyFilter>;
};


export type ActivitiesActivityLeaderboardByDepartmentArgs = {
  filter?: InputMaybe<PolicyFilter>;
};


export type ActivitiesActivityLeaderboardByEmployeeArgs = {
  filter?: InputMaybe<PolicyFilter>;
};


export type ActivitiesActivityTrendsArgs = {
  filter?: InputMaybe<PolicyFilter>;
};


export type ActivitiesByClientArgs = {
  clientId: Scalars['ID']['input'];
  filter?: InputMaybe<ClientActivityFilter>;
  pagination: ActivityPaginationInput;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type ActivitiesCodeArgs = {
  code: Scalars['String']['input'];
};


export type ActivitiesListArgs = {
  filter?: InputMaybe<PolicyFilter>;
  pagination: ActivityPaginationInput;
};


export type ActivitiesOverdueStatisticsPerDurationArgs = {
  filter?: InputMaybe<PolicyFilter>;
};


export type ActivitiesTopActivitiesArgs = {
  filter?: InputMaybe<PolicyFilter>;
  limit?: InputMaybe<Scalars['Float']['input']>;
};

export type ActivitiesPaginatedResult = {
  __typename?: 'ActivitiesPaginatedResult';
  items: Array<Activity>;
  totalHits: Scalars['Int']['output'];
};

export type Activity = {
  __typename?: 'Activity';
  client?: Maybe<Client>;
  closedDate?: Maybe<Scalars['Timestamp']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  codeDescription?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['Timestamp']['output']>;
  daysDuration?: Maybe<Scalars['Int']['output']>;
  department?: Maybe<Department>;
  followUpStartDate?: Maybe<Scalars['Timestamp']['output']>;
  id: Scalars['ID']['output'];
  isOverdue: Scalars['Boolean']['output'];
  policy?: Maybe<Policy>;
  product?: Maybe<Product>;
  subject?: Maybe<Scalars['String']['output']>;
  type: ActivityType;
  user?: Maybe<User>;
};

export type ActivityCode = {
  __typename?: 'ActivityCode';
  code: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
};

export type ActivityCompanyFilter = {
  childIds?: InputMaybe<Array<Scalars['String']['input']>>;
  parentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  ultimateParentIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ActivityCompanyFilterOutput = {
  __typename?: 'ActivityCompanyFilterOutput';
  childIds?: Maybe<Array<Scalars['String']['output']>>;
  parentIds?: Maybe<Array<Scalars['String']['output']>>;
  ultimateParentIds?: Maybe<Array<Scalars['String']['output']>>;
};

export type ActivityDateRange = {
  /** Type of date to filter by (open date, close date, or any date) */
  dateRangeType?: InputMaybe<ActivityDateRangeType>;
  from?: InputMaybe<Scalars['SimpleDate']['input']>;
  /** Used for filtering activities by period */
  period?: InputMaybe<ActivityPeriodType>;
  to?: InputMaybe<Scalars['SimpleDate']['input']>;
};

export type ActivityDateRangeOutput = {
  __typename?: 'ActivityDateRangeOutput';
  /** Type of date to filter by (open date, close date, or any date) */
  dateRangeType?: Maybe<ActivityDateRangeType>;
  from?: Maybe<Scalars['SimpleDate']['output']>;
  /** Used for filtering activities by period */
  period?: Maybe<ActivityPeriodType>;
  to?: Maybe<Scalars['SimpleDate']['output']>;
};

/** Type of date range for activity filtering */
export enum ActivityDateRangeType {
  /** Filter by any date (open or close) */
  ByAnyDate = 'BY_ANY_DATE',
  /** Filter by close date */
  ByCloseDate = 'BY_CLOSE_DATE',
  /** Filter by open date */
  ByOpenDate = 'BY_OPEN_DATE'
}

export type ActivityEmployee = {
  __typename?: 'ActivityEmployee';
  fullName: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type ActivityFilter = {
  activityCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  carrierFilter?: InputMaybe<ActivityCompanyFilter>;
  dateRange?: InputMaybe<ActivityDateRange>;
  employeeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  hasClient?: InputMaybe<Scalars['Boolean']['input']>;
  isOverdue?: InputMaybe<Scalars['Boolean']['input']>;
  productFilter?: InputMaybe<ActivityProductFilter>;
};

export type ActivityFilterOutput = {
  __typename?: 'ActivityFilterOutput';
  activityCodes?: Maybe<Array<Scalars['String']['output']>>;
  carrierFilter?: Maybe<ActivityCompanyFilterOutput>;
  dateRange?: Maybe<ActivityDateRangeOutput>;
  employeeIds?: Maybe<Array<Scalars['String']['output']>>;
  hasClient?: Maybe<Scalars['Boolean']['output']>;
  isOverdue?: Maybe<Scalars['Boolean']['output']>;
  productFilter?: Maybe<ProductActivityFilterOutput>;
};

export type ActivityFilterValuesResult = {
  __typename?: 'ActivityFilterValuesResult';
  codes: Array<ActivityCode>;
  employees: Array<ActivityEmployee>;
};

export type ActivityKpiComparisonResult = {
  __typename?: 'ActivityKpiComparisonResult';
  accountsWorkEfforts: Growth;
  avgEffortPerAccount: Growth;
  overdueActivities: Growth;
  totalEmployees: Growth;
  totalWorkEfforts: Growth;
};

export enum ActivityLeaderboardEntity {
  Department = 'DEPARTMENT',
  Employee = 'EMPLOYEE'
}

export type ActivityLeaderboardResult = {
  __typename?: 'ActivityLeaderboardResult';
  allActivities: Scalars['Int']['output'];
  clientsWithActivities: Scalars['Int']['output'];
  entityId: Scalars['String']['output'];
  entityName: Scalars['String']['output'];
  overdueActivities: Scalars['Int']['output'];
};

export type ActivityOverduePerDuration = {
  __typename?: 'ActivityOverduePerDuration';
  dayRange: OutputRange;
  overdue: Scalars['Int']['output'];
  overduePercentage?: Maybe<Scalars['Float']['output']>;
  rangeName?: Maybe<Scalars['String']['output']>;
  total: Scalars['Int']['output'];
};

export type ActivityPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy: ActivitySortingField;
  /** Total count will be different if we use sorting by metric with permissions */
  sortOrder?: InputMaybe<SortOrder>;
};

/** Type of period for activity filtering */
export enum ActivityPeriodType {
  AllTime = 'ALL_TIME',
  /** Filter activities from the last 30 days */
  Last_30Days = 'LAST_30_DAYS',
  /** Filter activities from the last 120 days */
  Last_120Days = 'LAST_120_DAYS'
}

export type ActivityProductFilter = {
  productGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  productIds?: InputMaybe<Array<Scalars['String']['input']>>;
  productInsuranceSegmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  productSuperGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum ActivitySortingField {
  ActivityType = 'ACTIVITY_TYPE',
  Code = 'CODE',
  CodeDescription = 'CODE_DESCRIPTION',
  Date = 'DATE',
  PolicyNumber = 'POLICY_NUMBER',
  ProductName = 'PRODUCT_NAME',
  Subject = 'SUBJECT',
  UserName = 'USER_NAME'
}

export type ActivityTrends = {
  __typename?: 'ActivityTrends';
  activities: MonthlyTrends;
  avgActivitiesPerClient: MonthlyTrends;
  clients: MonthlyTrends;
};

export enum ActivityType {
  Ams = 'AMS',
  Email = 'EMAIL'
}

export type AddResponseToFavoritesPayload = {
  __typename?: 'AddResponseToFavoritesPayload';
  success: Scalars['Boolean']['output'];
};

export type Address = {
  __typename?: 'Address';
  country?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  streetLine1?: Maybe<Scalars['String']['output']>;
  streetLine2?: Maybe<Scalars['String']['output']>;
};

export type AdminCompany = {
  __typename?: 'AdminCompany';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type AdminInsuranceCompany = {
  __typename?: 'AdminInsuranceCompany';
  aliases: Array<Scalars['String']['output']>;
  amBestNumber?: Maybe<Scalars['Int']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  deleted: Scalars['Boolean']['output'];
  duns?: Maybe<Scalars['String']['output']>;
  fein?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  level: Scalars['Int']['output'];
  naic?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  numberOfBrokers: Scalars['Int']['output'];
  numberOfMappedMappings: Scalars['Int']['output'];
  parentDeleted: Scalars['Boolean']['output'];
  parentId?: Maybe<Scalars['ID']['output']>;
  parentName?: Maybe<Scalars['String']['output']>;
  primaryRelationship: Scalars['String']['output'];
  primaryRole: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
  ultimateParentId?: Maybe<Scalars['ID']['output']>;
  ultimateParentName?: Maybe<Scalars['String']['output']>;
};

export type AdminProduct = {
  __typename?: 'AdminProduct';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type AdminProductExtended = {
  __typename?: 'AdminProductExtended';
  groups: Array<Scalars['String']['output']>;
  hideOnDecisions: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isFee: Scalars['Boolean']['output'];
  isOpportunity: Scalars['Boolean']['output'];
  isPackage: Scalars['Boolean']['output'];
  isRenewable: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type AgencyCode = {
  __typename?: 'AgencyCode';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type AgencyCodeCategory = {
  __typename?: 'AgencyCodeCategory';
  codes: Array<AgencyCode>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum AggAgencyStatus {
  Contracted = 'CONTRACTED',
  NonContracted = 'NON_CONTRACTED'
}

export enum AggClientStatus {
  New = 'NEW',
  Retained = 'RETAINED'
}

/** Policy and Policy Group Status. Details here: https://www.notion.so/ennabl/Policy-Client-Statuses-e2ccfd19b9bc475a9a296f7018c51cd9 */
export enum AggPolicyStatus {
  ClientLost = 'CLIENT_LOST',
  LostCancelled = 'LOST_CANCELLED',
  LostLost = 'LOST_LOST',
  LostNonRenewable = 'LOST_NON_RENEWABLE',
  LostTotal = 'LOST_TOTAL',
  NewCrossSell = 'NEW_CROSS_SELL',
  NewNew = 'NEW_NEW',
  NewTotal = 'NEW_TOTAL',
  Other = 'OTHER',
  RenewalRenewal = 'RENEWAL_RENEWAL',
  RenewalRewrite = 'RENEWAL_REWRITE',
  RenewalTotal = 'RENEWAL_TOTAL'
}

export type AggregateByEntity = {
  /** Additional entity-specific columns (e.g., parent name, segment) */
  additionalColumns?: InputMaybe<Array<EntityColumnConfig>>;
  /** Entity to aggregate by */
  entity: AggregationEntity;
  /** Custom header for entity name column */
  header?: InputMaybe<Scalars['String']['input']>;
};

export type AggregateByInput = {
  /** Primary entity to aggregate by (required) */
  primary: AggregateByEntity;
  /** Optional secondary entity for two-level aggregation */
  secondary?: InputMaybe<AggregateByEntity>;
};

export type AggregateMonolineOpportunity = {
  __typename?: 'AggregateMonolineOpportunity';
  byMonthV2: Array<OpportunityAggregationByMonth>;
  byProducerV2: Array<OpportunityAggregationByProducer>;
};


export type AggregateMonolineOpportunityByMonthV2Args = {
  currentTime?: InputMaybe<Scalars['Timestamp']['input']>;
  filter?: InputMaybe<PolicyFilter>;
};


export type AggregateMonolineOpportunityByProducerV2Args = {
  currentTime?: InputMaybe<Scalars['Timestamp']['input']>;
  filter?: InputMaybe<PolicyFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type AggregateWinBackOpportunity = {
  __typename?: 'AggregateWinBackOpportunity';
  byClientV2: Array<WinBackOpportunityAggregationByClient>;
};


export type AggregateWinBackOpportunityByClientV2Args = {
  currentTime?: InputMaybe<Scalars['Timestamp']['input']>;
  filter?: InputMaybe<PolicyFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type AggregatedColumnConfig = {
  /** Custom header override */
  header?: InputMaybe<Scalars['String']['input']>;
  /** Metric column key (including growth columns) */
  key: AggregatedReportColumn;
};

export type AggregatedPolicy = {
  __typename?: 'AggregatedPolicy';
  byAccountManager: Array<AggregatedPolicyByAccountManager>;
  byAccountSize: Array<AggregatedPolicyByAccountSize>;
  byAgencyStatus: Array<AggregatedPolicyByAgencyStatus>;
  byCarrier: Array<AggregatedPolicyByCarrier>;
  /** @deprecated AM Best data is no longer maintained (data provider contract ended). */
  byCarrierRating: Array<AggregatedPolicyByCarrierRating>;
  byClient: Array<AggregatedPolicyByClient>;
  byClientStatus: Array<AggregatedPolicyByClientStatus>;
  byCommissionPctBand: Array<AggregatedPolicyByCommissionPctBand>;
  byCounty: Array<AggregatedPolicyByCounty>;
  byDataIssues: Array<AggregatedPolicyByDataIssues>;
  byDepartment: Array<AggregatedPolicyByDepartment>;
  byDirect: Array<AggregatedPolicyByDirect>;
  /** aggregates by policy expiration date. Makes more sense with InclusionDateType.EXPIRATION */
  byExpirationMonth: Array<AggregatedPolicyByMonth>;
  /** aggregates by policy start date. Makes more sense with InclusionDateType.INCEPTION */
  byInceptionMonth: Array<AggregatedPolicyByMonth>;
  byIndustry: Array<AggregatedPolicyByIndustry>;
  byIntermediary: Array<AggregatedPolicyByIntermediary>;
  byIssuingPaper: Array<AggregatedPolicyByCarrier>;
  byLeafDepartment: Array<AggregatedPolicyByDepartment>;
  byPayTo: Array<AggregatedPolicyByCarrier>;
  byPolicyStatus: Array<AggregatedPolicyByPolicyStatus>;
  byPremiumAccountSize: Array<AggregatedPolicyByAccountSize>;
  byProducer: Array<AggregatedPolicyByProducer>;
  byProducerWithMissing: Array<AggregatedPolicyByProducerWithMissing>;
  byProduct: Array<AggregatedPolicyByProduct>;
  byRetailAgency: Array<AggregatedPolicyByAgency>;
  /** by State/Region of a Retail Agency for MGA */
  byRetailAgencyState: Array<AggregatedPolicyByState>;
  byRetailerSpecialists: Array<AggregatedPolicyByUser>;
  bySourceAgencyStatus: Array<AggregatedPolicyBySourceAgencyStatus>;
  byState: Array<AggregatedPolicyByState>;
  /** aggregates by transaction date. Doesn't work for WRITTEN amounts. Makes more sense with with InclusionDateType.TRANSACTION */
  byTransactionMonth: Array<AggregatedPolicyByMonth>;
  byUserWithRole: Array<AggregatedPolicyByUser>;
  byUserWithRoleWithMissing: Array<AggregatedPolicyByUserWithMissing>;
  growth: Growth;
  metric: Scalars['Float']['output'];
};


export type AggregatedPolicyByAccountManagerArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<PolicyMetric>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type AggregatedPolicyByAgencyStatusArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<PolicyMetric>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type AggregatedPolicyByCarrierArgs = {
  level?: InputMaybe<CarrierLevel>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<PolicyMetric>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type AggregatedPolicyByClientArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<PolicyMetric>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type AggregatedPolicyByCommissionPctBandArgs = {
  from?: InputMaybe<Scalars['Float']['input']>;
  includeLowerBound?: InputMaybe<Scalars['Boolean']['input']>;
  includeUpperBound?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<PolicyMetric>;
  sortOrder?: InputMaybe<SortOrder>;
  step?: InputMaybe<Scalars['Float']['input']>;
  to?: InputMaybe<Scalars['Float']['input']>;
};


export type AggregatedPolicyByCountyArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<PolicyMetric>;
  sortOrder?: InputMaybe<SortOrder>;
  withMissing?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AggregatedPolicyByDataIssuesArgs = {
  dataIssuesGroups?: InputMaybe<Array<PolicyDataIssuesGroup>>;
};


export type AggregatedPolicyByDepartmentArgs = {
  parentDepartmentId?: InputMaybe<Scalars['String']['input']>;
};


export type AggregatedPolicyByDirectArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<PolicyMetric>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type AggregatedPolicyByExpirationMonthArgs = {
  from?: InputMaybe<Scalars['Timestamp']['input']>;
  to?: InputMaybe<Scalars['Timestamp']['input']>;
};


export type AggregatedPolicyByIndustryArgs = {
  level?: InputMaybe<IndustryLevel>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<PolicyMetric>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type AggregatedPolicyByIntermediaryArgs = {
  level?: InputMaybe<IntermediaryLevel>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<PolicyMetric>;
  sortOrder?: InputMaybe<SortOrder>;
  withMissing?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AggregatedPolicyByIssuingPaperArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<PolicyMetric>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type AggregatedPolicyByLeafDepartmentArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<PolicyMetric>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type AggregatedPolicyByPayToArgs = {
  level?: InputMaybe<PayToLevel>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<PolicyMetric>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type AggregatedPolicyByPolicyStatusArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<PolicyMetric>;
  sortOrder?: InputMaybe<SortOrder>;
  statuses: Array<AggPolicyStatus>;
};


export type AggregatedPolicyByProducerArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<PolicyMetric>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type AggregatedPolicyByProducerWithMissingArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<PolicyMetric>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type AggregatedPolicyByProductArgs = {
  level?: InputMaybe<ProductLevel>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<PolicyMetric>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type AggregatedPolicyByRetailAgencyArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<PolicyMetric>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type AggregatedPolicyByRetailAgencyStateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<PolicyMetric>;
  sortOrder?: InputMaybe<SortOrder>;
  withMissing?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AggregatedPolicyByRetailerSpecialistsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<PolicyMetric>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type AggregatedPolicyBySourceAgencyStatusArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<PolicyMetric>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type AggregatedPolicyByStateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<PolicyMetric>;
  sortOrder?: InputMaybe<SortOrder>;
  withMissing?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AggregatedPolicyByUserWithRoleArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  role: UserAmsRole;
  sortBy?: InputMaybe<PolicyMetric>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type AggregatedPolicyByUserWithRoleWithMissingArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  role: UserAmsRole;
  sortBy?: InputMaybe<PolicyMetric>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type AggregatedPolicyGrowthArgs = {
  metric: PolicyMetric;
};


export type AggregatedPolicyMetricArgs = {
  metric: PolicyMetric;
};

export type AggregatedPolicyByAccountManager = {
  __typename?: 'AggregatedPolicyByAccountManager';
  accountManager: User;
  agg: AggregatedPolicy;
};

export type AggregatedPolicyByAccountSize = {
  __typename?: 'AggregatedPolicyByAccountSize';
  accountSize?: Maybe<Band>;
  agg: AggregatedPolicy;
};

export type AggregatedPolicyByAgency = {
  __typename?: 'AggregatedPolicyByAgency';
  agency: Market;
  agg: AggregatedPolicy;
};

export type AggregatedPolicyByAgencyStatus = {
  __typename?: 'AggregatedPolicyByAgencyStatus';
  agg: AggregatedPolicy;
  status: AggAgencyStatus;
};

export type AggregatedPolicyByCarrier = {
  __typename?: 'AggregatedPolicyByCarrier';
  agg: AggregatedPolicy;
  carrier: Market;
};

export type AggregatedPolicyByCarrierRating = {
  __typename?: 'AggregatedPolicyByCarrierRating';
  agg: AggregatedPolicy;
  rating: Rating;
};

export type AggregatedPolicyByClient = {
  __typename?: 'AggregatedPolicyByClient';
  agg: AggregatedPolicy;
  client: Client;
  /** @deprecated Sums per-policy premium at query time and is access-scoped, so it can differ from the client-wide premium size. */
  premiumBand?: Maybe<Band>;
  /** @deprecated Sums per-policy revenue at query time and is access-scoped, so it can differ from the client-wide account size. Use Client.inForceData.revenueBand instead. */
  revenueBand?: Maybe<Band>;
};

/** Aggregated policy by status. Details here: https://www.notion.so/ennabl/Policy-Client-Statuses-e2ccfd19b9bc475a9a296f7018c51cd9 */
export type AggregatedPolicyByClientStatus = {
  __typename?: 'AggregatedPolicyByClientStatus';
  agg: AggregatedPolicy;
  status: AggClientStatus;
};

export type AggregatedPolicyByCommissionPctBand = {
  __typename?: 'AggregatedPolicyByCommissionPctBand';
  agg: AggregatedPolicy;
  commissionPctBand: CommissionPctBand;
};

export type AggregatedPolicyByCounty = {
  __typename?: 'AggregatedPolicyByCounty';
  agg: AggregatedPolicy;
  county?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type AggregatedPolicyByDataIssues = {
  __typename?: 'AggregatedPolicyByDataIssues';
  agg: AggregatedPolicy;
  group: DataIssuesGroupOutput;
};

export type AggregatedPolicyByDepartment = {
  __typename?: 'AggregatedPolicyByDepartment';
  agg: AggregatedPolicy;
  department: Department;
};

export type AggregatedPolicyByDirect = {
  __typename?: 'AggregatedPolicyByDirect';
  agg: AggregatedPolicy;
  isDirect: Scalars['Boolean']['output'];
};

export type AggregatedPolicyByIndustry = {
  __typename?: 'AggregatedPolicyByIndustry';
  agg: AggregatedPolicy;
  industry: Industry;
};

export type AggregatedPolicyByIntermediary = {
  __typename?: 'AggregatedPolicyByIntermediary';
  agg: AggregatedPolicy;
  intermediary?: Maybe<Market>;
};

export type AggregatedPolicyByMonth = {
  __typename?: 'AggregatedPolicyByMonth';
  agg: AggregatedPolicy;
  month: Month;
};

/** Aggregated policy by status. Details here: https://www.notion.so/ennabl/Policy-Client-Statuses-e2ccfd19b9bc475a9a296f7018c51cd9 */
export type AggregatedPolicyByPolicyStatus = {
  __typename?: 'AggregatedPolicyByPolicyStatus';
  agg: AggregatedPolicy;
  status: AggPolicyStatus;
};

export type AggregatedPolicyByProducer = {
  __typename?: 'AggregatedPolicyByProducer';
  agg: AggregatedPolicy;
  producer: User;
};

export type AggregatedPolicyByProducerWithMissing = {
  __typename?: 'AggregatedPolicyByProducerWithMissing';
  agg: AggregatedPolicy;
  producer?: Maybe<User>;
};

export type AggregatedPolicyByProduct = {
  __typename?: 'AggregatedPolicyByProduct';
  agg: AggregatedPolicy;
  product: Product;
};

export type AggregatedPolicyBySourceAgencyStatus = {
  __typename?: 'AggregatedPolicyBySourceAgencyStatus';
  agg: AggregatedPolicy;
  status: Scalars['String']['output'];
};

export type AggregatedPolicyByState = {
  __typename?: 'AggregatedPolicyByState';
  agg: AggregatedPolicy;
  state?: Maybe<Scalars['String']['output']>;
};

export type AggregatedPolicyByUser = {
  __typename?: 'AggregatedPolicyByUser';
  agg: AggregatedPolicy;
  user: User;
};

export type AggregatedPolicyByUserWithMissing = {
  __typename?: 'AggregatedPolicyByUserWithMissing';
  agg: AggregatedPolicy;
  /** null for no-value */
  user?: Maybe<User>;
};

export enum AggregatedReportColumn {
  Clients = 'CLIENTS',
  ClientGrowth = 'CLIENT_GROWTH',
  Industries = 'INDUSTRIES',
  Lines = 'LINES',
  MgaRevenue = 'MGA_REVENUE',
  MgaRevenueGrowth = 'MGA_REVENUE_GROWTH',
  Policies = 'POLICIES',
  PolicyGrowth = 'POLICY_GROWTH',
  Premium = 'PREMIUM',
  PremiumGrowth = 'PREMIUM_GROWTH',
  Producers = 'PRODUCERS',
  Products = 'PRODUCTS',
  Retailers = 'RETAILERS',
  RetailerGrowth = 'RETAILER_GROWTH',
  Revenue = 'REVENUE',
  RevenueGrowth = 'REVENUE_GROWTH'
}

export enum AggregationEntity {
  AccountExecutive = 'ACCOUNT_EXECUTIVE',
  AccountManager = 'ACCOUNT_MANAGER',
  Department = 'DEPARTMENT',
  Industry = 'INDUSTRY',
  IssuingPaper = 'ISSUING_PAPER',
  ParentCarrier = 'PARENT_CARRIER',
  Producer = 'PRODUCER',
  Product = 'PRODUCT',
  Retailer = 'RETAILER',
  RetailerSpecialist = 'RETAILER_SPECIALIST',
  UltimateCarrier = 'ULTIMATE_CARRIER'
}

export type Amount = {
  __typename?: 'Amount';
  commission: Scalars['Float']['output'];
  commissionPct?: Maybe<Scalars['Float']['output']>;
  fee: Scalars['Float']['output'];
  mgaCommission?: Maybe<Scalars['Float']['output']>;
  mgaCommissionPct?: Maybe<Scalars['Float']['output']>;
  mgaRevenue?: Maybe<Scalars['Float']['output']>;
  premium: Scalars['Float']['output'];
  revenue: Scalars['Float']['output'];
};

export enum AmsPolicyStatus {
  Lost = 'LOST',
  New = 'NEW',
  Other = 'OTHER',
  Renewal = 'RENEWAL',
  Rewrite = 'REWRITE'
}

export type AmsPolicyStatusWithCodes = {
  __typename?: 'AmsPolicyStatusWithCodes';
  aggStatus: AggPolicyStatus;
  amsStatuses: Array<AmsPolicyStatus>;
  codes: Array<Scalars['String']['output']>;
};

export enum AmsType {
  Ams360 = 'AMS360',
  Ams360Mar = 'AMS360_MAR',
  Custom = 'CUSTOM',
  Epic = 'EPIC',
  Ezlynx = 'EZLYNX',
  Hawksoft = 'HAWKSOFT'
}

export type AppPermission = {
  __typename?: 'AppPermission';
  description: Scalars['String']['output'];
  id: AppPermissionId;
  isAdmin: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export enum AppPermissionId {
  /** @deprecated Use AppUserPermission in user management V2 */
  CrosscheckDevRealData = 'CROSSCHECK_DEV_REAL_DATA',
  /** @deprecated Use AppUserPermission in user management V2 */
  EditCommand = 'EDIT_COMMAND',
  /** @deprecated Use AppUserPermission in user management V2 */
  ExportDecisions = 'EXPORT_DECISIONS',
  /** @deprecated Use AppUserPermission in user management V2 */
  OnlyDocuments = 'ONLY_DOCUMENTS',
  /** @deprecated Use AppUserPermission in user management V2 */
  OnlyReportStudio = 'ONLY_REPORT_STUDIO',
  /** @deprecated Use AppUserPermission in user management V2 */
  ViewDecisions = 'VIEW_DECISIONS',
  /** @deprecated Use AppUserPermission in user management V2 */
  WorkflowsWriteBackPushToAms = 'WORKFLOWS__WRITE_BACK__PUSH_TO_AMS'
}

export enum AppUserPermission {
  DecisionsAccountExecutives = 'DECISIONS__ACCOUNT_EXECUTIVES',
  DecisionsAccountManagers = 'DECISIONS__ACCOUNT_MANAGERS',
  DecisionsActivities = 'DECISIONS__ACTIVITIES',
  DecisionsCarrierAppetite = 'DECISIONS__CARRIER_APPETITE',
  DecisionsExport = 'DECISIONS__EXPORT',
  DecisionsGeneral = 'DECISIONS__GENERAL',
  DecisionsHomePageDashboards = 'DECISIONS__HOME_PAGE_DASHBOARDS',
  DecisionsKpis = 'DECISIONS__KPIS',
  DecisionsMonolineRatios = 'DECISIONS__MONOLINE_RATIOS',
  DecisionsO360 = 'DECISIONS__O360',
  DecisionsRenewals = 'DECISIONS__RENEWALS',
  DecisionsReportStudio = 'DECISIONS__REPORT_STUDIO',
  DecisionsRetention = 'DECISIONS__RETENTION',
  EnnablAi = 'ENNABL_AI',
  EnnablData = 'ENNABL_DATA',
  Growth = 'GROWTH',
  GrowthGeneral = 'GROWTH__GENERAL',
  GrowthMyGoals = 'GROWTH__MY_GOALS',
  Mga = 'MGA',
  SourceDataManagement = 'SOURCE_DATA_MANAGEMENT',
  UserManagement = 'USER_MANAGEMENT',
  WorkflowsAcordPrefill = 'WORKFLOWS__ACORD_PREFILL',
  WorkflowsDocCompare = 'WORKFLOWS__DOC_COMPARE',
  WorkflowsDocLibrary = 'WORKFLOWS__DOC_LIBRARY',
  WorkflowsLegacyAmsDocuments = 'WORKFLOWS__LEGACY_AMS_DOCUMENTS',
  WorkflowsLossRuns = 'WORKFLOWS__LOSS_RUNS',
  WorkflowsProposalGeneration = 'WORKFLOWS__PROPOSAL_GENERATION',
  WorkflowsSoiGeneration = 'WORKFLOWS__SOI_GENERATION',
  WorkflowsSubmissionGeneration = 'WORKFLOWS__SUBMISSION_GENERATION',
  WorkflowsWriteBackPushToAms = 'WORKFLOWS__WRITE_BACK_PUSH_TO_AMS'
}

export type AppUserPermissionObject = {
  __typename?: 'AppUserPermissionObject';
  value: AppUserPermission;
};

export type AuthUser = {
  __typename?: 'AuthUser';
  email?: Maybe<Scalars['String']['output']>;
  ennablEmployeeId?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  /** The same as fullName */
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
};

export type AuthUsers = {
  __typename?: 'AuthUsers';
  list: Array<AuthUser>;
};

export type AverageAccountSizeWidgetParams = {
  __typename?: 'AverageAccountSizeWidgetParams';
  aggregateByPremium?: Maybe<Scalars['Boolean']['output']>;
  entity?: Maybe<WidgetEntity>;
  filter?: Maybe<PolicyFilterOutput>;
  radioValue?: Maybe<Scalars['String']['output']>;
  sortMetric?: Maybe<PolicyMetric>;
  tabKey?: Maybe<Scalars['String']['output']>;
  tabKeys?: Maybe<Array<Scalars['String']['output']>>;
  viewType: AverageAccountSizeWidgetViewType;
};

export type AverageAccountSizeWidgetParamsInput = {
  aggregateByPremium?: InputMaybe<Scalars['Boolean']['input']>;
  entity?: InputMaybe<WidgetEntity>;
  filter?: InputMaybe<PolicyFilter>;
  radioValue?: InputMaybe<Scalars['String']['input']>;
  sortMetric?: InputMaybe<PolicyMetric>;
  tabKey?: InputMaybe<Scalars['String']['input']>;
  tabKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  viewType: AverageAccountSizeWidgetViewType;
};

export enum AverageAccountSizeWidgetViewType {
  ByEntity = 'BY_ENTITY',
  ByProductSegment = 'BY_PRODUCT_SEGMENT'
}

export type AverageProductsPerClientWidgetParams = {
  __typename?: 'AverageProductsPerClientWidgetParams';
  entity: WidgetEntity;
  entityKeys?: Maybe<Array<WidgetEntity>>;
  filter?: Maybe<PolicyFilterOutput>;
  radioValue?: Maybe<Scalars['String']['output']>;
};

export type AverageProductsPerClientWidgetParamsInput = {
  entity: WidgetEntity;
  entityKeys?: InputMaybe<Array<WidgetEntity>>;
  filter?: InputMaybe<PolicyFilter>;
  radioValue?: InputMaybe<Scalars['String']['input']>;
};

export type Band = {
  __typename?: 'Band';
  id: Scalars['ID']['output'];
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  valueType: BandValueType;
};

export enum BandValueType {
  Premium = 'PREMIUM',
  Revenue = 'REVENUE',
  Sales = 'SALES'
}

export type Bands = {
  __typename?: 'Bands';
  premium: Array<Band>;
  revenue: Array<Band>;
  sales: Array<Band>;
};

export type BatchEnnablUsersDeleteInput = {
  userIds: Array<Scalars['ID']['input']>;
};

export type BatchEnnablUsersUpdateInput = {
  status: EnnablUserStatus;
  userIds: Array<Scalars['ID']['input']>;
};

export type BatchFilter = {
  accounts?: InputMaybe<Array<Scalars['String']['input']>>;
  carriers?: InputMaybe<Array<Scalars['String']['input']>>;
  claimType?: InputMaybe<ClaimType>;
  policyNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  products?: InputMaybe<Array<Scalars['String']['input']>>;
  severityThreshold?: InputMaybe<Scalars['Float']['input']>;
  sourceFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  years?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export enum BrokerMarketStatus {
  NonStrategic = 'NON_STRATEGIC',
  Other = 'OTHER',
  Strategic = 'STRATEGIC'
}

export type BrokerMarketStatusUpdateResult = {
  __typename?: 'BrokerMarketStatusUpdateResult';
  success: Scalars['Boolean']['output'];
};

export type CarrierAppetite = {
  __typename?: 'CarrierAppetite';
  departmentList: CarrierAppetiteDepartmentListResult;
  kpi: CarrierAppetiteKpi;
  table: CarrierAppetitePaginatedResult;
};


export type CarrierAppetiteDepartmentListArgs = {
  carrierLevel?: InputMaybe<CarrierLevel>;
  carrierSearch?: InputMaybe<Scalars['String']['input']>;
  departmentLevel?: InputMaybe<DepartmentLevel>;
};


export type CarrierAppetiteKpiArgs = {
  componentFilter: PolicyFilter;
  globalFilter: PolicyFilter;
  level?: InputMaybe<CarrierLevel>;
};


export type CarrierAppetiteTableArgs = {
  componentFilter: PolicyFilter;
  globalFilter: PolicyFilter;
  level?: InputMaybe<CarrierLevel>;
  pagination?: InputMaybe<CarrierAppetiteListPaginationInput>;
};

export type CarrierAppetiteDepartmentListResult = {
  __typename?: 'CarrierAppetiteDepartmentListResult';
  items: Array<CarrierAppetiteDepartmentRow>;
};

export type CarrierAppetiteDepartmentRow = {
  __typename?: 'CarrierAppetiteDepartmentRow';
  carrier: Market;
  department: Department;
  policyCount: Scalars['Int']['output'];
  premium: Scalars['Float']['output'];
  producers: Array<User>;
  revenue: Scalars['Float']['output'];
};

export type CarrierAppetiteFilter = {
  accountLocation?: InputMaybe<CarrierAppetiteLocationFilter>;
  /** Client revenue band in cents. Range must be wider or equal to $5000 */
  accountSize?: InputMaybe<Range>;
  industry?: InputMaybe<CarrierAppetiteIndustryFilter>;
  insuranceCompany?: InputMaybe<CarrierAppetiteInsuranceCompanyFilter>;
  product?: InputMaybe<CarrierAppetiteProductFilter>;
};

export type CarrierAppetiteIndustryFilter = {
  /**
   * 6-digit NAICS codes
   * @deprecated Use industryIds
   */
  industries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Generated (xx naics) throws error */
  industryGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * 2-digit NAICS codes
   * @deprecated Use industryGroupIds
   */
  industryGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Generated (xx naics) throws error */
  industryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Generated (xx naics) throws error */
  industrySubGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * 4-digit NAICS codes
   * @deprecated Use industrySubGroupIds
   */
  industrySubGroups?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CarrierAppetiteInsuranceCompanyFilter = {
  childIntermediaryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  issuingPaperIds?: InputMaybe<Array<Scalars['String']['input']>>;
  parentCarrierIds?: InputMaybe<Array<Scalars['String']['input']>>;
  parentIntermediaryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  ultimateCarrierIds?: InputMaybe<Array<Scalars['String']['input']>>;
  ultimateIntermediaryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated use ultimateCarrierIds */
  ultimateParentCarrierIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated use ultimateCarrierIds */
  ultimateParentIntermediaryIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CarrierAppetiteKpi = {
  __typename?: 'CarrierAppetiteKpi';
  carrierCount: Scalars['Float']['output'];
  directPolicies: Scalars['Float']['output'];
  directPremium: Scalars['Float']['output'];
  indirectPolicies: Scalars['Float']['output'];
  indirectPremium: Scalars['Float']['output'];
};

export type CarrierAppetiteListPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** sorting by status is not supported for global CA */
  sortBy?: InputMaybe<CarrierAppetiteSortingField>;
  /** Total count will be different if we use sorting by metric with permissions */
  sortOrder?: InputMaybe<SortOrder>;
};

export type CarrierAppetiteLocationFilter = {
  /** ${state}-${county}. case-insensitive. e.g. MD-Talbot */
  counties?: InputMaybe<Array<Scalars['String']['input']>>;
  postalCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  postalCodesRadius?: InputMaybe<LocationRadius>;
  /** ISO 3166-2 region code */
  states?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CarrierAppetitePaginatedResult = {
  __typename?: 'CarrierAppetitePaginatedResult';
  items: Array<CarrierAppetiteRow>;
  totalHits: Scalars['Int']['output'];
};

export type CarrierAppetiteProductFilter = {
  insuranceSegments?: InputMaybe<Array<Scalars['String']['input']>>;
  productIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CarrierAppetiteRow = {
  __typename?: 'CarrierAppetiteRow';
  carrier: Market;
  directCommission: OutputRange;
  directPolicies: Scalars['Float']['output'];
  indirectCommission: OutputRange;
  indirectPolicies: Scalars['Float']['output'];
  status: BrokerMarketStatus;
};

export enum CarrierAppetiteSortingField {
  DirectCommission = 'DIRECT_COMMISSION',
  DirectPolicies = 'DIRECT_POLICIES',
  IndirectCommission = 'INDIRECT_COMMISSION',
  IndirectPolicies = 'INDIRECT_POLICIES',
  Name = 'NAME',
  Status = 'STATUS'
}

export enum CarrierLevel {
  IssuingPaper = 'ISSUING_PAPER',
  ParentCarrier = 'PARENT_CARRIER',
  UltimateParentCarrier = 'ULTIMATE_PARENT_CARRIER'
}

export type CarrierPdfReportOptions = {
  placementAnalysis?: InputMaybe<PlacementAnalysisOptions>;
};

export type CarrierRank = {
  __typename?: 'CarrierRank';
  filter?: Maybe<Scalars['String']['output']>;
  metricType?: Maybe<Scalars['String']['output']>;
};

export type CarrierRankEdge = {
  __typename?: 'CarrierRankEdge';
  filter?: Maybe<Scalars['String']['output']>;
  metricType?: Maybe<Scalars['String']['output']>;
};

export enum CarrierSortingField {
  Commission = 'COMMISSION',
  Id = 'ID',
  Name = 'NAME',
  Premium = 'PREMIUM',
  Revenue = 'REVENUE'
}

export type ChangeDocumentFolderPayload = {
  __typename?: 'ChangeDocumentFolderPayload';
  success: Scalars['Boolean']['output'];
};

export enum ClaimType {
  Closed = 'CLOSED',
  Open = 'OPEN'
}

export type Client = {
  __typename?: 'Client';
  accountManagers: Array<User>;
  /** One of the clientNumbers */
  clientNumber?: Maybe<Scalars['String']['output']>;
  /** Account lookup codes from the source system */
  clientNumbers?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * Might work slowly. Do not use in list
   * @deprecated use contactsV2
   */
  contacts?: Maybe<Array<ClientContact>>;
  /** Might work slowly. Do not use in list */
  contactsV2?: Maybe<Array<Contact>>;
  dnbCompany?: Maybe<DnbCompany>;
  domesticUltimateDuns?: Maybe<Scalars['String']['output']>;
  domesticUltimateName?: Maybe<Scalars['String']['output']>;
  duns?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  employees?: Maybe<Scalars['Int']['output']>;
  fein?: Maybe<Scalars['String']['output']>;
  forms5500: Array<Form5500>;
  hasForms5500: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  inForceData: ClientInForceData;
  industry?: Maybe<Industry>;
  isAmsProspect: Scalars['Boolean']['output'];
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isMonoline: Scalars['Boolean']['output'];
  limitedAccess: Scalars['Boolean']['output'];
  marketCap?: Maybe<Scalars['Float']['output']>;
  /** Might work slowly. Do not use in list */
  marketContacts?: Maybe<Array<Contact>>;
  metrics?: Maybe<EntityMetrics>;
  /** @deprecated use industry.naics */
  naics?: Maybe<Scalars['String']['output']>;
  naicsSources?: Maybe<Array<ClientNaicsSource>>;
  name: Scalars['String']['output'];
  nextRenewal?: Maybe<Scalars['SimpleDate']['output']>;
  opportunityRecommendations?: Maybe<Array<OpportunityRecommendation>>;
  policies: Array<Policy>;
  policyAgg: AggregatedPolicy;
  primaryAddress?: Maybe<Address>;
  producers?: Maybe<Array<User>>;
  productAmount: Scalars['Int']['output'];
  products: Array<Product>;
  prospectFor: Array<AuthUser>;
  renewals: Array<RenewalsOpportunity>;
  /** Might work slowly. Do not use in list */
  rocketReachPerson?: Maybe<RocketReachPersonCached>;
  sales?: Maybe<Scalars['Float']['output']>;
  salesBand?: Maybe<Band>;
  savedOpportunity?: Maybe<SavedOpportunity>;
  /** @deprecated use sicCode */
  sic?: Maybe<Scalars['String']['output']>;
  sicCode?: Maybe<SicCode>;
  sources?: Maybe<Array<ClientSourceData>>;
  specialists?: Maybe<Array<Specialist>>;
  statistic: ClientStatistic;
  telephoneNumber?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ClientType>;
  url?: Maybe<Scalars['String']['output']>;
  winBackV2: Array<WinBackOpportunityV2>;
};


export type ClientOpportunityRecommendationsArgs = {
  producerId?: InputMaybe<Scalars['String']['input']>;
  withSaved?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ClientPolicyAggArgs = {
  filter?: InputMaybe<PolicyFilter>;
};


export type ClientRenewalsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  producerId?: InputMaybe<Scalars['String']['input']>;
};


export type ClientSavedOpportunityArgs = {
  producerId?: InputMaybe<Scalars['String']['input']>;
};


export type ClientWinBackV2Args = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  producerId?: InputMaybe<Scalars['String']['input']>;
};

export type ClientActivityFilter = {
  period?: InputMaybe<FromToPeriod>;
};

export type ClientContact = {
  __typename?: 'ClientContact';
  address?: Maybe<Address>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ClientFilter = {
  carrierIds?: InputMaybe<Array<Scalars['String']['input']>>;
  carrierName?: InputMaybe<Scalars['String']['input']>;
  clientType?: InputMaybe<ClientType>;
  companyNameOrForm5500PlanSponsor?: InputMaybe<Scalars['String']['input']>;
  form5500FilingYears?: InputMaybe<Array<Scalars['String']['input']>>;
  form5500Participants?: InputMaybe<FilterRange>;
  form5500PlanEffectiveDate?: InputMaybe<Array<DateRange>>;
  form5500PolicyExpirationDate?: InputMaybe<Array<DateRange>>;
  form5500SponsorSignedName?: InputMaybe<Scalars['String']['input']>;
  /** True - only forms with a broker, False - only forms without a broker, Not provided - both */
  form5500WithBroker?: InputMaybe<Scalars['Boolean']['input']>;
  /** True - with filled form 5500, False - without forms, Not provided - both */
  hasForm5500Data?: InputMaybe<Scalars['Boolean']['input']>;
  industryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  isMonoline?: InputMaybe<Scalars['Boolean']['input']>;
  numberOfEmployees?: InputMaybe<FilterRange>;
  region?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ClientInForceData = {
  __typename?: 'ClientInForceData';
  nextRenewal?: Maybe<Scalars['SimpleDate']['output']>;
  policyCount: Scalars['Float']['output'];
  premium?: Maybe<Scalars['Float']['output']>;
  productLines: Array<Product>;
  products: Array<Product>;
  revenue?: Maybe<Scalars['Float']['output']>;
  /** synonym of account size */
  revenueBand: Band;
};

export type ClientListPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<ClientSortingField>;
  /** Total count will be different if we use sorting by metric with permissions */
  sortOrder?: InputMaybe<SortOrder>;
};

export type ClientNaicsSource = {
  __typename?: 'ClientNaicsSource';
  industry?: Maybe<Industry>;
  isSelected: Scalars['Boolean']['output'];
  naics: Scalars['String']['output'];
  sourceName: Scalars['String']['output'];
};

export type ClientPaginatedResult = {
  __typename?: 'ClientPaginatedResult';
  items: Array<Client>;
  totalHits: Scalars['Int']['output'];
};

export type ClientRank = {
  __typename?: 'ClientRank';
  filter?: Maybe<Scalars['String']['output']>;
  metricType?: Maybe<Scalars['String']['output']>;
};

export type ClientRankEdge = {
  __typename?: 'ClientRankEdge';
  filter?: Maybe<Scalars['String']['output']>;
  metricType?: Maybe<Scalars['String']['output']>;
};

export type ClientSearchItemRequest = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  duns?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
};

export type ClientSearchItemResponse = {
  __typename?: 'ClientSearchItemResponse';
  client?: Maybe<Client>;
  /** Use some ID to map clients */
  requestId: Scalars['String']['output'];
};

export type ClientSearchRequest = {
  request: ClientSearchItemRequest;
  /** Use some ID to map clients */
  requestId: Scalars['String']['input'];
};

export enum ClientSortingField {
  Commission = 'COMMISSION',
  Employees = 'EMPLOYEES',
  Id = 'ID',
  MarketCap = 'MARKET_CAP',
  Name = 'NAME',
  Premium = 'PREMIUM',
  PrimaryAddress = 'PRIMARY_ADDRESS',
  Revenue = 'REVENUE',
  Sales = 'SALES'
}

export type ClientSourceData = {
  __typename?: 'ClientSourceData';
  sourceId: Scalars['String']['output'];
  sourceName?: Maybe<Scalars['String']['output']>;
  sourceNumber?: Maybe<Scalars['String']['output']>;
  systemId?: Maybe<Scalars['String']['output']>;
  systemName?: Maybe<Scalars['String']['output']>;
};

export type ClientStatistic = {
  __typename?: 'ClientStatistic';
  activePolicies: Scalars['Int']['output'];
  activeProducts: Scalars['Int']['output'];
  activeSegments: Array<Product>;
  clientLost?: Maybe<Scalars['SimpleDate']['output']>;
  clientSince?: Maybe<Scalars['SimpleDate']['output']>;
  lifetimePolicies: Scalars['Int']['output'];
  lifetimeRevenue: Scalars['Float']['output'];
  lostSegments: Array<Product>;
};

export enum ClientType {
  Company = 'COMPANY',
  Person = 'PERSON'
}

export type Clients = {
  __typename?: 'Clients';
  byIds: Array<Client>;
  /** @deprecated Use paginated instead */
  list: Array<Client>;
  paginated: ClientPaginatedResult;
};


export type ClientsByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type ClientsListArgs = {
  pagination?: InputMaybe<ClientListPaginationInput>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type ClientsPaginatedArgs = {
  filter?: InputMaybe<ClientFilter>;
  pagination?: InputMaybe<ClientListPaginationInput>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type CommandAdminProduct = {
  __typename?: 'CommandAdminProduct';
  group: Scalars['String']['output'];
  hideOnDecisions: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  insuranceSegment: Scalars['String']['output'];
  isFee: Scalars['Boolean']['output'];
  isOpportunity: Scalars['Boolean']['output'];
  isPackage: Scalars['Boolean']['output'];
  isRenewable: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  superGroup: Scalars['String']['output'];
};

export type CommandEnrichedProduct = {
  __typename?: 'CommandEnrichedProduct';
  adminProduct?: Maybe<CommandAdminProduct>;
  group?: Maybe<Scalars['String']['output']>;
  hideOnDecisions?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  insuranceSegment?: Maybe<Scalars['String']['output']>;
  isFee?: Maybe<Scalars['Boolean']['output']>;
  isOpportunity?: Maybe<Scalars['Boolean']['output']>;
  isPackage?: Maybe<Scalars['Boolean']['output']>;
  isRenewable?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  superGroup?: Maybe<Scalars['String']['output']>;
};

export type CommandProductMapping = {
  __typename?: 'CommandProductMapping';
  amsCode?: Maybe<Scalars['String']['output']>;
  amsInsuranceSegment?: Maybe<Scalars['String']['output']>;
  amsName: Scalars['String']['output'];
  enrichedProduct: CommandEnrichedProduct;
  externalSystemId: Scalars['ID']['output'];
  fullNumberOfPolicies: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  linkedWithAdminProduct: Scalars['Boolean']['output'];
  manualChangeInProgress: Scalars['Boolean']['output'];
};

export type CommissionBand = {
  __typename?: 'CommissionBand';
  max?: Maybe<Scalars['Percent']['output']>;
  metrics: CommissionsMetrics;
  min: Scalars['Percent']['output'];
};

export type CommissionPctBand = {
  __typename?: 'CommissionPctBand';
  id: Scalars['ID']['output'];
  max?: Maybe<Scalars['Float']['output']>;
  min: Scalars['Float']['output'];
};

export enum CommissionType {
  Mga = 'MGA',
  Total = 'TOTAL'
}

export type CommissionsByDepartment = {
  __typename?: 'CommissionsByDepartment';
  bands: Array<CommissionBand>;
  department: Department;
  metrics: CommissionsMetrics;
};

export type CommissionsByIndustry = {
  __typename?: 'CommissionsByIndustry';
  bands: Array<CommissionBand>;
  industry: Industry;
  metrics: CommissionsMetrics;
};

export type CommissionsByMarket = {
  __typename?: 'CommissionsByMarket';
  bands: Array<CommissionBand>;
  market: Market;
  metrics: CommissionsMetrics;
};

export type CommissionsByProduct = {
  __typename?: 'CommissionsByProduct';
  bands: Array<CommissionBand>;
  metrics: CommissionsMetrics;
  product: Product;
};

export type CommissionsByUser = {
  __typename?: 'CommissionsByUser';
  bands: Array<CommissionBand>;
  metrics: CommissionsMetrics;
  user?: Maybe<User>;
};

export type CommissionsDistribution = {
  __typename?: 'CommissionsDistribution';
  avgCommissionPct?: Maybe<Scalars['Float']['output']>;
  byCarrier: Array<CommissionsByMarket>;
  byDepartment: Array<CommissionsByDepartment>;
  byIndustry: Array<CommissionsByIndustry>;
  byIntermediary: Array<CommissionsByMarket>;
  byPayTo: Array<CommissionsByMarket>;
  byProducer: Array<CommissionsByUser>;
  byProduct: Array<CommissionsByProduct>;
  byRetailAgency: Array<CommissionsByMarket>;
};


export type CommissionsDistributionByCarrierArgs = {
  level?: InputMaybe<CarrierLevel>;
  params?: InputMaybe<CommissionsParams>;
};


export type CommissionsDistributionByDepartmentArgs = {
  params?: InputMaybe<CommissionsParams>;
};


export type CommissionsDistributionByIndustryArgs = {
  level?: InputMaybe<IndustryLevel>;
  params?: InputMaybe<CommissionsParams>;
};


export type CommissionsDistributionByIntermediaryArgs = {
  level?: InputMaybe<IntermediaryLevel>;
  params?: InputMaybe<CommissionsParams>;
};


export type CommissionsDistributionByPayToArgs = {
  level?: InputMaybe<PayToLevel>;
  params?: InputMaybe<CommissionsParams>;
};


export type CommissionsDistributionByProducerArgs = {
  params?: InputMaybe<CommissionsParams>;
};


export type CommissionsDistributionByProductArgs = {
  params?: InputMaybe<CommissionsParams>;
};


export type CommissionsDistributionByRetailAgencyArgs = {
  params?: InputMaybe<CommissionsParams>;
};

export type CommissionsMetrics = {
  __typename?: 'CommissionsMetrics';
  commissionPctAvg: Scalars['Percent']['output'];
  policyCount: Scalars['Float']['output'];
  premiumSum: Scalars['MoneyCents']['output'];
  revenueSum: Scalars['MoneyCents']['output'];
};

export type CommissionsParams = {
  /** Band start, default 0 */
  bandFrom?: InputMaybe<Scalars['Percent']['input']>;
  /** Band step, default 1% */
  bandStep?: InputMaybe<Scalars['Percent']['input']>;
  /** Band end, default 20% */
  bandTo?: InputMaybe<Scalars['Percent']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<CommissionsSortBy>;
  sortOrder?: InputMaybe<SortOrder>;
};

export enum CommissionsSortBy {
  CommissionPctAvg = 'COMMISSION_PCT_AVG',
  PolicyCount = 'POLICY_COUNT',
  PremiumSum = 'PREMIUM_SUM',
  RevenueSum = 'REVENUE_SUM'
}

export type CommissionsWidgetParams = {
  __typename?: 'CommissionsWidgetParams';
  carrierLevel?: Maybe<CarrierLevel>;
  filter?: Maybe<PolicyFilterOutput>;
  radioValue?: Maybe<Scalars['String']['output']>;
  selectedEntityId?: Maybe<Scalars['String']['output']>;
  tabEntity: WidgetEntity;
  tabEntityKeys?: Maybe<Array<WidgetEntity>>;
  tableEntity?: Maybe<WidgetEntity>;
  withEntitiesTable?: Maybe<Scalars['Boolean']['output']>;
};

export type CommissionsWidgetParamsInput = {
  carrierLevel?: InputMaybe<CarrierLevel>;
  filter?: InputMaybe<PolicyFilter>;
  radioValue?: InputMaybe<Scalars['String']['input']>;
  selectedEntityId?: InputMaybe<Scalars['String']['input']>;
  tabEntity: WidgetEntity;
  tabEntityKeys?: InputMaybe<Array<WidgetEntity>>;
  tableEntity?: InputMaybe<WidgetEntity>;
  withEntitiesTable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CompanyConditions = {
  /** elements of this array will be joined using OR clause */
  orConditions: Array<CompanyIdsFilter>;
};

export type CompanyConditionsOutput = {
  __typename?: 'CompanyConditionsOutput';
  /** elements of this array will be joined using OR clause */
  orConditions: Array<CompanyIdsFilterOutput>;
};

export enum CompanyFilterType {
  Carrier = 'CARRIER',
  Intermediary = 'INTERMEDIARY',
  PayTo = 'PAY_TO'
}

export type CompanyFilters = {
  /** elements of this array will be joined using AND clause */
  andConditions: Array<CompanyConditions>;
};

export type CompanyFiltersOutput = {
  __typename?: 'CompanyFiltersOutput';
  /** elements of this array will be joined using AND clause */
  andConditions: Array<CompanyConditionsOutput>;
};

/** Companies inside one CompanyFilter are filtered using OR logic. */
export type CompanyIdsFilter = {
  anyLevelIds?: InputMaybe<Array<Scalars['String']['input']>>;
  childIds?: InputMaybe<Array<Scalars['String']['input']>>;
  filterType: CompanyFilterType;
  parentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  ultimateParentIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CompanyIdsFilterOutput = {
  __typename?: 'CompanyIdsFilterOutput';
  anyLevelIds?: Maybe<Array<Scalars['String']['output']>>;
  childIds?: Maybe<Array<Scalars['String']['output']>>;
  filterType: CompanyFilterType;
  parentIds?: Maybe<Array<Scalars['String']['output']>>;
  ultimateParentIds?: Maybe<Array<Scalars['String']['output']>>;
};

export enum CompanyPrimaryRole {
  Carrier = 'CARRIER',
  Intermediary = 'INTERMEDIARY'
}

export type CompanyRating = {
  __typename?: 'CompanyRating';
  /** @deprecated AM Best data is no longer maintained (data provider contract ended). */
  financialSizeCategory?: Maybe<Scalars['Int']['output']>;
  /** @deprecated AM Best data is no longer maintained (data provider contract ended). */
  ratingLastDate?: Maybe<Scalars['Timestamp']['output']>;
  /** @deprecated AM Best data is no longer maintained (data provider contract ended). */
  title: Scalars['String']['output'];
};

export enum CompanyViewType {
  Intermediary = 'INTERMEDIARY',
  IssuingPaper = 'ISSUING_PAPER',
  ParentCarrier = 'PARENT_CARRIER',
  ParentIntermediary = 'PARENT_INTERMEDIARY',
  UltimateParentCarrier = 'ULTIMATE_PARENT_CARRIER',
  UltimateParentIntermediary = 'ULTIMATE_PARENT_INTERMEDIARY'
}

export type Contact = {
  __typename?: 'Contact';
  addresses?: Maybe<Array<ContactAddress>>;
  client?: Maybe<Client>;
  description?: Maybe<Scalars['String']['output']>;
  emails?: Maybe<Array<ContactEmail>>;
  id: Scalars['ID']['output'];
  market?: Maybe<Market>;
  name?: Maybe<Scalars['String']['output']>;
  phones?: Maybe<Array<ContactPhone>>;
  urls?: Maybe<Array<ContactUrls>>;
};

export type ContactAddress = {
  __typename?: 'ContactAddress';
  type: ContactType;
  value: Address;
};

export type ContactEmail = {
  __typename?: 'ContactEmail';
  type: ContactType;
  value: Scalars['String']['output'];
};

export type ContactPaginatedResult = {
  __typename?: 'ContactPaginatedResult';
  items: Array<Contact>;
  totalHits: Scalars['Int']['output'];
};

export type ContactPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy: ContactSortingField;
  /** Total count will be different if we use sorting by metric with permissions */
  sortOrder?: InputMaybe<SortOrder>;
};

export type ContactPhone = {
  __typename?: 'ContactPhone';
  type: ContactType;
  value: Scalars['String']['output'];
};

export enum ContactSortingField {
  Country = 'COUNTRY',
  County = 'COUNTY',
  Email = 'EMAIL',
  Locality = 'LOCALITY',
  Name = 'NAME',
  Phone = 'PHONE',
  Region = 'REGION',
  Url = 'URL'
}

export enum ContactType {
  Other = 'OTHER',
  Primary = 'PRIMARY'
}

export type ContactUrls = {
  __typename?: 'ContactUrls';
  type: ContactType;
  value: Scalars['String']['output'];
};

export type Contacts = {
  __typename?: 'Contacts';
  contact?: Maybe<Contact>;
  paginated: ContactPaginatedResult;
};


export type ContactsContactArgs = {
  id: Scalars['ID']['input'];
};


export type ContactsPaginatedArgs = {
  pagination?: InputMaybe<ContactPaginationInput>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCompanyProspectPayload = {
  __typename?: 'CreateCompanyProspectPayload';
  created: Prospect;
};

export type CreateDolCompanyProspectPayload = {
  __typename?: 'CreateDolCompanyProspectPayload';
  created: Prospect;
};

export type CreateIndividualProspectPayload = {
  __typename?: 'CreateIndividualProspectPayload';
  created: Prospect;
};

export type CreateUserReportPresetPayload = {
  __typename?: 'CreateUserReportPresetPayload';
  created: UserReportPreset;
};

export type CrossSellFilter = {
  __typename?: 'CrossSellFilter';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type CrossSellGeneratorFilter = {
  accountManagerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  carrierIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Any level */
  companyIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** IDs from producerPortal.crossSellFilters */
  crossSellFilterIds?: InputMaybe<Array<Scalars['String']['input']>>;
  departmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  employeesRange?: InputMaybe<FilterRange>;
  expirationDate?: InputMaybe<DateRange>;
  /** @deprecated Use expirationDate instead */
  expirationDateRange?: InputMaybe<FilterRange>;
  industryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  isMonoline?: InputMaybe<Scalars['Boolean']['input']>;
  issuingPaperIds?: InputMaybe<Array<Scalars['String']['input']>>;
  producerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Either productBoughtIds or productNotBoughtIds must include at least one product ID */
  productBoughtIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Either productBoughtIds or productNotBoughtIds must include at least one product ID */
  productNotBoughtIds?: InputMaybe<Array<Scalars['String']['input']>>;
  riskLocations?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Cents */
  salesSizeRange?: InputMaybe<FilterRange>;
};

export enum CrossSellGeneratorSoringFields {
  ClientEmail = 'CLIENT_EMAIL',
  ClientName = 'CLIENT_NAME',
  ClientPhone = 'CLIENT_PHONE',
  Country = 'COUNTRY',
  County = 'COUNTY',
  Industry = 'INDUSTRY',
  Locality = 'LOCALITY',
  Naics = 'NAICS',
  NextRenewal = 'NEXT_RENEWAL',
  Producer = 'PRODUCER',
  ProductAmount = 'PRODUCT_AMOUNT',
  Region = 'REGION',
  Revenue_12Months = 'REVENUE_12_MONTHS',
  RevenueInForce = 'REVENUE_IN_FORCE',
  Sales = 'SALES'
}

export type CrossSellOpportunityRecommendation = {
  __typename?: 'CrossSellOpportunityRecommendation';
  client: Client;
  id: Scalars['ID']['output'];
  recommendations: Array<OpportunityRecommendation>;
};

export type CrossSellOpportunityRecommendationPaginatedResult = {
  __typename?: 'CrossSellOpportunityRecommendationPaginatedResult';
  items: Array<CrossSellOpportunityRecommendation>;
  totalHits: Scalars['Int']['output'];
};

export type CrossSellOpportunityRecommendationPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<CrossSellOpportunityRecommendationSortingField>;
  /** Total count will be different if we use sorting by metric with permissions */
  sortOrder?: InputMaybe<SortOrder>;
};

export enum CrossSellOpportunityRecommendationSortingField {
  ClientName = 'CLIENT_NAME',
  NextRenewal = 'NEXT_RENEWAL',
  Rate = 'RATE'
}

export type CrossSellPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<CrossSellGeneratorSoringFields>;
  /** Total count will be different if we use sorting by metric with permissions */
  sortOrder?: InputMaybe<SortOrder>;
};

export type CrossSellReportCriteria = {
  __typename?: 'CrossSellReportCriteria';
  accountManagerIds?: Maybe<Array<Scalars['String']['output']>>;
  carrierIds?: Maybe<Array<Scalars['String']['output']>>;
  carriers?: Maybe<Array<Market>>;
  /** Any level */
  companyIds?: Maybe<Array<Scalars['String']['output']>>;
  /** IDs from producerPortal.crossSellFilters */
  crossSellFilterIds?: Maybe<Array<Scalars['String']['output']>>;
  departmentIds?: Maybe<Array<Scalars['String']['output']>>;
  employeesRange?: Maybe<FilterRangeOutput>;
  expirationDate?: Maybe<DateRangeOutput>;
  /** @deprecated Use expirationDate instead */
  expirationDateRange?: Maybe<FilterRangeOutput>;
  /** Could be null if mapping was changed */
  industries?: Maybe<Array<Maybe<Industry>>>;
  industryIds?: Maybe<Array<Scalars['String']['output']>>;
  isMonoline?: Maybe<Scalars['Boolean']['output']>;
  issuingPaperIds?: Maybe<Array<Scalars['String']['output']>>;
  issuingPapers?: Maybe<Array<Market>>;
  producerIds?: Maybe<Array<Scalars['String']['output']>>;
  /** Either productBoughtIds or productNotBoughtIds must include at least one product ID */
  productBoughtIds?: Maybe<Array<Scalars['String']['output']>>;
  /** Either productBoughtIds or productNotBoughtIds must include at least one product ID */
  productNotBoughtIds?: Maybe<Array<Scalars['String']['output']>>;
  /** Could be null if mapping was changed */
  productsBought?: Maybe<Array<Maybe<Product>>>;
  /** Could be null if mapping was changed */
  productsNotBought?: Maybe<Array<Maybe<Product>>>;
  riskLocations?: Maybe<Array<Scalars['String']['output']>>;
  /** Cents */
  salesSizeRange?: Maybe<FilterRangeOutput>;
};

export type CustomAggregatedPreviewParams = {
  filters: Array<CustomReportingFilter>;
  rows: Array<CustomReportingRowInput>;
  tableId: Scalars['String']['input'];
  values: Array<CustomReportingValueInput>;
};

export type CustomAggregatedPreviewParamsOutput = {
  __typename?: 'CustomAggregatedPreviewParamsOutput';
  filters: Array<CustomReportingFilterOutput>;
  rows: Array<CustomReportingRow>;
  tableId: Scalars['String']['output'];
  values: Array<CustomReportingValue>;
};

export type CustomPlainPreviewParams = {
  columns: Array<CustomReportingPlainColumnInput>;
  filters: Array<CustomReportingFilter>;
  tableId: Scalars['String']['input'];
};

export type CustomPlainPreviewParamsOutput = {
  __typename?: 'CustomPlainPreviewParamsOutput';
  columns: Array<CustomReportingPlainColumn>;
  filters: Array<CustomReportingFilterOutput>;
  tableId: Scalars['String']['output'];
};

export type CustomQueryPreviewParams = {
  query: Scalars['String']['input'];
};

export type CustomQueryPreviewParamsOutput = {
  __typename?: 'CustomQueryPreviewParamsOutput';
  query: Scalars['String']['output'];
};

export type CustomReporting = {
  __typename?: 'CustomReporting';
  countAggregated: Scalars['Float']['output'];
  countPlain: Scalars['Float']['output'];
  fields: Array<CustomReportingField>;
  filterValuesV2: CustomReportingFilterValues;
  previewAggregated: CustomReportingPreview;
  previewCustomQuery: CustomReportingPreview;
  previewPlain: CustomReportingPreview;
  tables: Array<CustomReportingTableData>;
};


export type CustomReportingCountAggregatedArgs = {
  params: CustomAggregatedPreviewParams;
};


export type CustomReportingCountPlainArgs = {
  params: CustomPlainPreviewParams;
};


export type CustomReportingFieldsArgs = {
  tableId?: InputMaybe<Scalars['String']['input']>;
};


export type CustomReportingFilterValuesV2Args = {
  fieldId: Scalars['String']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  tableId: Scalars['String']['input'];
};


export type CustomReportingPreviewAggregatedArgs = {
  params: CustomAggregatedPreviewParams;
};


export type CustomReportingPreviewCustomQueryArgs = {
  params: CustomQueryPreviewParams;
};


export type CustomReportingPreviewPlainArgs = {
  params: CustomPlainPreviewParams;
};

export type CustomReportingBoolFilter = {
  equal: Scalars['Boolean']['input'];
};

export type CustomReportingBoolFilterOutput = {
  __typename?: 'CustomReportingBoolFilterOutput';
  equal: Scalars['Boolean']['output'];
};

export enum CustomReportingBooleanAggregateFn {
  TrueCount = 'TRUE_COUNT'
}

export type CustomReportingBooleanValue = {
  __typename?: 'CustomReportingBooleanValue';
  aggregateFunction: CustomReportingBooleanAggregateFn;
};

export type CustomReportingBooleanValueInput = {
  aggregateFunction: CustomReportingBooleanAggregateFn;
};

export enum CustomReportingColumnType {
  Row = 'ROW',
  Value = 'VALUE'
}

export enum CustomReportingDateAggregateFn {
  Max = 'MAX',
  Min = 'MIN'
}

export type CustomReportingDateFilter = {
  equal?: InputMaybe<Scalars['Timestamp']['input']>;
  range?: InputMaybe<DateRange>;
  relative?: InputMaybe<CustomReportingDateRelativeFilter>;
};

export type CustomReportingDateFilterOutput = {
  __typename?: 'CustomReportingDateFilterOutput';
  equal?: Maybe<Scalars['Timestamp']['output']>;
  range?: Maybe<DateRangeOutput>;
  relative?: Maybe<CustomReportingDateRelativeFilterOutput>;
};

export type CustomReportingDateRelativeFilter = {
  offset?: InputMaybe<Scalars['Float']['input']>;
  type: CustomReportingDateRelativeFilterType;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type CustomReportingDateRelativeFilterOutput = {
  __typename?: 'CustomReportingDateRelativeFilterOutput';
  offset?: Maybe<Scalars['Float']['output']>;
  type: CustomReportingDateRelativeFilterType;
  value?: Maybe<Scalars['Float']['output']>;
};

export enum CustomReportingDateRelativeFilterType {
  InFuture = 'IN_FUTURE',
  InPast = 'IN_PAST',
  IsBlank = 'IS_BLANK',
  LastNDays = 'LAST_N_DAYS',
  LastNMonths = 'LAST_N_MONTHS',
  NextNDays = 'NEXT_N_DAYS',
  NextNMonths = 'NEXT_N_MONTHS',
  PreviousNYears = 'PREVIOUS_N_YEARS',
  PreviousYear = 'PREVIOUS_YEAR',
  Ytd = 'YTD',
  YtdAcct = 'YTD_ACCT'
}

export type CustomReportingDateValue = {
  __typename?: 'CustomReportingDateValue';
  aggregateFunction: CustomReportingDateAggregateFn;
};

export type CustomReportingDateValueInput = {
  aggregateFunction: CustomReportingDateAggregateFn;
};

export type CustomReportingField = {
  __typename?: 'CustomReportingField';
  deprecated: Scalars['Boolean']['output'];
  group: CustomReportingGroup;
  id: Scalars['ID']['output'];
  isArray?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  stringFilteringMode?: Maybe<CustomReportingStringFilteringMode>;
  supportAggregation: Scalars['Boolean']['output'];
  supportDataOutput: Scalars['Boolean']['output'];
  supportFiltering: Scalars['Boolean']['output'];
  tableIds: Array<Scalars['String']['output']>;
  type: CustomReportingFieldType;
};

export enum CustomReportingFieldType {
  Boolean = 'BOOLEAN',
  Date = 'DATE',
  DateStrict = 'DATE_STRICT',
  Money = 'MONEY',
  Number = 'NUMBER',
  Percent = 'PERCENT',
  String = 'STRING'
}

export type CustomReportingFilter = {
  boolFilter?: InputMaybe<CustomReportingBoolFilter>;
  dateFilter?: InputMaybe<CustomReportingDateFilter>;
  fieldId: Scalars['ID']['input'];
  numberFilter?: InputMaybe<CustomReportingNumberFilter>;
  stringFilter?: InputMaybe<CustomReportingStringFilter>;
};

export type CustomReportingFilterOutput = {
  __typename?: 'CustomReportingFilterOutput';
  boolFilter?: Maybe<CustomReportingBoolFilterOutput>;
  dateFilter?: Maybe<CustomReportingDateFilterOutput>;
  fieldId: Scalars['ID']['output'];
  numberFilter?: Maybe<CustomReportingNumberFilterOutput>;
  stringFilter?: Maybe<CustomReportingStringFilterOutput>;
};

export type CustomReportingFilterValues = {
  __typename?: 'CustomReportingFilterValues';
  values: Array<Scalars['String']['output']>;
};

export type CustomReportingGroup = {
  __typename?: 'CustomReportingGroup';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum CustomReportingNumberAggregateFn {
  Avg = 'AVG',
  Max = 'MAX',
  Min = 'MIN',
  Sum = 'SUM'
}

export type CustomReportingNumberFilter = {
  equal?: InputMaybe<Scalars['Float']['input']>;
  range?: InputMaybe<Range>;
};

export type CustomReportingNumberFilterOutput = {
  __typename?: 'CustomReportingNumberFilterOutput';
  equal?: Maybe<Scalars['Float']['output']>;
  range?: Maybe<OutputRange>;
};

export type CustomReportingNumberValue = {
  __typename?: 'CustomReportingNumberValue';
  aggregateFunction: CustomReportingNumberAggregateFn;
};

export type CustomReportingNumberValueInput = {
  aggregateFunction: CustomReportingNumberAggregateFn;
};

export type CustomReportingPlainColumn = {
  __typename?: 'CustomReportingPlainColumn';
  fieldId: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
};

export type CustomReportingPlainColumnInput = {
  fieldId: Scalars['ID']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
};

export type CustomReportingPreview = {
  __typename?: 'CustomReportingPreview';
  columns: Array<CustomReportingPreviewColumn>;
  data: Array<CustomReportingPreviewRow>;
};

export type CustomReportingPreviewColumn = {
  __typename?: 'CustomReportingPreviewColumn';
  title: Scalars['String']['output'];
  type: CustomReportingColumnType;
};

export type CustomReportingPreviewRow = {
  __typename?: 'CustomReportingPreviewRow';
  values: Array<Scalars['String']['output']>;
};

export type CustomReportingRow = {
  __typename?: 'CustomReportingRow';
  fieldId: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
};

export type CustomReportingRowInput = {
  fieldId: Scalars['ID']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
};

export type CustomReportingStringFilter = {
  /** @deprecated not used */
  equal?: InputMaybe<Scalars['String']['input']>;
  exclude?: InputMaybe<Array<Scalars['String']['input']>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  oneOf?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CustomReportingStringFilterOutput = {
  __typename?: 'CustomReportingStringFilterOutput';
  /** @deprecated not used */
  equal?: Maybe<Scalars['String']['output']>;
  exclude?: Maybe<Array<Scalars['String']['output']>>;
  isNull?: Maybe<Scalars['Boolean']['output']>;
  oneOf?: Maybe<Array<Scalars['String']['output']>>;
};

export enum CustomReportingStringFilteringMode {
  Enum = 'ENUM',
  FullList = 'FULL_LIST',
  Search = 'SEARCH'
}

export type CustomReportingStringValue = {
  __typename?: 'CustomReportingStringValue';
  aggregateFunction: CustomReportingStringValueAggregateFn;
};

export enum CustomReportingStringValueAggregateFn {
  Count = 'COUNT'
}

export type CustomReportingStringValueInput = {
  aggregateFunction: CustomReportingStringValueAggregateFn;
};

export type CustomReportingTableData = {
  __typename?: 'CustomReportingTableData';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CustomReportingValue = {
  __typename?: 'CustomReportingValue';
  boolSettings?: Maybe<CustomReportingBooleanValue>;
  dateSettings?: Maybe<CustomReportingDateValue>;
  fieldId: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  /** Used for MONEY, PERCENT and NUMBER */
  numberSettings?: Maybe<CustomReportingNumberValue>;
  stringSettings?: Maybe<CustomReportingStringValue>;
};

export type CustomReportingValueInput = {
  boolSettings?: InputMaybe<CustomReportingBooleanValueInput>;
  dateSettings?: InputMaybe<CustomReportingDateValueInput>;
  fieldId: Scalars['ID']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  /** Used for MONEY, PERCENT and NUMBER */
  numberSettings?: InputMaybe<CustomReportingNumberValueInput>;
  stringSettings?: InputMaybe<CustomReportingStringValueInput>;
};

export type Dashboard = {
  __typename?: 'Dashboard';
  created: Scalars['Timestamp']['output'];
  expandChart: Scalars['Boolean']['output'];
  expandMetrics: Scalars['Boolean']['output'];
  filter?: Maybe<PolicyFilterOutput>;
  id: Scalars['ID']['output'];
  sections: Array<DashboardSection>;
  title: Scalars['String']['output'];
  updated: Scalars['Timestamp']['output'];
};

export type DashboardSection = {
  __typename?: 'DashboardSection';
  collapsed: Scalars['Boolean']['output'];
  created: Scalars['Timestamp']['output'];
  expandMetrics?: Maybe<Scalars['Boolean']['output']>;
  expandTrends?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  policyFilter?: Maybe<PolicyFilterOutput>;
  policyFilterId?: Maybe<Scalars['String']['output']>;
  showFilters?: Maybe<Scalars['Boolean']['output']>;
  title: Scalars['String']['output'];
  widgets: Array<DashboardWidget>;
};

export type DashboardSectionUpsertInput = {
  collapsed: Scalars['Boolean']['input'];
  expandMetrics?: InputMaybe<Scalars['Boolean']['input']>;
  expandTrends?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  policyFilter?: InputMaybe<PolicyFilter>;
  policyFilterId?: InputMaybe<Scalars['String']['input']>;
  showFilters?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
  widgets: Array<DashboardWidgetUpsertInput>;
};

export type DashboardUpsertInput = {
  /** If set, then update, else get from existing entity, false by default */
  expandChart?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set, then update, else get from existing entity, false by default */
  expandMetrics?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set, then update, else get from existing entity, null by default */
  filter?: InputMaybe<PolicyFilter>;
  /** If set, then update existing, else create new one */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** If set, then update, else get from existing entity, empty array by default */
  sections?: InputMaybe<Array<InputMaybe<DashboardSectionUpsertInput>>>;
  /** If set, then update, else get from existing entity, Unnamed Dashboard by default */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type DashboardWidget = {
  __typename?: 'DashboardWidget';
  id: Scalars['ID']['output'];
  params: DashboardWidgetParamsPerType;
  type: DashboardWidgetType;
};

export type DashboardWidgetParamsPerType = {
  __typename?: 'DashboardWidgetParamsPerType';
  accountSize?: Maybe<AccountSizeWidgetParams>;
  accounts?: Maybe<AccountsWidgetParams>;
  averageAccountSize?: Maybe<AverageAccountSizeWidgetParams>;
  averageProductsPerClient?: Maybe<AverageProductsPerClientWidgetParams>;
  commissions?: Maybe<CommissionsWidgetParams>;
  growth?: Maybe<GrowthWidgetParams>;
  kpi?: Maybe<KpiWidgetParams>;
  leaderboard?: Maybe<LeaderboardWidgetParams>;
  lost?: Maybe<LostWidgetParams>;
  metrics?: Maybe<MetricsWidgetParams>;
  monolineRatios?: Maybe<MonolineRatiosWidgetParams>;
  opportunities?: Maybe<OpportunitiesWidgetParams>;
  policies?: Maybe<PoliciesWidgetParams>;
  premiumFlow?: Maybe<PremiumFlowWidgetParams>;
  premiumOutflowInflow?: Maybe<PremiumOutflowInflowWidgetParams>;
  producersSupported?: Maybe<ProducersSupportedWidgetParams>;
  topEntities?: Maybe<TopEntitiesWidgetParams>;
  upcomingRenewals?: Maybe<UpcomingRenewalsWidgetParams>;
};

export type DashboardWidgetParamsPerTypeInput = {
  accountSize?: InputMaybe<AccountSizeWidgetParamsInput>;
  accounts?: InputMaybe<AccountsWidgetParamsInput>;
  averageAccountSize?: InputMaybe<AverageAccountSizeWidgetParamsInput>;
  averageProductsPerClient?: InputMaybe<AverageProductsPerClientWidgetParamsInput>;
  commissions?: InputMaybe<CommissionsWidgetParamsInput>;
  growth?: InputMaybe<GrowthWidgetParamsInput>;
  kpi?: InputMaybe<KpiWidgetParamsInput>;
  leaderboard?: InputMaybe<LeaderboardWidgetParamsInput>;
  lost?: InputMaybe<LostWidgetParamsInput>;
  metrics?: InputMaybe<MetricsWidgetParamsInput>;
  monolineRatios?: InputMaybe<MonolineRatiosWidgetParamsInput>;
  opportunities?: InputMaybe<OpportunitiesWidgetParamsInput>;
  policies?: InputMaybe<PoliciesWidgetParamsInput>;
  premiumFlow?: InputMaybe<PremiumFlowWidgetParamsInput>;
  premiumOutflowInflow?: InputMaybe<PremiumOutflowInflowWidgetParamsInput>;
  producersSupported?: InputMaybe<ProducersSupportedWidgetParamsInput>;
  topEntities?: InputMaybe<TopEntitiesWidgetParamsInput>;
  upcomingRenewals?: InputMaybe<UpcomingRenewalsWidgetParamsInput>;
};

export enum DashboardWidgetType {
  Accounts = 'ACCOUNTS',
  AccountSize = 'ACCOUNT_SIZE',
  AverageAccountSize = 'AVERAGE_ACCOUNT_SIZE',
  AverageProductsPerClient = 'AVERAGE_PRODUCTS_PER_CLIENT',
  Commissions = 'COMMISSIONS',
  Growth = 'GROWTH',
  Kpi = 'KPI',
  Leaderboard = 'LEADERBOARD',
  Lost = 'LOST',
  Metrics = 'METRICS',
  MonolineRatios = 'MONOLINE_RATIOS',
  Opportunities = 'OPPORTUNITIES',
  Policies = 'POLICIES',
  PremiumFlow = 'PREMIUM_FLOW',
  PremiumOutflowInflow = 'PREMIUM_OUTFLOW_INFLOW',
  ProducersSupported = 'PRODUCERS_SUPPORTED',
  TopEntities = 'TOP_ENTITIES',
  UpcomingRenewals = 'UPCOMING_RENEWALS'
}

export type DashboardWidgetUpsertInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  params: DashboardWidgetParamsPerTypeInput;
  type: DashboardWidgetType;
};

export type Dashboards = {
  __typename?: 'Dashboards';
  all: Array<Dashboard>;
  byId: Dashboard;
  currentDashboardId?: Maybe<Scalars['String']['output']>;
};


export type DashboardsByIdArgs = {
  id: Scalars['ID']['input'];
};

export enum DataAuditReportType {
  BasicDq = 'BASIC_DQ',
  DuplicatePolicies = 'DUPLICATE_POLICIES',
  FlatCanceled = 'FLAT_CANCELED',
  NonBilledPolicies = 'NON_BILLED_POLICIES',
  OutstandingRevenue = 'OUTSTANDING_REVENUE',
  PoliciesWithoutProduct = 'POLICIES_WITHOUT_PRODUCT',
  UnderestimatedPolicies = 'UNDERESTIMATED_POLICIES'
}

export type DataIssuesGroupOutput = {
  __typename?: 'DataIssuesGroupOutput';
  /** To identify the group in the response */
  id: Scalars['String']['output'];
  issues: Array<PolicyDataIssue>;
};

export enum DatasourceType {
  /** Agency level policy or transaction data */
  AgencyData = 'AGENCY_DATA',
  /** Production credit data. Policies and transaction broken down by producer */
  ProductionCredit = 'PRODUCTION_CREDIT'
}

export type DateRange = {
  from?: InputMaybe<Scalars['SimpleDate']['input']>;
  to?: InputMaybe<Scalars['SimpleDate']['input']>;
};

export type DateRangeOutput = {
  __typename?: 'DateRangeOutput';
  from?: Maybe<Scalars['SimpleDate']['output']>;
  to?: Maybe<Scalars['SimpleDate']['output']>;
};

export type DecisionsPermission = {
  __typename?: 'DecisionsPermission';
  departmentIds?: Maybe<Array<Scalars['String']['output']>>;
  externalSystemIds?: Maybe<Array<Scalars['String']['output']>>;
  productIds?: Maybe<Array<Scalars['String']['output']>>;
};

export type DecisionsPermissions = {
  __typename?: 'DecisionsPermissions';
  allowed: Array<DecisionsPermission>;
};

export type DeleteDocumentFoldersResponse = {
  __typename?: 'DeleteDocumentFoldersResponse';
  deletedDocuments: Scalars['Float']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeleteDocumentPayload = {
  __typename?: 'DeleteDocumentPayload';
  deleted: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
};

export type DeleteOpportunityListPayload = {
  __typename?: 'DeleteOpportunityListPayload';
  success: Scalars['Boolean']['output'];
};

export type DeleteOpportunityReportPayload = {
  __typename?: 'DeleteOpportunityReportPayload';
  success: Scalars['Boolean']['output'];
};

export type DeleteProspectPayload = {
  __typename?: 'DeleteProspectPayload';
  success: Scalars['Boolean']['output'];
};

export type DeleteRemindersPayload = {
  __typename?: 'DeleteRemindersPayload';
  success: Scalars['Boolean']['output'];
};

export type DeleteSavedPagePayload = {
  __typename?: 'DeleteSavedPagePayload';
  success: Scalars['Boolean']['output'];
};

export type DeleteUserReportPresetPayload = {
  __typename?: 'DeleteUserReportPresetPayload';
  success: Scalars['Boolean']['output'];
};

export type Department = {
  __typename?: 'Department';
  children: Array<Department>;
  id: Scalars['ID']['output'];
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  level?: Maybe<DepartmentLevel>;
  levelNumber?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  parent?: Maybe<Department>;
};

/** level of BizOrg / Department */
export enum DepartmentLevel {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E',
  F = 'F',
  G = 'G',
  H = 'H'
}

export type DepartmentLevelWithName = {
  __typename?: 'DepartmentLevelWithName';
  isDefault: Scalars['Boolean']['output'];
  level: DepartmentLevel;
  name: Scalars['String']['output'];
};

export type DepartmentMonolineRatio = {
  __typename?: 'DepartmentMonolineRatio';
  department: Department;
  metrics: MonolineRatioMetrics;
};

export type DepartmentMonolineRatioWithStats = {
  __typename?: 'DepartmentMonolineRatioWithStats';
  items: Array<DepartmentMonolineRatio>;
  statistics?: Maybe<MonolineRatioStatistics>;
};

export type Departments = {
  __typename?: 'Departments';
  byId: Department;
  levels: Array<DepartmentLevelWithName>;
  list: Array<Department>;
  listRestricted: Array<Department>;
  tree: Array<Department>;
  treeRestricted: Array<Department>;
};


export type DepartmentsByIdArgs = {
  id: Scalars['ID']['input'];
};


export type DepartmentsListRestrictedArgs = {
  roleId?: InputMaybe<Scalars['String']['input']>;
};


export type DepartmentsTreeRestrictedArgs = {
  roleId?: InputMaybe<Scalars['String']['input']>;
};

export enum DetailedPolicyStatus {
  CrossSell = 'CROSS_SELL',
  New = 'NEW',
  Renewal = 'RENEWAL',
  Rewrite = 'REWRITE'
}

export type DiscoveredSourceColumn = {
  __typename?: 'DiscoveredSourceColumn';
  name: Scalars['String']['output'];
};

export type DnbAddress = {
  __typename?: 'DnbAddress';
  countryCode?: Maybe<Scalars['String']['output']>;
  countryName?: Maybe<Scalars['String']['output']>;
  countyName?: Maybe<Scalars['String']['output']>;
  /** Indicates if this address is strictly accurate or precise. */
  isInexact?: Maybe<Scalars['Boolean']['output']>;
  isResidentialAddress?: Maybe<Scalars['Boolean']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  /** Name of the city, town, township, village, borough, etc */
  localityName?: Maybe<Scalars['String']['output']>;
  locationOwnership?: Maybe<DnbAddressLocationOwnership>;
  longitude?: Maybe<Scalars['Float']['output']>;
  /** The name of the village, town or suburb when it is not a Primary Town or City (e.g., the Booker in Booker, High Wycombe) */
  minorTownName?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  /** Identifies a street or building within the geographic area covered by the Postal Code */
  postalCodeExtension?: Maybe<Scalars['String']['output']>;
  premisesArea?: Maybe<DnbAddressPremisesArea>;
  /** The shortened name of the locally */
  regionAbbreviatedName?: Maybe<Scalars['String']['output']>;
  regionName?: Maybe<Scalars['String']['output']>;
  statisticalAreaPopulationRankDescription?: Maybe<Scalars['String']['output']>;
  /** The details of the street address where the entity is located */
  streetLine1?: Maybe<Scalars['String']['output']>;
  streetLine2?: Maybe<Scalars['String']['output']>;
  streetLine3?: Maybe<Scalars['String']['output']>;
  streetLine4?: Maybe<Scalars['String']['output']>;
  streetName?: Maybe<Scalars['String']['output']>;
  streetNumber?: Maybe<Scalars['String']['output']>;
};

export type DnbAddressLocationOwnership = {
  __typename?: 'DnbAddressLocationOwnership';
  description?: Maybe<Scalars['String']['output']>;
  dnbCode?: Maybe<Scalars['Float']['output']>;
};

export type DnbAddressPremisesArea = {
  __typename?: 'DnbAddressPremisesArea';
  measurement?: Maybe<Scalars['Float']['output']>;
  reliabilityDescription?: Maybe<Scalars['String']['output']>;
  reliabilityDnBCode?: Maybe<Scalars['Float']['output']>;
  unitDescription?: Maybe<Scalars['String']['output']>;
  unitDnBCode?: Maybe<Scalars['Float']['output']>;
};

export type DnbCompaniesByIndustryRequest = {
  addressCounty?: InputMaybe<Scalars['String']['input']>;
  /** 1 to 50 characters used to find entities by the name of the city, town, village, etc. */
  addressLocality?: InputMaybe<Scalars['String']['input']>;
  /** 1 to 50 characters used to find entities by the name or US State abbreviation */
  addressRegion?: InputMaybe<Scalars['String']['input']>;
  /** 2 letter ISO 3166-1 scheme */
  countryCode?: InputMaybe<Scalars['String']['input']>;
  employees?: InputMaybe<Range>;
  isOutOfBusiness?: InputMaybe<Scalars['Boolean']['input']>;
  locationRadius?: InputMaybe<DnbLocationRadius>;
  /** 6 digit NAICS codes. If empty - we send all known codes */
  naicsCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** 1 to 20 characters used to find the entity by the postal code. If search with radius - postalCode must be specified in locationRadius instead */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  /** find entities by their primary or tradestyle names or D-U-N-S, Former primary names (last 5) or stockTicker */
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  streetAddressLine1?: InputMaybe<Scalars['String']['input']>;
  /** Identifying the Global Ultimate country/market of the entity. 2 letter ISO 3166-1 scheme */
  ultimateCountryCode?: InputMaybe<Scalars['String']['input']>;
  /** In dollars */
  yearlyRevenue?: InputMaybe<Range>;
};

export type DnbCompaniesByIndustryResponse = {
  __typename?: 'DnbCompaniesByIndustryResponse';
  items: Array<DnbSuggestion>;
  matched: Scalars['Int']['output'];
  returned: Scalars['Int']['output'];
};

export type DnbCompany = {
  __typename?: 'DnbCompany';
  businessEntityType?: Maybe<Scalars['String']['output']>;
  controlOwnershipDate?: Maybe<Scalars['String']['output']>;
  controlOwnershipTypeDescription?: Maybe<Scalars['String']['output']>;
  corporateLinkage?: Maybe<DnbCorporateLinkage>;
  /** The D-U-N-S Number */
  duns: Scalars['String']['output'];
  /** @deprecated Use integration.searchClient query instead */
  ennablClientId?: Maybe<Scalars['String']['output']>;
  fein?: Maybe<Scalars['String']['output']>;
  financials: Array<DnbFinancials>;
  foundationDate?: Maybe<Scalars['Timestamp']['output']>;
  id: Scalars['ID']['output'];
  industries?: Maybe<Array<Industry>>;
  industryCodes?: Maybe<Array<DnbIndustryCode>>;
  isMinorityOwned?: Maybe<Scalars['Boolean']['output']>;
  isSmallBusiness?: Maybe<Scalars['Boolean']['output']>;
  mailingAddress?: Maybe<DnbAddress>;
  naicsCodes: Array<DnbNaicsCode>;
  name: Scalars['String']['output'];
  numberOfEmployees?: Maybe<Scalars['Int']['output']>;
  numberOfEmployeesInformationScopeDescription?: Maybe<Scalars['String']['output']>;
  phones: Array<DnbPhone>;
  primaryAddress?: Maybe<DnbAddress>;
  principals: Array<DnbPrincipal>;
  prospect?: Maybe<Prospect>;
  registeredAddress?: Maybe<DnbAddress>;
  status?: Maybe<DnbControlStatus>;
  tradeStyleNames?: Maybe<Array<Scalars['String']['output']>>;
  websites: Array<Scalars['String']['output']>;
};


export type DnbCompanyProspectArgs = {
  anyOwner?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DnbCompanyRequest = {
  addressCounty?: InputMaybe<Scalars['String']['input']>;
  /** identifies the city, town, township, village, borough, etc. where the entity is located. */
  addressLocality?: InputMaybe<Scalars['String']['input']>;
  /** If country is US or CA, the Region must be 2 characters. For other countries, it can be up to 64 characters. */
  addressRegion?: InputMaybe<Scalars['String']['input']>;
  /** The 2-letter country/market ISO code. In the U.S. this would be a State. */
  countryCode?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  streetAddressLine1?: InputMaybe<Scalars['String']['input']>;
  streetAddressLine2?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type DnbControlStatus = {
  __typename?: 'DnbControlStatus';
  fullReportDate?: Maybe<Scalars['Timestamp']['output']>;
  isDelisted?: Maybe<Scalars['Boolean']['output']>;
  isMailUndeliverable?: Maybe<Scalars['Boolean']['output']>;
  isMarketable?: Maybe<Scalars['Boolean']['output']>;
  isOutOfBusiness?: Maybe<Scalars['Boolean']['output']>;
  isPhoneDisconnected?: Maybe<Scalars['Boolean']['output']>;
  operatingStatus?: Maybe<DnbOperatingStatus>;
  operatingStatusDescription?: Maybe<Scalars['String']['output']>;
};

export type DnbCorporateLinkage = {
  __typename?: 'DnbCorporateLinkage';
  domesticUltimate?: Maybe<DnbUltimate>;
  familytreeRolesPlayed?: Maybe<Array<DnbFamilyTreeRole>>;
  globalUltimate?: Maybe<DnbUltimate>;
  globalUltimateFamilyTreeMembersCount?: Maybe<Scalars['Int']['output']>;
  headQuarter?: Maybe<DnbUltimate>;
  hierarchyLevel?: Maybe<Scalars['Int']['output']>;
  isBranch?: Maybe<Scalars['Boolean']['output']>;
  parent?: Maybe<DnbUltimate>;
};

export enum DnbCriteriaSearchSorting {
  CountryCode = 'COUNTRY_CODE',
  IsBranch = 'IS_BRANCH',
  IsOutOfBusiness = 'IS_OUT_OF_BUSINESS',
  NumberOfEmployees = 'NUMBER_OF_EMPLOYEES',
  PrimaryName = 'PRIMARY_NAME',
  YearlyRevenue = 'YEARLY_REVENUE'
}

export type DnbFamilyTreeRole = {
  __typename?: 'DnbFamilyTreeRole';
  description?: Maybe<Scalars['String']['output']>;
  dnbCode?: Maybe<Scalars['Int']['output']>;
};

export type DnbFinancials = {
  __typename?: 'DnbFinancials';
  accountantName?: Maybe<Scalars['String']['output']>;
  /** The date when the accounting period ended. */
  financialStatementToDate?: Maybe<Scalars['Timestamp']['output']>;
  reliabilityDescription?: Maybe<Scalars['String']['output']>;
  unitCode?: Maybe<Scalars['String']['output']>;
  yearlyRevenue?: Maybe<Array<DnbYearlyRevenue>>;
};

export type DnbIndustryCode = {
  __typename?: 'DnbIndustryCode';
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  typeDescription?: Maybe<Scalars['String']['output']>;
  typeDnBCode?: Maybe<Scalars['Int']['output']>;
};

/** Max radius is 100mi or equivalent */
export type DnbLocationRadius = {
  /** Search radius around specified location */
  radius: Scalars['Float']['input'];
  /** Unit of measurement for the radius */
  unit: LocationRadiusUnit;
};

export type DnbNaicsCode = {
  __typename?: 'DnbNaicsCode';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  /** Priority is based on the percentage of business the entity does in the industry. */
  priority: Scalars['Int']['output'];
};

export enum DnbOperatingStatus {
  Active = 'ACTIVE',
  OutOfService = 'OUT_OF_SERVICE'
}

export type DnbPhone = {
  __typename?: 'DnbPhone';
  isUnreachable?: Maybe<Scalars['Boolean']['output']>;
  isdCode?: Maybe<Scalars['String']['output']>;
  number: Scalars['String']['output'];
};

export type DnbPrincipal = {
  __typename?: 'DnbPrincipal';
  familyName?: Maybe<Scalars['String']['output']>;
  fullName: Scalars['String']['output'];
  gender?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
  isImportant: Scalars['Boolean']['output'];
  jobTitles?: Maybe<Array<Scalars['String']['output']>>;
  namePrefix?: Maybe<Scalars['String']['output']>;
  nameSuffix?: Maybe<Scalars['String']['output']>;
};

export type DnbSuggestion = {
  __typename?: 'DnbSuggestion';
  corporateLinkage?: Maybe<DnbCorporateLinkage>;
  /** The D-U-N-S Number */
  duns: Scalars['String']['output'];
  /** @deprecated Use integration.searchClient query instead */
  ennablClientId?: Maybe<Scalars['String']['output']>;
  /** Only available for search by industry */
  financials?: Maybe<Array<DnbFinancials>>;
  id: Scalars['ID']['output'];
  industries?: Maybe<Array<Industry>>;
  /** Only available for search by industry */
  industryCodes?: Maybe<Array<DnbIndustryCode>>;
  mailingAddress?: Maybe<DnbAddress>;
  /** Only available for search by industry */
  naicsCodes?: Maybe<Array<DnbNaicsCode>>;
  name: Scalars['String']['output'];
  /** Only available for search by industry */
  numberOfEmployees?: Maybe<Scalars['Int']['output']>;
  /** Only available for search by industry */
  numberOfEmployeesInformationScopeDescription?: Maybe<Scalars['String']['output']>;
  phones: Array<DnbPhone>;
  primaryAddress?: Maybe<DnbAddress>;
  prospect?: Maybe<Prospect>;
  status?: Maybe<DnbControlStatus>;
  websites: Array<Scalars['String']['output']>;
};


export type DnbSuggestionProspectArgs = {
  anyOwner?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DnbTrend = {
  __typename?: 'DnbTrend';
  growthRate?: Maybe<Scalars['Float']['output']>;
  timePeriod?: Maybe<DnbTrendTimePeriod>;
};

export type DnbTrendTimePeriod = {
  __typename?: 'DnbTrendTimePeriod';
  description?: Maybe<Scalars['String']['output']>;
  dnbCode?: Maybe<Scalars['Float']['output']>;
};

export type DnbUltimate = {
  __typename?: 'DnbUltimate';
  duns?: Maybe<Scalars['String']['output']>;
  primaryAddress?: Maybe<DnbAddress>;
  primaryName?: Maybe<Scalars['String']['output']>;
};

export type DnbYearlyRevenue = {
  __typename?: 'DnbYearlyRevenue';
  /** The three-letter currency code, defined in the ISO 4217 scheme */
  currency?: Maybe<Scalars['String']['output']>;
  trend?: Maybe<Array<DnbTrend>>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type Document = {
  __typename?: 'Document';
  client?: Maybe<Client>;
  createdDate?: Maybe<Scalars['Timestamp']['output']>;
  documentClass?: Maybe<Scalars['String']['output']>;
  documentSize?: Maybe<Scalars['Float']['output']>;
  extension?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastModifiedDate?: Maybe<Scalars['Timestamp']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  policy?: Maybe<Policy>;
  policyNumber?: Maybe<Scalars['String']['output']>;
  sourceSystem?: Maybe<ExternalSystem>;
  url?: Maybe<Scalars['String']['output']>;
};

export type DocumentDownloadUrlInput = {
  id: Scalars['String']['input'];
  type: DocumentFileType;
};

export enum DocumentFileType {
  AnalysisJson = 'ANALYSIS_JSON',
  Preview = 'PREVIEW',
  ReportArchive = 'REPORT_ARCHIVE'
}

export type DocumentFilter = {
  clientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  query?: InputMaybe<Scalars['String']['input']>;
  sourceSystem?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentFilterDateRange = {
  from?: InputMaybe<Scalars['SimpleDate']['input']>;
  to?: InputMaybe<Scalars['SimpleDate']['input']>;
  type: DocumentsFilterDateType;
};

export type DocumentFilterDateRangeOutput = {
  __typename?: 'DocumentFilterDateRangeOutput';
  from?: Maybe<Scalars['SimpleDate']['output']>;
  to?: Maybe<Scalars['SimpleDate']['output']>;
  type: DocumentsFilterDateType;
};

export type DocumentListPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<DocumentSortingField>;
  /** Total count will be different if we use sorting by metric with permissions */
  sortOrder?: InputMaybe<SortOrder>;
};

export type DocumentListResults = {
  __typename?: 'DocumentListResults';
  items: Array<DocumentMetadata>;
  totalHits: Scalars['Float']['output'];
};

export type DocumentMetadata = {
  __typename?: 'DocumentMetadata';
  adminProducts: Array<AdminProduct>;
  /** Source client (account) names, from document */
  clientNames: Array<Scalars['String']['output']>;
  /** Date when the document was created */
  created: Scalars['SimpleDate']['output'];
  /** File size in bytes */
  fileSize: Scalars['Int']['output'];
  filename: Scalars['String']['output'];
  folder?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  products?: Maybe<Array<Product>>;
  status: DocumentProcessingStatus;
};

export type DocumentPaginatedResult = {
  __typename?: 'DocumentPaginatedResult';
  items: Array<Document>;
  totalHits: Scalars['Int']['output'];
};

export type DocumentPresignedUploadUrl = {
  __typename?: 'DocumentPresignedUploadUrl';
  file: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type DocumentPresignedUrl = {
  __typename?: 'DocumentPresignedUrl';
  createdDate: Scalars['Timestamp']['output'];
  /** URL is empty if file is still in processing */
  excelArchiveUrl?: Maybe<Scalars['String']['output']>;
  filename: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isProcessing: Scalars['Boolean']['output'];
  previewUrl: Scalars['String']['output'];
  /** URL is empty if file is still in processing */
  url?: Maybe<Scalars['String']['output']>;
};

export enum DocumentProcessingStatus {
  Failure = 'FAILURE',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED',
  Success = 'SUCCESS'
}

export enum DocumentSortingField {
  Address = 'ADDRESS',
  ClientId = 'CLIENT_ID',
  ClientName = 'CLIENT_NAME',
  CreatedDate = 'CREATED_DATE',
  FileType = 'FILE_TYPE',
  Name = 'NAME',
  PolicyNumber = 'POLICY_NUMBER',
  SourceSystem = 'SOURCE_SYSTEM',
  State = 'STATE'
}

export type DocumentStatistics = {
  __typename?: 'DocumentStatistics';
  byStatus: Array<DocumentStatusCount>;
  total: Scalars['Float']['output'];
};

export type DocumentStatusCount = {
  __typename?: 'DocumentStatusCount';
  count: Scalars['Float']['output'];
  status: DocumentProcessingStatus;
};

export type DocumentUrlList = {
  __typename?: 'DocumentUrlList';
  processed: Array<DocumentPresignedUrl>;
  processingQuantity: Scalars['Float']['output'];
};

export type Documents = {
  __typename?: 'Documents';
  byIds: Array<Document>;
  paginated: DocumentPaginatedResult;
};


export type DocumentsByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type DocumentsPaginatedArgs = {
  filter?: InputMaybe<DocumentFilter>;
  pagination?: InputMaybe<DocumentListPaginationInput>;
};

export type DocumentsBalance = {
  __typename?: 'DocumentsBalance';
  documentsLeft: Scalars['Float']['output'];
  documentsUploaded: Scalars['Float']['output'];
};

export type DocumentsCompare = {
  __typename?: 'DocumentsCompare';
  filesList: Array<DocumentsCompareFile>;
  groupById: DocumentsCompareGroup;
  groupList: Array<DocumentsCompareGroup>;
};


export type DocumentsCompareFilesListArgs = {
  groupId: Scalars['String']['input'];
};


export type DocumentsCompareGroupByIdArgs = {
  id: Scalars['String']['input'];
};

export type DocumentsCompareFile = {
  __typename?: 'DocumentsCompareFile';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pagesCount?: Maybe<Scalars['Float']['output']>;
  uploadedAt: Scalars['Timestamp']['output'];
  url: Scalars['String']['output'];
};

export type DocumentsCompareFileInput = {
  /** Flag to mark a file as primary/main for comparison group */
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type DocumentsCompareFileUrl = {
  __typename?: 'DocumentsCompareFileUrl';
  file: Scalars['String']['output'];
  id: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type DocumentsCompareGroup = {
  __typename?: 'DocumentsCompareGroup';
  createdAt: Scalars['Timestamp']['output'];
  differencesCount?: Maybe<Scalars['Float']['output']>;
  documentsCount?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  isNew?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  primaryFileId?: Maybe<Scalars['String']['output']>;
  /** Exists when status is SUCCESS */
  reportDownloadUrl?: Maybe<Scalars['String']['output']>;
  /** Available only for byId request and if status is SUCCESS */
  resultUrl?: Maybe<Scalars['String']['output']>;
  status: DocumentsCompareGroupStatus;
  syncScore?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['Timestamp']['output'];
};

export enum DocumentsCompareGroupStatus {
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  InUploading = 'IN_UPLOADING',
  ReadyForProcessing = 'READY_FOR_PROCESSING',
  Success = 'SUCCESS'
}

export type DocumentsFilter = {
  adminProductIds?: InputMaybe<Array<Scalars['String']['input']>>;
  dateRange?: InputMaybe<DocumentFilterDateRange>;
  folder?: InputMaybe<Scalars['String']['input']>;
  /** Any level product IDs */
  productIds?: InputMaybe<Array<Scalars['String']['input']>>;
  rootFolder?: InputMaybe<Scalars['Boolean']['input']>;
  /** Used for updating of stored last used time */
  storedId?: InputMaybe<Scalars['String']['input']>;
};

export enum DocumentsFilterDateType {
  Creation = 'CREATION',
  PolicyEffective = 'POLICY_EFFECTIVE',
  PolicyExpiration = 'POLICY_EXPIRATION'
}

export type DocumentsFilterOutput = {
  __typename?: 'DocumentsFilterOutput';
  adminProductIds?: Maybe<Array<Scalars['String']['output']>>;
  dateRange?: Maybe<DocumentFilterDateRangeOutput>;
  folder?: Maybe<Scalars['String']['output']>;
  /** Any level product IDs */
  productIds?: Maybe<Array<Scalars['String']['output']>>;
  rootFolder?: Maybe<Scalars['Boolean']['output']>;
  /** Used for updating of stored last used time */
  storedId?: Maybe<Scalars['String']['output']>;
};

export type DocumentsListPagination = {
  limit?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  sortBy?: InputMaybe<DocumentsSortingField>;
  /** Total count will be different if we use sorting by metric with permissions */
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentsSearchPagination = {
  limit?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
};

export enum DocumentsSortingField {
  CreatedDate = 'CREATED_DATE',
  FileName = 'FILE_NAME',
  FileSize = 'FILE_SIZE'
}

export type DocumentsV0 = {
  __typename?: 'DocumentsV0';
  balance: DocumentsBalance;
  byId?: Maybe<DocumentPresignedUrl>;
  /** @deprecated Use urlList instead */
  listUrls: DocumentUrlList;
  urlList: Array<DocumentPresignedUrl>;
};


export type DocumentsV0ByIdArgs = {
  id: Scalars['String']['input'];
};

export type DocumentsV1 = {
  __typename?: 'DocumentsV1';
  balance: DocumentsBalance;
  byId: DocumentMetadata;
  list: DocumentListResults;
  listFolders: Array<Scalars['String']['output']>;
  search: DocumentListResults;
  statistics: DocumentStatistics;
};


export type DocumentsV1ByIdArgs = {
  id: Scalars['String']['input'];
};


export type DocumentsV1ListArgs = {
  filter?: InputMaybe<DocumentsFilter>;
  pagination?: InputMaybe<DocumentsListPagination>;
};


export type DocumentsV1SearchArgs = {
  filter?: InputMaybe<DocumentsFilter>;
  pagination?: InputMaybe<DocumentsSearchPagination>;
  query: Scalars['String']['input'];
};


export type DocumentsV1StatisticsArgs = {
  filter?: InputMaybe<DocumentsFilter>;
};

export type DolCompany = {
  __typename?: 'DolCompany';
  /** FEIN of the company */
  fein: Scalars['ID']['output'];
  mailAddress?: Maybe<Form5500Address>;
  name: Scalars['String']['output'];
  participantsAmount?: Maybe<OutputRange>;
  phone?: Maybe<Scalars['String']['output']>;
  prospect?: Maybe<Prospect>;
  /** @deprecated Removed */
  usAddress?: Maybe<Form5500Address>;
};


export type DolCompanyProspectArgs = {
  anyOwner?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DolCompanySearchRequest = {
  brokerName?: InputMaybe<Scalars['String']['input']>;
  carrierName?: InputMaybe<Scalars['String']['input']>;
  /** Federal Employer Identification Number */
  fein?: InputMaybe<Scalars['String']['input']>;
  /** Location radius for zipCodes field which must be provided if locationRadius is provided */
  locationRadius?: InputMaybe<LocationRadius>;
  /** NAICS 2022 codes */
  naicsCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Sponsor name in terms of form5500 or company name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Participants amount for the beginning of the year form published */
  participantsAmount?: InputMaybe<Range>;
  /** One of policy expiration dates is in the range */
  policyExpirationDate?: InputMaybe<DateRange>;
  /** The two symbol state code */
  stateCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Zip-5 codes */
  zipCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DolCompanySearchResult = {
  __typename?: 'DolCompanySearchResult';
  items: Array<DolCompany>;
  totalHits: Scalars['Float']['output'];
};

export type EnnablRole = {
  __typename?: 'EnnablRole';
  appPermissions: Array<AppPermission>;
  decisionsPermissions?: Maybe<DecisionsPermissions>;
  id: Scalars['ID']['output'];
  /** This is custom access role created for specific user */
  isPrivate: Scalars['Boolean']['output'];
  /**
   * Predefined roles are not allowed to be removed or updated (except name)
   * @deprecated Will be deleted after UM migration, for now protected is only preset-full-access preset and can be detected by id
   */
  isProtected: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export enum EnnablRoleHierarchyType {
  Root = 'ROOT',
  SubAdmin = 'SUB_ADMIN',
  SubUser = 'SUB_USER'
}

export enum EnnablRoleType {
  AccountExecutive = 'ACCOUNT_EXECUTIVE',
  AccountManager = 'ACCOUNT_MANAGER',
  Admin = 'ADMIN',
  Custom = 'CUSTOM',
  Producer = 'PRODUCER'
}

export type EnnablRoles = {
  __typename?: 'EnnablRoles';
  role: EnnablUserRole;
  roles: Array<EnnablUserRole>;
};


export type EnnablRolesRoleArgs = {
  id: Scalars['ID']['input'];
};

export type EnnablUser = {
  __typename?: 'EnnablUser';
  createdDate?: Maybe<Scalars['Timestamp']['output']>;
  email: Scalars['String']['output'];
  employeeId?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invitedBy?: Maybe<Scalars['String']['output']>;
  lastActiveDate?: Maybe<Scalars['Timestamp']['output']>;
  lastName: Scalars['String']['output'];
  role?: Maybe<EnnablUserRole>;
  roleId?: Maybe<Scalars['ID']['output']>;
  status: EnnablUserStatus;
};

export type EnnablUserInviteInput = {
  email: Scalars['String']['input'];
  employeeId?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  roleId?: InputMaybe<Scalars['ID']['input']>;
};

export type EnnablUserPermissionsInput = {
  departmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  externalSystemIds?: InputMaybe<Array<Scalars['String']['input']>>;
  productIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type EnnablUserRole = {
  __typename?: 'EnnablUserRole';
  appPermissions: Array<AppUserPermission>;
  /** Child SUB_USER roles for SUB_ADMIN roles */
  children?: Maybe<Array<EnnablUserRole>>;
  createdAt?: Maybe<Scalars['Timestamp']['output']>;
  /** If null, no data permissions are granted */
  decisionsPermissions?: Maybe<DecisionsPermission>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** This is custom access role created for specific user */
  isPrivate: Scalars['Boolean']['output'];
  /** Predefined roles are not allowed to be removed or updated (except name) */
  isProtected: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** Parent SUB_ADMIN role for SUB_USER roles */
  parent?: Maybe<EnnablUserRole>;
  /** Role hierarchy type: ROOT, SUB_ADMIN, or SUB_USER */
  roleType: EnnablRoleHierarchyType;
  updatedAt?: Maybe<Scalars['Timestamp']['output']>;
  viewMode?: Maybe<EnnablUserViewMode>;
};

export type EnnablUserRoleCreateInput = {
  appPermissions: Array<AppUserPermission>;
  decisionsPermissions: EnnablUserPermissionsInput;
  description?: InputMaybe<Scalars['String']['input']>;
  /** This is custom access role created for specific user */
  isPrivate: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  /** Parent SUB_ADMIN role ID, required for SUB_USER roles */
  parentRoleId?: InputMaybe<Scalars['ID']['input']>;
  /** Role type: ROOT (default), SUB_ADMIN, or SUB_USER */
  roleType?: InputMaybe<EnnablRoleHierarchyType>;
  viewMode: EnnablUserViewMode;
};

export type EnnablUserRoleUpdateInput = {
  appPermissions: Array<AppUserPermission>;
  decisionsPermissions: EnnablUserPermissionsInput;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  /** Parent SUB_ADMIN role ID. Only ROOT admin can change this. */
  parentRoleId?: InputMaybe<Scalars['ID']['input']>;
  viewMode: EnnablUserViewMode;
};

export enum EnnablUserStatus {
  Active = 'ACTIVE',
  Pending = 'PENDING',
  Removed = 'REMOVED',
  Suspended = 'SUSPENDED'
}

export type EnnablUserUpdateInput = {
  employeeId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  roleId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<EnnablUserStatus>;
};

export enum EnnablUserViewMode {
  DecisionsAccountManager = 'DECISIONS_ACCOUNT_MANAGER',
  DecisionsDefault = 'DECISIONS_DEFAULT',
  DecisionsProducer = 'DECISIONS_PRODUCER',
  EnnablData = 'ENNABL_DATA',
  MgaDefault = 'MGA_DEFAULT'
}

export type EnnablUserViewModeObject = {
  __typename?: 'EnnablUserViewModeObject';
  value: EnnablUserViewMode;
};

export type EnrichmentMappings = {
  __typename?: 'EnrichmentMappings';
  insuranceCompanyMappingSearchMappings: InsuranceCompanySearchMappingResponse;
  insuranceCompanyMappingSearchUsedAdminCompanies: InsuranceCompanySearchUsedAdminCompaniesResponse;
  productList: ListProductsMappingResponse;
};


export type EnrichmentMappingsInsuranceCompanyMappingSearchMappingsArgs = {
  externalSystemIds?: InputMaybe<Array<Scalars['String']['input']>>;
  linkedWithAdminCompany?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<InsuranceCompanySearchMappingPagination>;
};


export type EnrichmentMappingsInsuranceCompanyMappingSearchUsedAdminCompaniesArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<InsuranceCompanySearchUsedAdminCompaniesPagination>;
  ultimateParentPrimaryRelationship?: InputMaybe<InsuranceCompanyRelationshipType>;
  usedInExternalSystemIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type EnrichmentMappingsProductListArgs = {
  externalSystemIds?: InputMaybe<Array<Scalars['String']['input']>>;
  linkedWithAdminProduct?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EnrichmentProcessingTokenResponse = {
  __typename?: 'EnrichmentProcessingTokenResponse';
  token?: Maybe<Scalars['String']['output']>;
};

export enum EntityColumn {
  DepartmentParentName = 'DEPARTMENT__PARENT_NAME',
  IndustryGroup = 'INDUSTRY__GROUP',
  IndustrySubGroup = 'INDUSTRY__SUB_GROUP',
  Parent = 'PARENT',
  ProductSegment = 'PRODUCT__SEGMENT'
}

export type EntityColumnConfig = {
  /** Custom header override */
  header?: InputMaybe<Scalars['String']['input']>;
  /** Column key - must be prefixed with entity name (e.g., PRODUCT__SEGMENT) */
  key: EntityColumn;
};

export type EntityMetrics = {
  __typename?: 'EntityMetrics';
  commission: Scalars['Float']['output'];
  premium: Scalars['Float']['output'];
  revenue: Scalars['Float']['output'];
};

export type EtlAmount = {
  __typename?: 'EtlAmount';
  commission: Scalars['Float']['output'];
  fee: Scalars['Float']['output'];
  premium: Scalars['Float']['output'];
};

export type EtlBucket = {
  __typename?: 'EtlBucket';
  billedAmount?: Maybe<EtlAmount>;
  count: Scalars['Int']['output'];
  writtenAmount?: Maybe<EtlAmount>;
};

export type EtlEntityStats = {
  __typename?: 'EtlEntityStats';
  extracted: EtlBucket;
  failed: EtlBucket;
  loaded: EtlBucket;
  loadedWithProblems: EtlBucket;
};

export type EtlInfo = {
  __typename?: 'EtlInfo';
  lastFinishAt?: Maybe<Scalars['Timestamp']['output']>;
};

export type EtlSnapshot = {
  __typename?: 'EtlSnapshot';
  clients?: Maybe<EtlEntityStats>;
  date: Scalars['Timestamp']['output'];
  policies?: Maybe<EtlEntityStats>;
  transactions?: Maybe<EtlEntityStats>;
};

export type EtlStageInfo = {
  __typename?: 'EtlStageInfo';
  processedAt?: Maybe<Scalars['Timestamp']['output']>;
  uploadId?: Maybe<Scalars['ID']['output']>;
};

export type EtlStages = {
  __typename?: 'EtlStages';
  decision?: Maybe<EtlStageInfo>;
  enrichment1?: Maybe<EtlStageInfo>;
  enrichment2?: Maybe<EtlStageInfo>;
  marts?: Maybe<EtlStageInfo>;
  tailor?: Maybe<EtlStageInfo>;
  unifier?: Maybe<EtlStageInfo>;
};

export type EtlSystemInfo = {
  __typename?: 'EtlSystemInfo';
  lastExtractAt?: Maybe<Scalars['Timestamp']['output']>;
  lastProcessedAt?: Maybe<Scalars['Timestamp']['output']>;
  lastProcessedUpload?: Maybe<SourceDataUpload>;
  stages?: Maybe<EtlStages>;
};

export type ExternalSystem = {
  __typename?: 'ExternalSystem';
  agency: ExternalSystemAgency;
  etlHistory?: Maybe<Array<EtlSnapshot>>;
  etlSnapshot?: Maybe<EtlSnapshot>;
  /** system id */
  id: Scalars['ID']['output'];
  lastEtl?: Maybe<EtlSystemInfo>;
  /** Newest login among the users scoped to this system through their role (decisionsPermissions.externalSystemIds). Null when no such user has ever signed in. Users on unrestricted (all-systems) roles are not counted. */
  lastUserLoginAt?: Maybe<Scalars['Timestamp']['output']>;
  latestSubmittedUpload?: Maybe<SourceDataUpload>;
  /** @deprecated Use latestSubmittedUpload */
  latestSubmittedUploadFromS3?: Maybe<SourceDataUpload>;
  name: Scalars['String']['output'];
  status?: Maybe<ExternalSystemStatus>;
  /**
   * system id
   * @deprecated Use id instead
   */
  systemId: Scalars['String']['output'];
};

export type ExternalSystemAgency = {
  __typename?: 'ExternalSystemAgency';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum ExternalSystemStatus {
  Closed = 'CLOSED',
  Draft = 'DRAFT',
  Live = 'LIVE',
  Migrated = 'MIGRATED',
  Onboarding = 'ONBOARDING'
}

export type FilterRange = {
  /** Lower bound for search */
  from?: InputMaybe<Scalars['Float']['input']>;
  mode?: InputMaybe<FilterRangeMode>;
  notExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Upper bound search */
  to?: InputMaybe<Scalars['Float']['input']>;
};

export enum FilterRangeMode {
  /** Exclude limit values */
  ExcludeLimits = 'EXCLUDE_LIMITS',
  /** Include limit values */
  IncludeLimits = 'INCLUDE_LIMITS',
  /** Include right end values */
  IncludeMax = 'INCLUDE_MAX',
  /** Include left end values (Default) */
  IncludeMin = 'INCLUDE_MIN'
}

export type FilterRangeOutput = {
  __typename?: 'FilterRangeOutput';
  /** Lower bound for search */
  from?: Maybe<Scalars['Float']['output']>;
  mode?: Maybe<FilterRangeMode>;
  notExists?: Maybe<Scalars['Boolean']['output']>;
  /** Upper bound search */
  to?: Maybe<Scalars['Float']['output']>;
};

export type Form5500 = {
  __typename?: 'Form5500';
  /** Source: admin_* */
  admin?: Maybe<Form5500Admin>;
  /** Source: admin_manual_signed_* */
  adminManualSigned?: Maybe<Form5500Signed>;
  /** Source: admin_signed_* */
  adminSigned?: Maybe<Form5500Signed>;
  /** Source: dfe_manual_signed_* */
  dfeManualSigned?: Maybe<Form5500Signed>;
  /** Source: dfe_signed_* */
  dfeSigned?: Maybe<Form5500Signed>;
  /** Source: filing_year */
  filingYear?: Maybe<Scalars['Int']['output']>;
  /** Source: ack_id */
  id: Scalars['ID']['output'];
  /** Source: industry_desc */
  industryDesc?: Maybe<Scalars['String']['output']>;
  /** Source: business_code */
  naics?: Maybe<Scalars['String']['output']>;
  /** calculated in resolver and might be undefined if unavailable to download */
  optionalPdfDownloadLink?: Maybe<Scalars['String']['output']>;
  participantsCount: ParticipantsCount;
  pdfDownloadLink: Scalars['String']['output'];
  /** Source: plan_eff_date */
  planEffectiveDate?: Maybe<Scalars['Timestamp']['output']>;
  /** Source: plan_name */
  planName?: Maybe<Scalars['String']['output']>;
  /** Source: type_plan_entity_desc */
  planTypeDesc?: Maybe<Scalars['String']['output']>;
  /** Source: form_plan_year_begin_date */
  planYearBegin?: Maybe<Scalars['Timestamp']['output']>;
  /** Source: form_plan_year_end_date */
  planYearEnd?: Maybe<Scalars['Timestamp']['output']>;
  /** Source: date_received */
  received?: Maybe<Scalars['Timestamp']['output']>;
  scheduleA: Array<Form5500ScheduleA>;
  /** Source: sponsor_dfe_* */
  sponsorDfe?: Maybe<Form5500SponsorDfe>;
  /** Source: spons_manual_signed_* */
  sponsorManualSigned?: Maybe<Form5500Signed>;
  /** Source: spons_signed_* */
  sponsorSigned?: Maybe<Form5500Signed>;
  /** Source: filing_form_type */
  type?: Maybe<Form5500Type>;
};

export type Form5500Address = {
  __typename?: 'Form5500Address';
  city?: Maybe<Scalars['String']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type Form5500Admin = {
  __typename?: 'Form5500Admin';
  ein?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  phoneForeign?: Maybe<Scalars['String']['output']>;
  usAddress?: Maybe<Form5500Address>;
};

export type Form5500ScheduleA = {
  __typename?: 'Form5500ScheduleA';
  /** Source: sch_aein */
  ein?: Maybe<Scalars['String']['output']>;
  /** unique identifier of this record inside form5500 record, starting with 1 */
  formId: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  /** Source: ins_broker_comm_tot_amt */
  insuranceBrokerCommissionTotal?: Maybe<Scalars['Float']['output']>;
  /** Source: ins_broker_fees_tot_amt */
  insuranceBrokerFeeTotal?: Maybe<Scalars['Float']['output']>;
  /** Source: ins_broker_fees_tot_amt */
  insuranceBrokerRevenueTotal?: Maybe<Scalars['Float']['output']>;
  /** Source: ins_carrier_ein */
  insuranceCarrierEin?: Maybe<Scalars['String']['output']>;
  /** Source: ins_carrier_naic_code */
  insuranceCarrierNaics?: Maybe<Scalars['String']['output']>;
  /** Source: ins_carrier_name */
  insuranceCarrierName?: Maybe<Scalars['String']['output']>;
  /** Source: ins_contract_num */
  insuranceContractNumber?: Maybe<Scalars['String']['output']>;
  /** Source: ins_prsn_covered_eoy_cnt */
  insurancePersonCoveredCount?: Maybe<Scalars['Int']['output']>;
  /** Source: ins_policy_from_date */
  insurancePolicyFromDate?: Maybe<Scalars['Timestamp']['output']>;
  /** Source: ins_policy_to_date */
  insurancePolicyToDate?: Maybe<Scalars['Timestamp']['output']>;
  /** Information Concerning Insurance Contract Coverage, Fees, and Commissions. Provide info for each contract of a separate Schedule A. */
  part1: Array<Form5500ScheduleAPart1>;
  /** Source: sch_aplan_num */
  planNum?: Maybe<Scalars['String']['output']>;
  /** Source: sch_aplan_year_begin_date */
  planYearBeginDate?: Maybe<Scalars['String']['output']>;
  /** Source: sch_aplan_year_end_date */
  planYearEndDate?: Maybe<Scalars['String']['output']>;
  /** Source: wlfr_* */
  welfareBenefitAmounts?: Maybe<Form5500WelfareBenefitAmounts>;
  /** Source: parsed wlfr_bnft_ind_* + wlfr_type_bnft_oth_text */
  welfareBenefitProducts?: Maybe<Array<Scalars['String']['output']>>;
};

export type Form5500ScheduleAPart1 = {
  __typename?: 'Form5500ScheduleAPart1';
  /** Source: ins_broker_comm_pd_amt */
  brokerCommission?: Maybe<Scalars['Float']['output']>;
  /** Source: ins_broker_fees_pd_amt */
  brokerFee?: Maybe<Scalars['Float']['output']>;
  /** Source: ins_broker_name */
  brokerName?: Maybe<Scalars['String']['output']>;
  /** Source: ins_broker_fees_pd_amt */
  brokerRevenue?: Maybe<Scalars['Float']['output']>;
  /** Source: ins_broker_us* */
  brokerUsAddress1?: Maybe<Form5500Address>;
  /** unique identifier of this record inside ScheduleA record, starting with 1 */
  formId: Scalars['Float']['output'];
  /** Source: ack_id */
  id: Scalars['ID']['output'];
  /** unique identifier of this record inside ScheduleA record, starting with 1 */
  rowOrder: Scalars['String']['output'];
};

export type Form5500SearchPagination = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type Form5500SearchRequest = {
  /** Federal Employer Identification Number */
  fein?: InputMaybe<Scalars['String']['input']>;
  /** Year for was created */
  filingYears?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Sponsor name in terms of form5500 or company name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Name of the plan */
  planName?: InputMaybe<Scalars['String']['input']>;
  /** The two symbol state code */
  stateCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Form5500SearchResponse = {
  __typename?: 'Form5500SearchResponse';
  items: Array<Form5500>;
  totalHits: Scalars['Int']['output'];
};

export type Form5500Signed = {
  __typename?: 'Form5500Signed';
  date?: Maybe<Scalars['Timestamp']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Form5500SponsorDfe = {
  __typename?: 'Form5500SponsorDFE';
  dbaName?: Maybe<Scalars['String']['output']>;
  ein?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  phoneForeign?: Maybe<Scalars['String']['output']>;
  usLocalAddress?: Maybe<Form5500Address>;
  usMailAddress?: Maybe<Form5500Address>;
};

export enum Form5500Type {
  Full = 'FULL',
  Short = 'SHORT'
}

export type Form5500WelfareBenefitAmounts = {
  __typename?: 'Form5500WelfareBenefitAmounts';
  /** Source: wlfr_tot_charges_paid_amt */
  paidTotalCharges?: Maybe<Scalars['Float']['output']>;
  /** Source: wlfr_premium_rcvd_amt */
  premiumReceived?: Maybe<Scalars['Float']['output']>;
  /** Source: wlfr_tot_earned_prem_a */
  premiumTotalEarned?: Maybe<Scalars['Float']['output']>;
};

export type FromToPeriod = {
  from: Scalars['Timestamp']['input'];
  to: Scalars['Timestamp']['input'];
};

export type GetDocumentUploadUrlsItem = {
  __typename?: 'GetDocumentUploadUrlsItem';
  filename: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type GetDocumentUploadUrlsResponse = {
  __typename?: 'GetDocumentUploadUrlsResponse';
  batchId: Scalars['String']['output'];
  files: Array<GetDocumentUploadUrlsItem>;
};

export type GlobalCarrierAppetite = {
  __typename?: 'GlobalCarrierAppetite';
  kpi: GlobalCarrierAppetiteKpi;
  list: GlobalCarrierAppetitePaginatedResult;
  marketTree: Array<GlobalInsuranceCompany>;
  productTree: Array<GlobalInsuranceSegment>;
};


export type GlobalCarrierAppetiteKpiArgs = {
  carrierLevel: CarrierLevel;
  filter: CarrierAppetiteFilter;
};


export type GlobalCarrierAppetiteListArgs = {
  carrierLevel: CarrierLevel;
  filter: CarrierAppetiteFilter;
  pagination: CarrierAppetiteListPaginationInput;
};


export type GlobalCarrierAppetiteMarketTreeArgs = {
  primaryRole: CompanyPrimaryRole;
};

export type GlobalCarrierAppetiteKpi = {
  __typename?: 'GlobalCarrierAppetiteKpi';
  carrierCount: Scalars['Float']['output'];
  /** if null - count of policies is less than 100 */
  directPolicies?: Maybe<Scalars['Float']['output']>;
  /** if null - count of policies is less than 100 */
  indirectPolicies?: Maybe<Scalars['Float']['output']>;
};

export type GlobalCarrierAppetitePaginatedResult = {
  __typename?: 'GlobalCarrierAppetitePaginatedResult';
  items: Array<GlobalCarrierAppetiteRow>;
  totalHits: Scalars['Int']['output'];
};

export type GlobalCarrierAppetiteRow = {
  __typename?: 'GlobalCarrierAppetiteRow';
  /** children field is not resolved here */
  carrier: GlobalInsuranceCompany;
  directCommission: OutputRange;
  /** if null - count of policies is less than 100 */
  directPolicies?: Maybe<Scalars['Float']['output']>;
  indirectCommission: OutputRange;
  /** if null - count of policies is less than 100 */
  indirectPolicies?: Maybe<Scalars['Float']['output']>;
};

export type GlobalInsuranceCompany = {
  __typename?: 'GlobalInsuranceCompany';
  /** for child level this list is always empty */
  children: Array<GlobalInsuranceCompany>;
  id: Scalars['String']['output'];
  /** corresponding market in broker's DB, if present */
  market?: Maybe<Market>;
  name: Scalars['String']['output'];
};

export type GlobalInsuranceSegment = {
  __typename?: 'GlobalInsuranceSegment';
  name: Scalars['String']['output'];
  /** corresponding product in broker's DB, if present */
  product?: Maybe<Product>;
  products: Array<GlobalProduct>;
};

export type GlobalProduct = {
  __typename?: 'GlobalProduct';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** corresponding product in broker's DB, if present */
  product?: Maybe<Product>;
};

export type Growth = {
  __typename?: 'Growth';
  currentValue?: Maybe<Scalars['Float']['output']>;
  diff?: Maybe<Scalars['Float']['output']>;
  diffPct?: Maybe<Scalars['Float']['output']>;
  prevValue?: Maybe<Scalars['Float']['output']>;
};

export type GrowthWidgetParams = {
  __typename?: 'GrowthWidgetParams';
  carrierLevel?: Maybe<CarrierLevel>;
  entity: WidgetEntity;
  entityKeys?: Maybe<Array<WidgetEntity>>;
  filter?: Maybe<PolicyFilterOutput>;
  radioValue?: Maybe<Scalars['String']['output']>;
};

export type GrowthWidgetParamsInput = {
  carrierLevel?: InputMaybe<CarrierLevel>;
  entity: WidgetEntity;
  entityKeys?: InputMaybe<Array<WidgetEntity>>;
  filter?: InputMaybe<PolicyFilter>;
  radioValue?: InputMaybe<Scalars['String']['input']>;
};

export type HazardhubAaisFireProtectionClassParams = {
  __typename?: 'HazardhubAaisFireProtectionClassParams';
  availableWaterType?: Maybe<Scalars['String']['output']>;
  class?: Maybe<Scalars['String']['output']>;
  hydrantFireStationDistance?: Maybe<Scalars['String']['output']>;
};

export type HazardhubAirportNoise = {
  __typename?: 'HazardhubAirportNoise';
  decibels?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type HazardhubAspectRisk = {
  __typename?: 'HazardhubAspectRisk';
  aspect?: Maybe<Scalars['String']['output']>;
  direction?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['String']['output']>;
};

export type HazardhubAssessment = {
  __typename?: 'HazardhubAssessment';
  airConditioning?: Maybe<Scalars['String']['output']>;
  airConditioningType?: Maybe<Scalars['String']['output']>;
  amenities?: Maybe<Scalars['String']['output']>;
  amenities2?: Maybe<Scalars['String']['output']>;
  assessedImprovementValue?: Maybe<Scalars['Float']['output']>;
  assessedLandValue?: Maybe<Scalars['Float']['output']>;
  assessmentYear?: Maybe<Scalars['String']['output']>;
  assessorsParcelNumber?: Maybe<Scalars['String']['output']>;
  basement?: Maybe<Scalars['String']['output']>;
  buildingArea?: Maybe<Scalars['Float']['output']>;
  buildingArea1?: Maybe<Scalars['Float']['output']>;
  buildingClass?: Maybe<Scalars['String']['output']>;
  buildingCondition?: Maybe<Scalars['String']['output']>;
  buildingQuality?: Maybe<Scalars['String']['output']>;
  condoProjectBldgName?: Maybe<Scalars['String']['output']>;
  currentOwnerName?: Maybe<Scalars['String']['output']>;
  fireplace?: Maybe<Scalars['String']['output']>;
  garageCars?: Maybe<Scalars['Float']['output']>;
  garageType?: Maybe<Scalars['String']['output']>;
  heating?: Maybe<Scalars['String']['output']>;
  legalBriefDescriptionFull?: Maybe<Scalars['String']['output']>;
  legalSubdivisionName?: Maybe<Scalars['String']['output']>;
  listSaleDocumentNumber?: Maybe<Scalars['String']['output']>;
  listSalePrice?: Maybe<Scalars['String']['output']>;
  listSalePriceCode?: Maybe<Scalars['String']['output']>;
  listSaleRecordingDate?: Maybe<Scalars['String']['output']>;
  listValidPrice?: Maybe<Scalars['String']['output']>;
  lotSizeAcres?: Maybe<Scalars['Float']['output']>;
  lotSizeDepthFeet?: Maybe<Scalars['String']['output']>;
  lotSizeFrontageFeet?: Maybe<Scalars['String']['output']>;
  lotSizeSquareFeet?: Maybe<Scalars['Float']['output']>;
  mainBuildingAreaIndicator?: Maybe<Scalars['String']['output']>;
  nOfPlumbingFixtures?: Maybe<Scalars['String']['output']>;
  neighborhoodCode?: Maybe<Scalars['String']['output']>;
  noOfBuildings?: Maybe<Scalars['Float']['output']>;
  noOfStories?: Maybe<Scalars['String']['output']>;
  numberOfBaths?: Maybe<Scalars['Float']['output']>;
  numberOfBedrooms?: Maybe<Scalars['Float']['output']>;
  numberOfPartialBaths?: Maybe<Scalars['Float']['output']>;
  numberOfUnits?: Maybe<Scalars['Float']['output']>;
  owner1FirstName?: Maybe<Scalars['String']['output']>;
  owner1LastName?: Maybe<Scalars['String']['output']>;
  owner2Firstname?: Maybe<Scalars['String']['output']>;
  owner2LastName?: Maybe<Scalars['String']['output']>;
  ownerOccupied?: Maybe<Scalars['String']['output']>;
  pool?: Maybe<Scalars['String']['output']>;
  previousSalePrice?: Maybe<Scalars['String']['output']>;
  roofCover?: Maybe<Scalars['String']['output']>;
  roofType?: Maybe<Scalars['String']['output']>;
  schoolTaxDistrict1?: Maybe<Scalars['String']['output']>;
  schoolTaxDistrict1Indicator?: Maybe<Scalars['String']['output']>;
  schoolTaxDistrict2?: Maybe<Scalars['String']['output']>;
  schoolTaxDistrict2Indicator?: Maybe<Scalars['String']['output']>;
  schoolTaxDistrict3?: Maybe<Scalars['String']['output']>;
  schoolTaxDistrict3Indicator?: Maybe<Scalars['String']['output']>;
  siteInfluence?: Maybe<Scalars['String']['output']>;
  standardizedLandUseCode?: Maybe<Scalars['String']['output']>;
  taxAmount?: Maybe<Scalars['Float']['output']>;
  taxDelinquentYear?: Maybe<Scalars['String']['output']>;
  taxMarketValue?: Maybe<Scalars['Float']['output']>;
  taxRateCodeArea?: Maybe<Scalars['String']['output']>;
  topography?: Maybe<Scalars['String']['output']>;
  totalAssessedValue?: Maybe<Scalars['Float']['output']>;
  totalMarketValue?: Maybe<Scalars['Float']['output']>;
  totalNumberOfRooms?: Maybe<Scalars['String']['output']>;
  typeConstruction?: Maybe<Scalars['String']['output']>;
  yearBuilt?: Maybe<Scalars['String']['output']>;
};

export type HazardhubBaseFloodElevation = {
  __typename?: 'HazardhubBaseFloodElevation';
  distance?: Maybe<HazardhubDistanceNumber>;
  elevation?: Maybe<HazardhubDistanceNumber>;
  meter?: Maybe<Scalars['Float']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type HazardhubCachedResponse = {
  __typename?: 'HazardhubCachedResponse';
  data: HazardhubResponse;
  lastUpdated: Scalars['Timestamp']['output'];
};

export type HazardhubCbrsParams = {
  __typename?: 'HazardhubCbrsParams';
  cbrsType?: Maybe<Scalars['String']['output']>;
  designation?: Maybe<Scalars['String']['output']>;
  fastAcres?: Maybe<Scalars['Float']['output']>;
  fiDate?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  shoreMile?: Maybe<Scalars['Float']['output']>;
  suDate?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  wetAcres?: Maybe<Scalars['Float']['output']>;
};

export type HazardhubCoastDistance = {
  __typename?: 'HazardhubCoastDistance';
  beachDistance?: Maybe<HazardhubDistanceString>;
  distance?: Maybe<Scalars['String']['output']>;
  highResDistance?: Maybe<HazardhubDistanceString>;
  lowResDistance?: Maybe<HazardhubDistanceString>;
  units?: Maybe<Scalars['String']['output']>;
};

export type HazardhubDetail = {
  __typename?: 'HazardhubDetail';
  areaDesc?: Maybe<Scalars['String']['output']>;
  siteDesc?: Maybe<Scalars['String']['output']>;
};

export type HazardhubDistanceNumber = {
  __typename?: 'HazardhubDistanceNumber';
  units?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type HazardhubDistanceString = {
  __typename?: 'HazardhubDistanceString';
  units?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type HazardhubDistanceToSignificantFloodParams = {
  __typename?: 'HazardhubDistanceToSignificantFloodParams';
  distanceTo100YrFloodplain?: Maybe<Scalars['String']['output']>;
  elevation100?: Maybe<Scalars['String']['output']>;
  elevationDifference100?: Maybe<Scalars['String']['output']>;
  elevationInFeet?: Maybe<HazardhubValueString>;
};

export type HazardhubDistanceToSignificantWfRiskParams = {
  __typename?: 'HazardhubDistanceToSignificantWfRiskParams';
  high?: Maybe<Scalars['String']['output']>;
  moderate?: Maybe<Scalars['String']['output']>;
  risk?: Maybe<Scalars['String']['output']>;
  veryHigh?: Maybe<Scalars['String']['output']>;
};

export type HazardhubDriveDistanceFireStation = {
  __typename?: 'HazardhubDriveDistanceFireStation';
  distance?: Maybe<Scalars['Float']['output']>;
  units?: Maybe<Scalars['String']['output']>;
};

export type HazardhubDriveTimeFireStation = {
  __typename?: 'HazardhubDriveTimeFireStation';
  duration?: Maybe<Scalars['Float']['output']>;
  units?: Maybe<Scalars['String']['output']>;
};

export type HazardhubDroughtFrequencyIndex = {
  __typename?: 'HazardhubDroughtFrequencyIndex';
  desc?: Maybe<Scalars['String']['output']>;
  pct?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type HazardhubEarthquake = {
  __typename?: 'HazardhubEarthquake';
  mmi?: Maybe<Scalars['String']['output']>;
  peakGroundAcceleration?: Maybe<Scalars['Float']['output']>;
  richterScale?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['String']['output']>;
  shake?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type HazardhubEnhancedHailParams = {
  __typename?: 'HazardhubEnhancedHailParams';
  countWithin25MilesForLastDecade?: Maybe<Scalars['String']['output']>;
  haddrisk?: Maybe<Scalars['String']['output']>;
  historicalHailEvents?: Maybe<HazardhubHistoricalHailEvents>;
  hpctrisk?: Maybe<Scalars['String']['output']>;
  nearestHailIncident?: Maybe<HazardhubNearestIncident>;
  numOfDamagingHailIncidentsWithin25MilesSince1996?: Maybe<Scalars['Float']['output']>;
  scale?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type HazardhubEnhancedHhFloodParams = {
  __typename?: 'HazardhubEnhancedHhFloodParams';
  diff?: Maybe<Scalars['Float']['output']>;
  dist?: Maybe<Scalars['Float']['output']>;
  elevPt?: Maybe<Scalars['Float']['output']>;
  elevnff?: Maybe<Scalars['Float']['output']>;
  linesDescrip?: Maybe<Scalars['String']['output']>;
  linesDiff?: Maybe<Scalars['Float']['output']>;
  linesDistance?: Maybe<Scalars['Float']['output']>;
  linesName?: Maybe<Scalars['String']['output']>;
  linesScore?: Maybe<Scalars['String']['output']>;
  polygonDescrip?: Maybe<Scalars['String']['output']>;
  polygonName?: Maybe<Scalars['String']['output']>;
  polygonType?: Maybe<Scalars['String']['output']>;
  polygonsDiff?: Maybe<Scalars['Float']['output']>;
  polygonsDistance?: Maybe<Scalars['Float']['output']>;
  polygonsScore?: Maybe<Scalars['String']['output']>;
};

export type HazardhubEnhancedHhPfs = {
  __typename?: 'HazardhubEnhancedHhPfs';
  averagePctLoss?: Maybe<Scalars['Float']['output']>;
  estimatedLossAmt?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type HazardhubEnhancedHurricaneParams = {
  __typename?: 'HazardhubEnhancedHurricaneParams';
  annualChanceEventLessThan950Mb?: Maybe<Scalars['Float']['output']>;
  annualChanceEventMoreThan50Knots?: Maybe<Scalars['Float']['output']>;
  avgBarometricPressMb?: Maybe<Scalars['Float']['output']>;
  avgWindSpeedKnots?: Maybe<Scalars['Float']['output']>;
  maxWindSpeedKnots?: Maybe<Scalars['Float']['output']>;
  minBarometricPressMb?: Maybe<Scalars['Float']['output']>;
  nameYearMaxWind?: Maybe<Scalars['String']['output']>;
  nameYearMinPress?: Maybe<Scalars['String']['output']>;
  numCat0Hurricanes?: Maybe<Scalars['Float']['output']>;
  numCat1Hurricanes?: Maybe<Scalars['Float']['output']>;
  numCat2Hurricanes?: Maybe<Scalars['Float']['output']>;
  numCat3Hurricanes?: Maybe<Scalars['Float']['output']>;
  numCat4Hurricanes?: Maybe<Scalars['Float']['output']>;
  numCat5Hurricanes?: Maybe<Scalars['Float']['output']>;
  numDisturbances?: Maybe<Scalars['Float']['output']>;
  numEventsGt50Knots?: Maybe<Scalars['Float']['output']>;
  numEventsPressLt950Mb?: Maybe<Scalars['Float']['output']>;
  numExtratropicalSystems?: Maybe<Scalars['Float']['output']>;
  numHurricanes?: Maybe<Scalars['Float']['output']>;
  numLows?: Maybe<Scalars['Float']['output']>;
  numSubtropicalDepressions?: Maybe<Scalars['Float']['output']>;
  numSubtropicalStorms?: Maybe<Scalars['Float']['output']>;
  numTropicalDepressions?: Maybe<Scalars['Float']['output']>;
  numTropicalStorms?: Maybe<Scalars['Float']['output']>;
  numTropicalWaves?: Maybe<Scalars['Float']['output']>;
  scale?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  totalEventsSince1980?: Maybe<Scalars['Float']['output']>;
};

export type HazardhubEnhancedLightningParams = {
  __typename?: 'HazardhubEnhancedLightningParams';
  laddrisk?: Maybe<Scalars['String']['output']>;
  lpctrisk?: Maybe<Scalars['String']['output']>;
  lsqmi?: Maybe<Scalars['String']['output']>;
  scale?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['String']['output']>;
  strikesYr?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type HazardhubEnhancedProperty = {
  __typename?: 'HazardhubEnhancedProperty';
  assessment?: Maybe<HazardhubAssessment>;
  images?: Maybe<Array<Scalars['String']['output']>>;
  listingRecord?: Maybe<HazardhubListingRecord>;
  mlsListingRecordDetails?: Maybe<HazardhubMlsListingDetails>;
  property?: Maybe<HazardhubProperty>;
  valuation?: Maybe<HazardhubValuation>;
};

export type HazardhubEnhancedTornadoParams = {
  __typename?: 'HazardhubEnhancedTornadoParams';
  countWithin25MilesForLastDecade?: Maybe<Scalars['String']['output']>;
  historicalTornadoEvents?: Maybe<HazardhubHistoricalTornadoEvents>;
  nearestTornadoIncident?: Maybe<HazardhubNearestIncident>;
  numOfDamagingTornadoIncidentsWithin25MilesSince1996?: Maybe<Scalars['Float']['output']>;
  scale?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['String']['output']>;
  taddrisk?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  tpctrisk?: Maybe<Scalars['String']['output']>;
};

export type HazardhubEnhancedWildfire = {
  __typename?: 'HazardhubEnhancedWildfire';
  fireSeasonPrecipRisk?: Maybe<HazardhubFireSeasonPrecipRisk>;
  katabaticWindRisk?: Maybe<HazardhubKatabaticWindRisk>;
  landcoverRisk?: Maybe<HazardhubLandcoverRisk>;
  riskScores?: Maybe<HazardhubRiskScores>;
  score?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  vegetationBurnSiteRisk?: Maybe<HazardhubVegetationBurnSiteRisk>;
  wildfirePerimeterRisk?: Maybe<HazardhubWildfirePerimeterRisk>;
};

export type HazardhubEnhancedWindParams = {
  __typename?: 'HazardhubEnhancedWindParams';
  countWithin25MilesForLastDecade?: Maybe<Scalars['String']['output']>;
  historicalWindEvents?: Maybe<HazardhubHistoricalWindEvents>;
  nearestWindIncident?: Maybe<HazardhubNearestIncident>;
  numOfDamagingWindIncidentsWithin25MilesSince1996?: Maybe<Scalars['Float']['output']>;
  scale?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  waddrisk?: Maybe<Scalars['String']['output']>;
  wpctrisk?: Maybe<Scalars['String']['output']>;
};

export type HazardhubFemaAllFloodParams = {
  __typename?: 'HazardhubFemaAllFloodParams';
  arRevert?: Maybe<Scalars['String']['output']>;
  arSubtrv?: Maybe<Scalars['String']['output']>;
  bfeRevert?: Maybe<Scalars['String']['output']>;
  depRevert?: Maybe<Scalars['String']['output']>;
  depth?: Maybe<Scalars['Float']['output']>;
  dfirmId?: Maybe<Scalars['String']['output']>;
  dualZone?: Maybe<Scalars['String']['output']>;
  fldArId?: Maybe<Scalars['String']['output']>;
  fldZone?: Maybe<Scalars['String']['output']>;
  lenUnit?: Maybe<Scalars['String']['output']>;
  sfhaTf?: Maybe<Scalars['String']['output']>;
  sourceCit?: Maybe<Scalars['String']['output']>;
  staticBfe?: Maybe<Scalars['Float']['output']>;
  studyTyp?: Maybe<Scalars['String']['output']>;
  vDatum?: Maybe<Scalars['String']['output']>;
  velUnit?: Maybe<Scalars['String']['output']>;
  velocity?: Maybe<Scalars['Float']['output']>;
  versionId?: Maybe<Scalars['String']['output']>;
  zoneSubty?: Maybe<Scalars['String']['output']>;
};

export type HazardhubFemaClaim = {
  __typename?: 'HazardhubFemaClaim';
  value?: Maybe<Scalars['Float']['output']>;
  year?: Maybe<Scalars['Float']['output']>;
};

export type HazardhubFemaClaims = {
  __typename?: 'HazardhubFemaClaims';
  claims?: Maybe<Array<HazardhubFemaClaim>>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type HazardhubFemaFirmDate = {
  __typename?: 'HazardhubFemaFirmDate';
  cid?: Maybe<Scalars['String']['output']>;
  communityName?: Maybe<Scalars['String']['output']>;
  crsEntryDate?: Maybe<Scalars['String']['output']>;
  currentClass?: Maybe<Scalars['String']['output']>;
  currentEffectiveDate?: Maybe<Scalars['String']['output']>;
  currentEffectiveDateFloodMap?: Maybe<Scalars['String']['output']>;
  dateEnteredProgram?: Maybe<Scalars['String']['output']>;
  initialFirmIdDate?: Maybe<Scalars['String']['output']>;
  initialFloodHazardBoundayMapIdDate?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  percentDiscountForNonSfha?: Maybe<Scalars['String']['output']>;
  percentDiscountForSfha?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type HazardhubFemaFirmPanels = {
  __typename?: 'HazardhubFemaFirmPanels';
  effectiveDate?: Maybe<Scalars['String']['output']>;
  firmPanel?: Maybe<Scalars['String']['output']>;
};

export type HazardhubFemaMapParams = {
  __typename?: 'HazardhubFemaMapParams';
  femaFloodMapUrl?: Maybe<Scalars['String']['output']>;
};

export type HazardhubFireProtection = {
  __typename?: 'HazardhubFireProtection';
  aaisProxy?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type HazardhubFireSeasonPrecipRisk = {
  __typename?: 'HazardhubFireSeasonPrecipRisk';
  desc?: Maybe<Scalars['String']['output']>;
  monthlyAvgPrecip?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

export type HazardhubFireSeasonPrecipitationParams = {
  __typename?: 'HazardhubFireSeasonPrecipitationParams';
  fireSeasonPrecipitation?: Maybe<Scalars['String']['output']>;
  risk?: Maybe<Scalars['String']['output']>;
  scale?: Maybe<Scalars['String']['output']>;
};

export type HazardhubGroundSnowLoad = {
  __typename?: 'HazardhubGroundSnowLoad';
  desc?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type HazardhubHardiness = {
  __typename?: 'HazardhubHardiness';
  avextmin?: Maybe<Scalars['String']['output']>;
  avextmin5?: Maybe<Scalars['String']['output']>;
  zone?: Maybe<Scalars['String']['output']>;
  zoneseg?: Maybe<Scalars['String']['output']>;
};

export type HazardhubHhElevation = {
  __typename?: 'HazardhubHhElevation';
  aspect?: Maybe<Scalars['String']['output']>;
  elevation?: Maybe<Scalars['String']['output']>;
  slope?: Maybe<Scalars['String']['output']>;
};

export type HazardhubHhSnowLoad = {
  __typename?: 'HazardhubHhSnowLoad';
  desc?: Maybe<Scalars['String']['output']>;
  scale?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type HazardhubHistoricalHailEvents = {
  __typename?: 'HazardhubHistoricalHailEvents';
  hailRad?: Maybe<Scalars['String']['output']>;
};

export type HazardhubHistoricalTornadoEvents = {
  __typename?: 'HazardhubHistoricalTornadoEvents';
  tornadoRad?: Maybe<Scalars['String']['output']>;
};

export type HazardhubHistoricalWindEvents = {
  __typename?: 'HazardhubHistoricalWindEvents';
  windRad?: Maybe<Scalars['String']['output']>;
};

export type HazardhubHospital = {
  __typename?: 'HazardhubHospital';
  address?: Maybe<Scalars['String']['output']>;
  distance?: Maybe<Scalars['String']['output']>;
  helipad?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  numberOfHospitalsWithin5Miles?: Maybe<Scalars['Float']['output']>;
  numberOfHospitalsWithin10Miles?: Maybe<Scalars['Float']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type HazardhubHydrantParams = {
  __typename?: 'HazardhubHydrantParams';
  distanceFromNearestHydrant?: Maybe<Scalars['String']['output']>;
  hydrantsWithin1000Ft?: Maybe<Scalars['Float']['output']>;
};

export type HazardhubIndex = {
  __typename?: 'HazardhubIndex';
  index?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type HazardhubKatabaticWindRisk = {
  __typename?: 'HazardhubKatabaticWindRisk';
  desc?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

export type HazardhubLandcoverAreas = {
  __typename?: 'HazardhubLandcoverAreas';
  distanceTo?: Maybe<Scalars['Float']['output']>;
  pctWildland?: Maybe<Scalars['Float']['output']>;
  riskCategory?: Maybe<Scalars['String']['output']>;
};

export type HazardhubLandcoverRisk = {
  __typename?: 'HazardhubLandcoverRisk';
  desc?: Maybe<Scalars['String']['output']>;
  detail?: Maybe<HazardhubDetail>;
  proximateLandcoverAreas?: Maybe<Array<HazardhubLandcoverAreas>>;
  score?: Maybe<Scalars['Float']['output']>;
};

export type HazardhubLavaFlow = {
  __typename?: 'HazardhubLavaFlow';
  desc?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  zone?: Maybe<Scalars['String']['output']>;
};

export type HazardhubListingRecord = {
  __typename?: 'HazardhubListingRecord';
  date?: Maybe<Scalars['Timestamp']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type HazardhubLivingArea = {
  __typename?: 'HazardhubLivingArea';
  squareFootage?: Maybe<Scalars['String']['output']>;
  yearBuilt?: Maybe<Scalars['String']['output']>;
};

export type HazardhubLomaParams = {
  __typename?: 'HazardhubLomaParams';
  case?: Maybe<Scalars['String']['output']>;
  cid?: Maybe<Scalars['String']['output']>;
  communityName?: Maybe<Scalars['String']['output']>;
  dateEnded?: Maybe<Scalars['String']['output']>;
  determination?: Maybe<Scalars['String']['output']>;
  docUrl?: Maybe<Scalars['String']['output']>;
  lotType?: Maybe<Scalars['String']['output']>;
  outcome?: Maybe<Scalars['String']['output']>;
  projectCat?: Maybe<Scalars['String']['output']>;
  projectName?: Maybe<Scalars['String']['output']>;
  revalStat?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type HazardhubLomrParams = {
  __typename?: 'HazardhubLomrParams';
  caseNo?: Maybe<Scalars['String']['output']>;
  dfirmId?: Maybe<Scalars['String']['output']>;
  effDate?: Maybe<Scalars['String']['output']>;
  lomrId?: Maybe<Scalars['String']['output']>;
  sourceCit?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type HazardhubMaxWindParams = {
  __typename?: 'HazardhubMaxWindParams';
  maxRecordedWindMph?: Maybe<Scalars['Float']['output']>;
  maxWindScale?: Maybe<Scalars['Float']['output']>;
};

export type HazardhubMlsListingDetails = {
  __typename?: 'HazardhubMlsListingDetails';
  adGeoAltitude?: Maybe<Scalars['String']['output']>;
  adZoneFeatures?: Maybe<Scalars['String']['output']>;
  exterior: HazardhubMlsListingExterior;
  interior: HazardhubMlsListingInterior;
  interiorFinishes: HazardhubMlsListingInteriorFinishes;
  rooms: HazardhubMlsListingRooms;
  schoolDistrict?: Maybe<Scalars['String']['output']>;
};

export type HazardhubMlsListingExterior = {
  __typename?: 'HazardhubMlsListingExterior';
  constructionFeatures?: Maybe<Scalars['String']['output']>;
  fenceFeatures?: Maybe<Scalars['String']['output']>;
  foundationFeatures?: Maybe<Scalars['String']['output']>;
  garageFeatures?: Maybe<Scalars['String']['output']>;
  garageSpaces?: Maybe<Scalars['Int']['output']>;
  generalFeatures?: Maybe<Scalars['String']['output']>;
  locationFeatures?: Maybe<Scalars['String']['output']>;
  lotSizeAcres?: Maybe<Scalars['Float']['output']>;
  lotSizeFeatures?: Maybe<Scalars['String']['output']>;
  lotSizeSquareFeet?: Maybe<Scalars['Float']['output']>;
  parkingFeatures?: Maybe<Scalars['String']['output']>;
  parkingSpaces?: Maybe<Scalars['String']['output']>;
  patio?: Maybe<Scalars['Boolean']['output']>;
  patioFeatures?: Maybe<Scalars['String']['output']>;
  pool?: Maybe<Scalars['Boolean']['output']>;
  poolFeatures?: Maybe<Scalars['String']['output']>;
  roadFeatures?: Maybe<Scalars['String']['output']>;
  roofFeatures?: Maybe<Scalars['String']['output']>;
  sewerFeatures?: Maybe<Scalars['String']['output']>;
  spa?: Maybe<Scalars['Boolean']['output']>;
  styleFeatures?: Maybe<Scalars['String']['output']>;
  viewFeatures?: Maybe<Scalars['String']['output']>;
  wallFeatures?: Maybe<Scalars['String']['output']>;
  wateraccessFeatures?: Maybe<Scalars['String']['output']>;
  waterfrontFeatures?: Maybe<Scalars['String']['output']>;
};

export type HazardhubMlsListingInterior = {
  __typename?: 'HazardhubMlsListingInterior';
  associationDues1?: Maybe<Scalars['String']['output']>;
  livingSquareFeet?: Maybe<Scalars['Float']['output']>;
  propertyType?: Maybe<Scalars['String']['output']>;
  publicRemarks?: Maybe<Scalars['String']['output']>;
  soldDate?: Maybe<Scalars['String']['output']>;
  soldPrice?: Maybe<Scalars['String']['output']>;
  subtype?: Maybe<Scalars['String']['output']>;
  yearBuilt?: Maybe<Scalars['Int']['output']>;
};

export type HazardhubMlsListingInteriorFinishes = {
  __typename?: 'HazardhubMlsListingInteriorFinishes';
  applianceFeatures?: Maybe<Scalars['String']['output']>;
  basement?: Maybe<Scalars['Boolean']['output']>;
  basementFeatures?: Maybe<Scalars['String']['output']>;
  cooling?: Maybe<Scalars['Boolean']['output']>;
  coolingFeatures?: Maybe<Scalars['String']['output']>;
  fireplace?: Maybe<Scalars['Boolean']['output']>;
  fireplaceFeatures?: Maybe<Scalars['String']['output']>;
  fireplaceNumber?: Maybe<Scalars['Int']['output']>;
  floorFeatures?: Maybe<Scalars['String']['output']>;
  generalFeatures?: Maybe<Scalars['String']['output']>;
  heatingFeatures?: Maybe<Scalars['String']['output']>;
  levelsFeatures?: Maybe<Scalars['String']['output']>;
  securityFeatures?: Maybe<Scalars['String']['output']>;
  securitySystem?: Maybe<Scalars['Boolean']['output']>;
  utilitiesFeatures?: Maybe<Scalars['String']['output']>;
  waterFeatures?: Maybe<Scalars['String']['output']>;
  windowFeatures?: Maybe<Scalars['String']['output']>;
};

export type HazardhubMlsListingRooms = {
  __typename?: 'HazardhubMlsListingRooms';
  bathsFull?: Maybe<Scalars['Float']['output']>;
  bathsHalf?: Maybe<Scalars['Float']['output']>;
  bathsTotal?: Maybe<Scalars['Float']['output']>;
  bedroomsTotal?: Maybe<Scalars['Float']['output']>;
  diningFeatures?: Maybe<Scalars['String']['output']>;
  family?: Maybe<Scalars['Boolean']['output']>;
  generalFeatures?: Maybe<Scalars['String']['output']>;
  kitchenFeatures?: Maybe<Scalars['String']['output']>;
  laundryFeatures?: Maybe<Scalars['String']['output']>;
  room11Features?: Maybe<Scalars['String']['output']>;
  room11Type?: Maybe<Scalars['String']['output']>;
  room13Features?: Maybe<Scalars['String']['output']>;
  room13Type?: Maybe<Scalars['String']['output']>;
  roomsTotal?: Maybe<Scalars['Float']['output']>;
};

export type HazardhubMudslideRisk = {
  __typename?: 'HazardhubMudslideRisk';
  pcl?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type HazardhubNearestFireStation = {
  __typename?: 'HazardhubNearestFireStation';
  distance?: Maybe<Scalars['Float']['output']>;
  driveDistanceFireStation?: Maybe<HazardhubDriveDistanceFireStation>;
  driveDurationUnits?: Maybe<Scalars['String']['output']>;
  driveDurationValue?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  responseArea?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  units?: Maybe<Scalars['String']['output']>;
};

export type HazardhubNearestIncident = {
  __typename?: 'HazardhubNearestIncident';
  cropDam?: Maybe<Scalars['String']['output']>;
  deaths?: Maybe<Scalars['String']['output']>;
  distanceMiles?: Maybe<Scalars['Float']['output']>;
  inches?: Maybe<Scalars['String']['output']>;
  injuries?: Maybe<Scalars['String']['output']>;
  propDam?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['String']['output']>;
};

export type HazardhubPerennialWater = {
  __typename?: 'HazardhubPerennialWater';
  answer?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type HazardhubPfa = {
  __typename?: 'HazardhubPfa';
  score?: Maybe<Scalars['String']['output']>;
  siteName?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type HazardhubPoliceStations = {
  __typename?: 'HazardhubPoliceStations';
  distance?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  numberWithin5Miles?: Maybe<Scalars['String']['output']>;
};

export type HazardhubPremiumTax = {
  __typename?: 'HazardhubPremiumTax';
  text?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type HazardhubPremiumTaxParams = {
  __typename?: 'HazardhubPremiumTaxParams';
  authTaxingAuthority?: Maybe<HazardhubValueString>;
  city?: Maybe<HazardhubValueString>;
  cityDestination?: Maybe<HazardhubValueString>;
  county?: Maybe<HazardhubValueString>;
  dateVintage?: Maybe<HazardhubValueString>;
  fips?: Maybe<HazardhubValueString>;
  fipsTaxingAuthority?: Maybe<HazardhubValueString>;
  fireZone?: Maybe<HazardhubValueString>;
  /** Geographic Name Information System Code */
  gnis?: Maybe<HazardhubValueString>;
  id?: Maybe<HazardhubValueString>;
  taxCode1?: Maybe<HazardhubValueString>;
  /** Only used for Florida */
  taxCode2?: Maybe<HazardhubValueString>;
};

export type HazardhubProperty = {
  __typename?: 'HazardhubProperty';
  address?: Maybe<Scalars['String']['output']>;
  apn?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<Scalars['String']['output']>;
  streetAddress?: Maybe<Scalars['String']['output']>;
  useCode?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type HazardhubReplacementCost = {
  __typename?: 'HazardhubReplacementCost';
  architecturalStyle?: Maybe<Scalars['String']['output']>;
  constructionQuality?: Maybe<Scalars['String']['output']>;
  constructionType?: Maybe<Scalars['String']['output']>;
  livingArea?: Maybe<HazardhubLivingArea>;
  locale?: Maybe<Scalars['String']['output']>;
  physicalShape?: Maybe<Scalars['String']['output']>;
  primaryExterior?: Maybe<Scalars['String']['output']>;
  primaryRoofCovering?: Maybe<Scalars['String']['output']>;
  replacementCost?: Maybe<Scalars['String']['output']>;
  slopeOfSite?: Maybe<Scalars['String']['output']>;
};

export type HazardhubRequest = {
  address: Scalars['String']['input'];
  city?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  /** 2 letter */
  state?: InputMaybe<Scalars['String']['input']>;
  /** Unit number of the property */
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type HazardhubResponse = {
  __typename?: 'HazardhubResponse';
  /** ID in the enrichment cache */
  cachedId: Scalars['String']['output'];
  enhancedProperty: HazardhubEnhancedProperty;
  replacementCost: HazardhubReplacementCost;
  risks: HazardhubRisks;
  savedOpportunity?: Maybe<SavedOpportunity>;
};


export type HazardhubResponseSavedOpportunityArgs = {
  producerId?: InputMaybe<Scalars['String']['input']>;
};

export type HazardhubRingParams = {
  __typename?: 'HazardhubRingParams';
  cumulative0to1Mile?: Maybe<Scalars['Float']['output']>;
  cumulative0to2Mile?: Maybe<Scalars['Float']['output']>;
  cumulative0to3Mile?: Maybe<Scalars['Float']['output']>;
  cumulative0to4Mile?: Maybe<Scalars['Float']['output']>;
  cumulative0to5Mile?: Maybe<Scalars['Float']['output']>;
  ring0to1Mile?: Maybe<Scalars['Float']['output']>;
  ring1to2Mile?: Maybe<Scalars['Float']['output']>;
  ring2to3Mile?: Maybe<Scalars['Float']['output']>;
  ring3to4Mile?: Maybe<Scalars['Float']['output']>;
  ring4to5Mile?: Maybe<Scalars['Float']['output']>;
};

export type HazardhubRiskScores = {
  __typename?: 'HazardhubRiskScores';
  base?: Maybe<Scalars['Float']['output']>;
  composite?: Maybe<Scalars['Float']['output']>;
};

export type HazardhubRiskStandartizedAddress = {
  __typename?: 'HazardhubRiskStandartizedAddress';
  address?: Maybe<Scalars['String']['output']>;
  googleMapsUrl?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locationType?: Maybe<Scalars['String']['output']>;
  /** houseNumber, city, state, etc. */
  matchLevel?: Maybe<Scalars['String']['output']>;
  /** From 0 to 1 */
  matchScore?: Maybe<Scalars['Float']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type HazardhubRisks = {
  __typename?: 'HazardhubRisks';
  aaisFireProtectionClassParams?: Maybe<HazardhubAaisFireProtectionClassParams>;
  airportNoise?: Maybe<HazardhubAirportNoise>;
  aspectRisk?: Maybe<HazardhubAspectRisk>;
  baseFloodElevation?: Maybe<HazardhubBaseFloodElevation>;
  burglary?: Maybe<HazardhubScoreTextValue>;
  cbrsParams?: Maybe<HazardhubCbrsParams>;
  coastDistance?: Maybe<HazardhubCoastDistance>;
  convectionStorm?: Maybe<HazardhubScoreWithText>;
  convectionStormPerDecade?: Maybe<HazardhubValueString>;
  crime?: Maybe<HazardhubScoreTextValue>;
  designatedFault?: Maybe<HazardhubScoreWithText>;
  distanceToSignificantFloodParams?: Maybe<HazardhubDistanceToSignificantFloodParams>;
  distanceToSignificantWildfireHazard?: Maybe<HazardhubDistanceToSignificantWfRiskParams>;
  driveDistanceFireStation?: Maybe<HazardhubDriveDistanceFireStation>;
  driveTimeFireStation?: Maybe<HazardhubDriveTimeFireStation>;
  drought?: Maybe<HazardhubScoreWithText>;
  droughtFrequencyIndex?: Maybe<HazardhubDroughtFrequencyIndex>;
  drugAlcoholDeaths?: Maybe<HazardhubScoreWithText>;
  drugAlcoholDeathsDeaths?: Maybe<HazardhubValueString>;
  drugAlcoholDeathsRate100K?: Maybe<HazardhubValueString>;
  drugAlcoholDeathsScore?: Maybe<HazardhubValueString>;
  earthquake?: Maybe<HazardhubEarthquake>;
  enhancedHailParams?: Maybe<HazardhubEnhancedHailParams>;
  enhancedHazardhubFlood?: Maybe<HazardhubScoreWithText>;
  enhancedHazardhubFloodParams?: Maybe<HazardhubEnhancedHhFloodParams>;
  enhancedHazardhubPfs?: Maybe<HazardhubEnhancedHhPfs>;
  enhancedHurricaneParams?: Maybe<HazardhubEnhancedHurricaneParams>;
  enhancedLightningParams?: Maybe<HazardhubEnhancedLightningParams>;
  enhancedTornadoParams?: Maybe<HazardhubEnhancedTornadoParams>;
  enhancedWildfire?: Maybe<HazardhubEnhancedWildfire>;
  enhancedWindParams?: Maybe<HazardhubEnhancedWindParams>;
  faultEarthquake?: Maybe<HazardhubScoreWithText>;
  femaAllFlood?: Maybe<HazardhubScoreWithText>;
  femaAllFloodParams?: Maybe<HazardhubFemaAllFloodParams>;
  femaClaims?: Maybe<HazardhubFemaClaims>;
  femaFirmDate?: Maybe<HazardhubFemaFirmDate>;
  femaFirmPanels?: Maybe<HazardhubFemaFirmPanels>;
  femaMapParams?: Maybe<HazardhubFemaMapParams>;
  fireProtection?: Maybe<HazardhubFireProtection>;
  fireSeasonPrecipitationParams?: Maybe<HazardhubFireSeasonPrecipitationParams>;
  fireStationType?: Maybe<HazardhubValueString>;
  forcibleRape?: Maybe<HazardhubScoreTextValue>;
  forcibleRobbery?: Maybe<HazardhubScoreTextValue>;
  frackingEarthquake?: Maybe<HazardhubScoreWithText>;
  frozenPipeIndex?: Maybe<HazardhubIndex>;
  groundSnowLoad?: Maybe<HazardhubGroundSnowLoad>;
  hailRingParams?: Maybe<HazardhubRingParams>;
  hardiness?: Maybe<HazardhubHardiness>;
  hazardhubCatastrophicFlood?: Maybe<HazardhubScoreWithText>;
  hazardhubCatastrophicFloodParams?: Maybe<HazardhubEnhancedHhFloodParams>;
  hazardhubElevation?: Maybe<HazardhubHhElevation>;
  hazardhubFpcCode?: Maybe<HazardhubValueString>;
  hazardhubSnowLoad?: Maybe<HazardhubHhSnowLoad>;
  hospital?: Maybe<HazardhubHospital>;
  hydrant?: Maybe<HazardhubScoreWithText>;
  hydrantParams?: Maybe<HazardhubHydrantParams>;
  iceDamIndex?: Maybe<HazardhubIndex>;
  landslide?: Maybe<HazardhubScoreWithText>;
  larceny?: Maybe<HazardhubScoreTextValue>;
  lavaFlow?: Maybe<HazardhubLavaFlow>;
  lomaParams?: Maybe<HazardhubLomaParams>;
  lomrParams?: Maybe<HazardhubLomrParams>;
  matchedAddress: HazardhubRiskStandartizedAddress;
  maxWindParams?: Maybe<HazardhubMaxWindParams>;
  mineSubsidence?: Maybe<HazardhubScoreWithText>;
  moldIndex?: Maybe<HazardhubIndex>;
  motorVehicleTheft?: Maybe<HazardhubScoreTextValue>;
  mudslideRisk?: Maybe<HazardhubMudslideRisk>;
  murder?: Maybe<HazardhubScoreTextValue>;
  nearestFireStations?: Maybe<Array<HazardhubNearestFireStation>>;
  nuclearSite?: Maybe<HazardhubScoreWithText>;
  numberOfFireStationsWithin5Miles?: Maybe<Scalars['Float']['output']>;
  numberOfFireStationsWithin10Miles?: Maybe<Scalars['Float']['output']>;
  perennialWater?: Maybe<HazardhubPerennialWater>;
  pfa?: Maybe<HazardhubPfa>;
  policeStations?: Maybe<HazardhubPoliceStations>;
  potentialCatastrophicPrecipitation?: Maybe<Scalars['String']['output']>;
  potentialMaximumPrecipitation?: Maybe<Scalars['String']['output']>;
  premiumTax?: Maybe<HazardhubPremiumTax>;
  premiumTaxParams?: Maybe<HazardhubPremiumTaxParams>;
  radon?: Maybe<HazardhubScoreWithText>;
  reTierCounties?: Maybe<HazardhubValueNumber>;
  schoolDistrict?: Maybe<HazardhubSchoolDistrict>;
  seaLevelRise?: Maybe<HazardhubSeaLevelRise>;
  sinkhole?: Maybe<HazardhubSinkhole>;
  sinkholeRingParams?: Maybe<HazardhubRingParams>;
  sinkholeRiskParams?: Maybe<HazardhubSinkholeRiskParams>;
  slopeRisk?: Maybe<HazardhubSlopeRisk>;
  soilShearVelocity?: Maybe<HazardhubSoilShearVelocity>;
  surgeMax?: Maybe<HazardhubSurgeMax>;
  tornadoRingParams?: Maybe<HazardhubRingParams>;
  tsunami?: Maybe<HazardhubScoreWithText>;
  urgentCare?: Maybe<HazardhubUrgentCare>;
  volcano?: Maybe<HazardhubScoreWithText>;
  volcanoNearest?: Maybe<HazardhubVolcanoNearest>;
  waterType?: Maybe<HazardhubValueString>;
  weatherParams?: Maybe<HazardhubWeatherParams>;
  wildfire?: Maybe<HazardhubScoreWithText>;
  wildfireDescription?: Maybe<HazardhubValueString>;
  wildfireDistanceToHighArea?: Maybe<HazardhubDistanceString>;
  wildfireHistoryParams?: Maybe<HazardhubWildfireHistoryParams>;
  wildfireHousingDensity?: Maybe<HazardhubValueNumber>;
  wildfireRisk?: Maybe<HazardhubValueString>;
  wildfireRiskScore?: Maybe<HazardhubWildfireRiskScore>;
  windBornDebris?: Maybe<HazardhubWindBornDebris>;
  windPool?: Maybe<HazardhubWindPool>;
  windRegion?: Maybe<HazardhubWindRegion>;
  windRingParams?: Maybe<HazardhubRingParams>;
};

export type HazardhubSchoolDistrict = {
  __typename?: 'HazardhubSchoolDistrict';
  name?: Maybe<Scalars['String']['output']>;
};

export type HazardhubScoreTextValue = {
  __typename?: 'HazardhubScoreTextValue';
  score?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type HazardhubScoreWithText = {
  __typename?: 'HazardhubScoreWithText';
  score?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type HazardhubSeaLevelRise = {
  __typename?: 'HazardhubSeaLevelRise';
  floodAt?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type HazardhubSinkhole = {
  __typename?: 'HazardhubSinkhole';
  distance?: Maybe<HazardhubDistanceString>;
  score?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type HazardhubSinkholeRiskParams = {
  __typename?: 'HazardhubSinkholeRiskParams';
  climate?: Maybe<Scalars['String']['output']>;
  closedDepressionGrade?: Maybe<Scalars['String']['output']>;
  closedDepressionRisk?: Maybe<Scalars['String']['output']>;
  karstType?: Maybe<Scalars['String']['output']>;
  rocktype?: Maybe<Scalars['String']['output']>;
  sinkholeDistance?: Maybe<HazardhubDistanceString>;
  sinkholePointGrade?: Maybe<Scalars['String']['output']>;
  sinkholeSusceptibilityGrade?: Maybe<Scalars['String']['output']>;
  sinkholeSusceptibilityRisk?: Maybe<Scalars['String']['output']>;
};

export type HazardhubSlopeRisk = {
  __typename?: 'HazardhubSlopeRisk';
  description?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['String']['output']>;
  slope?: Maybe<Scalars['String']['output']>;
};

export type HazardhubSoilShearVelocity = {
  __typename?: 'HazardhubSoilShearVelocity';
  units?: Maybe<Scalars['String']['output']>;
  vs30?: Maybe<Scalars['Float']['output']>;
};

export type HazardhubSurgeMax = {
  __typename?: 'HazardhubSurgeMax';
  category?: Maybe<Scalars['String']['output']>;
  category1?: Maybe<Scalars['String']['output']>;
  category2?: Maybe<Scalars['String']['output']>;
  category3?: Maybe<Scalars['String']['output']>;
  category4?: Maybe<Scalars['String']['output']>;
  desc?: Maybe<Scalars['String']['output']>;
  desc1?: Maybe<Scalars['String']['output']>;
  desc2?: Maybe<Scalars['String']['output']>;
  desc3?: Maybe<Scalars['String']['output']>;
  desc4?: Maybe<Scalars['String']['output']>;
  potentialInundationLevel?: Maybe<Scalars['String']['output']>;
  potentialInundationLevel1?: Maybe<Scalars['String']['output']>;
  potentialInundationLevel2?: Maybe<Scalars['String']['output']>;
  potentialInundationLevel3?: Maybe<Scalars['String']['output']>;
  potentialInundationLevel4?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type HazardhubUrgentCare = {
  __typename?: 'HazardhubUrgentCare';
  address?: Maybe<Scalars['String']['output']>;
  distance?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type HazardhubValuation = {
  __typename?: 'HazardhubValuation';
  priceRangeMax?: Maybe<Scalars['Float']['output']>;
  priceRangeMin?: Maybe<Scalars['Float']['output']>;
};

export type HazardhubValueNumber = {
  __typename?: 'HazardhubValueNumber';
  value?: Maybe<Scalars['String']['output']>;
};

export type HazardhubValueString = {
  __typename?: 'HazardhubValueString';
  value?: Maybe<Scalars['String']['output']>;
};

export type HazardhubVegetationBurnSiteRisk = {
  __typename?: 'HazardhubVegetationBurnSiteRisk';
  desc?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  withinHalfMile?: Maybe<Scalars['Float']['output']>;
  withinOneMile?: Maybe<Scalars['Float']['output']>;
};

export type HazardhubVolcanoNearest = {
  __typename?: 'HazardhubVolcanoNearest';
  volcanoDistance?: Maybe<HazardhubDistanceString>;
  volcanoElev?: Maybe<HazardhubValueString>;
  volcanoName?: Maybe<HazardhubValueString>;
  volcanoStatus?: Maybe<HazardhubValueString>;
  volcanoType?: Maybe<HazardhubValueString>;
};

export type HazardhubWeatherParams = {
  __typename?: 'HazardhubWeatherParams';
  annualAverageDaysLessThan0?: Maybe<Scalars['String']['output']>;
  annualAverageDaysLessThan10?: Maybe<Scalars['String']['output']>;
  annualAverageDaysLessThan20?: Maybe<Scalars['String']['output']>;
  annualAverageDaysMoreThan40?: Maybe<Scalars['String']['output']>;
  annualAverageDaysMoreThan50?: Maybe<Scalars['String']['output']>;
  annualFallDaysLessThan0?: Maybe<Scalars['String']['output']>;
  annualFallDaysLessThan10?: Maybe<Scalars['String']['output']>;
  annualFallDaysLessThan20?: Maybe<Scalars['String']['output']>;
  annualFallDaysLessThan32?: Maybe<Scalars['String']['output']>;
  annualSpringDaysLessThan0?: Maybe<Scalars['String']['output']>;
  annualSpringDaysLessThan10?: Maybe<Scalars['String']['output']>;
  annualSpringDaysLessThan20?: Maybe<Scalars['String']['output']>;
  annualSpringDaysLessThan32?: Maybe<Scalars['String']['output']>;
  annualWinterDaysLessThan0?: Maybe<Scalars['String']['output']>;
  annualWinterDaysLessThan10?: Maybe<Scalars['String']['output']>;
  annualWinterDaysLessThan20?: Maybe<Scalars['String']['output']>;
  annualWinterDaysLessThan40?: Maybe<Scalars['String']['output']>;
  averageAnnualPrecipitation?: Maybe<Scalars['String']['output']>;
  averageAnnualSnowfall?: Maybe<Scalars['String']['output']>;
  averageAnnualTemperatureMax?: Maybe<Scalars['String']['output']>;
  averageAnnualTemperatureMin?: Maybe<Scalars['String']['output']>;
  averageDaysSnowfallGreaterThan1Inch?: Maybe<Scalars['String']['output']>;
  averageDaysSnowfallGreaterThan10Inches?: Maybe<Scalars['String']['output']>;
  averageFallSnowfall?: Maybe<Scalars['String']['output']>;
  averageSpringSnowfall?: Maybe<Scalars['String']['output']>;
  averageWinterSnowfall?: Maybe<Scalars['String']['output']>;
  avgDaysSnowDepthAbove10In?: Maybe<Scalars['String']['output']>;
  avgDaysSnowfallAbove1In?: Maybe<Scalars['String']['output']>;
  avgNumDaysBelow32Degrees?: Maybe<Scalars['String']['output']>;
  avgNumWinterDaysBelow32Degrees?: Maybe<Scalars['String']['output']>;
  coolingDegreeDays?: Maybe<Scalars['String']['output']>;
  fallDaysSnowDepthGreaterThan1Inch?: Maybe<Scalars['String']['output']>;
  fallDaysSnowDepthGreaterThan3Inches?: Maybe<Scalars['String']['output']>;
  fallDaysSnowDepthGreaterThan5Inches?: Maybe<Scalars['String']['output']>;
  fallDaysSnowDepthGreaterThan10Inches?: Maybe<Scalars['String']['output']>;
  fallDaysWithMaxTempLessThan32?: Maybe<Scalars['String']['output']>;
  fallDiurnalRange?: Maybe<Scalars['String']['output']>;
  heatingDegreeDays?: Maybe<Scalars['String']['output']>;
  springDaysSnowDepthGreaterThan1Inch?: Maybe<Scalars['String']['output']>;
  springDaysSnowDepthGreaterThan3Inches?: Maybe<Scalars['String']['output']>;
  springDaysSnowDepthGreaterThan5Inches?: Maybe<Scalars['String']['output']>;
  springDaysSnowDepthGreaterThan10Inches?: Maybe<Scalars['String']['output']>;
  springDaysWithMaxTempLessThan32?: Maybe<Scalars['String']['output']>;
  springDiurnalRange?: Maybe<Scalars['String']['output']>;
  winterDaysSnowDepthGreaterThan1Inches?: Maybe<Scalars['String']['output']>;
  winterDaysSnowDepthGreaterThan3Inches?: Maybe<Scalars['String']['output']>;
  winterDaysSnowDepthGreaterThan5Inches?: Maybe<Scalars['String']['output']>;
  winterDaysSnowDepthGreaterThan10Inches?: Maybe<Scalars['String']['output']>;
  winterDaysWithMaxTempLessThan32?: Maybe<Scalars['String']['output']>;
  winterDiurnalRange?: Maybe<Scalars['String']['output']>;
};

export type HazardhubWildfireHistoryParams = {
  __typename?: 'HazardhubWildfireHistoryParams';
  numberOfWildfires?: Maybe<Scalars['Float']['output']>;
  numberOfWildfiresNear?: Maybe<Scalars['Float']['output']>;
  risk?: Maybe<Scalars['String']['output']>;
  yearName?: Maybe<Scalars['String']['output']>;
  yearNameDistance?: Maybe<Scalars['String']['output']>;
};

export type HazardhubWildfirePerimeterRisk = {
  __typename?: 'HazardhubWildfirePerimeterRisk';
  desc?: Maybe<Scalars['String']['output']>;
  proximateWildfirePerimeters?: Maybe<Array<Scalars['String']['output']>>;
  score?: Maybe<Scalars['Float']['output']>;
};

export type HazardhubWildfireRiskScore = {
  __typename?: 'HazardhubWildfireRiskScore';
  composite?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type HazardhubWindBornDebris = {
  __typename?: 'HazardhubWindBornDebris';
  score?: Maybe<Scalars['String']['output']>;
  terrain?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  year2001?: Maybe<HazardhubScoreWithText>;
  year2007?: Maybe<HazardhubScoreWithText>;
  year2010?: Maybe<HazardhubScoreWithText>;
  year2014?: Maybe<HazardhubScoreWithText>;
};

export type HazardhubWindPool = {
  __typename?: 'HazardhubWindPool';
  name?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type HazardhubWindRegion = {
  __typename?: 'HazardhubWindRegion';
  score?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  text2?: Maybe<Scalars['String']['output']>;
};

export enum InclusionDateType {
  /** By policy expiration (end or cancel) date */
  Expiration = 'EXPIRATION',
  /** By policy effective (start) date */
  Inception = 'INCEPTION',
  /** By transaction dates */
  Transaction = 'TRANSACTION'
}

export type IndexDocumentsItemInput = {
  filename: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export type Industries = {
  __typename?: 'Industries';
  /**
   * Returns only low-level industries
   * @deprecated Use paginated instead
   */
  list: Array<Industry>;
  /** Returns only low-level industries */
  paginated: IndustryPaginatedResult;
  /** Returns all industries groups with children */
  tree: Array<Industry>;
};


export type IndustriesListArgs = {
  pagination?: InputMaybe<IndustryListPaginationInput>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type IndustriesPaginatedArgs = {
  pagination?: InputMaybe<IndustryListPaginationInput>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type Industry = {
  __typename?: 'Industry';
  children?: Maybe<Array<Industry>>;
  id: Scalars['ID']['output'];
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  level: IndustryLevel;
  metrics?: Maybe<EntityMetrics>;
  naics: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parent?: Maybe<Industry>;
  /** @deprecated use sicCodes */
  sic?: Maybe<Array<Scalars['String']['output']>>;
  sicCodes?: Maybe<Array<SicCode>>;
};

/** Industries inside one IndustryFilter are filtered using OR logic */
export type IndustryFilter = {
  industryGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  industryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  industrySubGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type IndustryFilterOutput = {
  __typename?: 'IndustryFilterOutput';
  industryGroupIds?: Maybe<Array<Scalars['String']['output']>>;
  industryIds?: Maybe<Array<Scalars['String']['output']>>;
  industrySubGroupIds?: Maybe<Array<Scalars['String']['output']>>;
};

export enum IndustryLevel {
  Group = 'GROUP',
  Industry = 'INDUSTRY',
  SubGroup = 'SUB_GROUP'
}

export type IndustryListPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<IndustrySortingField>;
  /** Total count will be different if we use sorting by metric with permissions */
  sortOrder?: InputMaybe<SortOrder>;
};

export type IndustryPaginatedResult = {
  __typename?: 'IndustryPaginatedResult';
  items: Array<Industry>;
  totalHits: Scalars['Int']['output'];
};

export type IndustryRank = {
  __typename?: 'IndustryRank';
  filter?: Maybe<Scalars['String']['output']>;
  metricType?: Maybe<Scalars['String']['output']>;
};

export type IndustryRankEdge = {
  __typename?: 'IndustryRankEdge';
  filter?: Maybe<Scalars['String']['output']>;
  metricType?: Maybe<Scalars['String']['output']>;
};

export enum IndustrySortingField {
  Commission = 'COMMISSION',
  Id = 'ID',
  Name = 'NAME',
  Premium = 'PREMIUM',
  Revenue = 'REVENUE'
}

export enum InsuranceCompanyMappingSortBy {
  AdminCompanyName = 'ADMIN_COMPANY_NAME',
  AdminCompanyParentName = 'ADMIN_COMPANY_PARENT_NAME',
  AdminCompanyPrimaryRole = 'ADMIN_COMPANY_PRIMARY_ROLE',
  AdminCompanyUltimateParentName = 'ADMIN_COMPANY_ULTIMATE_PARENT_NAME',
  ExternalSystemUiLabel = 'EXTERNAL_SYSTEM_UI_LABEL',
  Id = 'ID',
  LinkedWithAdminCompany = 'LINKED_WITH_ADMIN_COMPANY',
  MappingCompanyType = 'MAPPING_COMPANY_TYPE',
  MappingName = 'MAPPING_NAME',
  MappingRegion = 'MAPPING_REGION',
  NumberOfPolicies = 'NUMBER_OF_POLICIES'
}

export enum InsuranceCompanyRelationshipType {
  Carrier = 'CARRIER',
  Intermediary = 'INTERMEDIARY'
}

export type InsuranceCompanySearchMapping = {
  __typename?: 'InsuranceCompanySearchMapping';
  companyName?: Maybe<Scalars['String']['output']>;
  companyType?: Maybe<InsuranceCompanyType>;
  externalSystemLabel: Scalars['String']['output'];
  id: Scalars['String']['output'];
  linkedWithAdmin: Scalars['Boolean']['output'];
  manualChangeInProgress: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  parentName?: Maybe<Scalars['String']['output']>;
  policyCount: Scalars['Float']['output'];
  primaryRole?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  ultimateParentName?: Maybe<Scalars['String']['output']>;
};

export type InsuranceCompanySearchMappingPagination = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<InsuranceCompanyMappingSortBy>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type InsuranceCompanySearchMappingResponse = {
  __typename?: 'InsuranceCompanySearchMappingResponse';
  items: Array<InsuranceCompanySearchMapping>;
  totalHits: Scalars['Int']['output'];
};

export type InsuranceCompanySearchUsedAdminCompaniesPagination = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type InsuranceCompanySearchUsedAdminCompaniesResponse = {
  __typename?: 'InsuranceCompanySearchUsedAdminCompaniesResponse';
  items: Array<UsedAdminCompanyWithChildren>;
  totalHits: Scalars['Int']['output'];
};

export enum InsuranceCompanyType {
  Broker = 'BROKER',
  Company = 'COMPANY'
}

export type IntegrationLimitInfo = {
  __typename?: 'IntegrationLimitInfo';
  calls: Scalars['Float']['output'];
  limit: Scalars['Float']['output'];
};

export type IntegrationResponseFavoritesStatus = {
  __typename?: 'IntegrationResponseFavoritesStatus';
  isFavorite: Scalars['Boolean']['output'];
  updated?: Maybe<Scalars['Timestamp']['output']>;
};

export enum IntegrationServiceName {
  Dnb = 'DNB',
  Fenris = 'FENRIS',
  Hazardhub = 'HAZARDHUB',
  RocketReach = 'ROCKET_REACH'
}

export type Integrations = {
  __typename?: 'Integrations';
  companies: Array<DnbSuggestion>;
  companyById: DnbCompany;
  companyByIndustry: DnbCompaniesByIndustryResponse;
  dolCompanies: DolCompanySearchResult;
  dolCompanyByFein?: Maybe<DolCompany>;
  dolCompanyMatch?: Maybe<DolCompany>;
  /** @deprecated Use dolCompanies instead */
  dolCompanySearch: DolCompanySearchResult;
  form5500ByFein: Array<Form5500>;
  form5500Search: Form5500SearchResponse;
  /** Overall limit for hazardhub */
  hazardhubLimit: IntegrationLimitInfo;
  home?: Maybe<HazardhubResponse>;
  homeCached?: Maybe<HazardhubCachedResponse>;
  isIntegrationResponseInFavorites: IntegrationResponseFavoritesStatus;
  /** Monthly limit for all services */
  monthlyLimit: IntegrationLimitInfo;
  rocketReachPeople: RocketReachSearchResult;
  rocketReachPersonById?: Maybe<RocketReachPerson>;
  rocketReachPersonByIdCached?: Maybe<RocketReachPersonCached>;
  searchClient: Array<ClientSearchItemResponse>;
};


export type IntegrationsCompaniesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  request: DnbCompanyRequest;
};


export type IntegrationsCompanyByIdArgs = {
  id: Scalars['ID']['input'];
};


export type IntegrationsCompanyByIndustryArgs = {
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  request: DnbCompaniesByIndustryRequest;
  sortBy?: InputMaybe<DnbCriteriaSearchSorting>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type IntegrationsDolCompaniesArgs = {
  pagination?: InputMaybe<SimplePagination>;
  request: DolCompanySearchRequest;
};


export type IntegrationsDolCompanyByFeinArgs = {
  fein: Scalars['String']['input'];
};


export type IntegrationsDolCompanyMatchArgs = {
  name: Scalars['String']['input'];
  state: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};


export type IntegrationsDolCompanySearchArgs = {
  request: Form5500SearchRequest;
};


export type IntegrationsForm5500ByFeinArgs = {
  fein: Scalars['String']['input'];
};


export type IntegrationsForm5500SearchArgs = {
  pagination?: InputMaybe<Form5500SearchPagination>;
  request: Form5500SearchRequest;
};


export type IntegrationsHomeArgs = {
  request: HazardhubRequest;
};


export type IntegrationsHomeCachedArgs = {
  request: HazardhubRequest;
};


export type IntegrationsIsIntegrationResponseInFavoritesArgs = {
  integrationResponseId: Scalars['ID']['input'];
  service: IntegrationServiceName;
};


export type IntegrationsRocketReachPeopleArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query: RocketReachQuery;
};


export type IntegrationsRocketReachPersonByIdArgs = {
  id: Scalars['ID']['input'];
};


export type IntegrationsRocketReachPersonByIdCachedArgs = {
  id: Scalars['ID']['input'];
};


export type IntegrationsSearchClientArgs = {
  request: Array<ClientSearchRequest>;
};

export enum IntermediaryLevel {
  ChildIntermediary = 'CHILD_INTERMEDIARY',
  ParentIntermediary = 'PARENT_INTERMEDIARY',
  UltimateParentIntermediary = 'ULTIMATE_PARENT_INTERMEDIARY'
}

export type KpiDashboard = {
  __typename?: 'KpiDashboard';
  created: Scalars['Timestamp']['output'];
  datasourceType?: Maybe<DatasourceType>;
  expandChart?: Maybe<Scalars['Boolean']['output']>;
  expandMetrics?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  period?: Maybe<UserKpiPeriod>;
  sections: Array<KpiDashboardSection>;
  title: Scalars['String']['output'];
  updated: Scalars['Timestamp']['output'];
};

export type KpiDashboardCreateInput = {
  datasourceType?: InputMaybe<DatasourceType>;
  expandChart?: InputMaybe<Scalars['Boolean']['input']>;
  expandMetrics?: InputMaybe<Scalars['Boolean']['input']>;
  period?: InputMaybe<UserKpiPeriodInput>;
  sections: Array<KpiDashboardSectionCreateInput>;
  title: Scalars['String']['input'];
};

export type KpiDashboardSection = {
  __typename?: 'KpiDashboardSection';
  collapsed: Scalars['Boolean']['output'];
  created: Scalars['Timestamp']['output'];
  id: Scalars['String']['output'];
  kpiList: Array<UserKpi>;
  title: Scalars['String']['output'];
  /** @deprecated Not supported on section level - use dashboard updated */
  updated: Scalars['Timestamp']['output'];
};

export type KpiDashboardSectionCreateInput = {
  collapsed: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
  kpiList: Array<UserKpiDashboardCreateKpiInput>;
  title: Scalars['String']['input'];
};

export type KpiDashboardUpdateInput = {
  datasourceType?: InputMaybe<DatasourceType>;
  expandChart?: InputMaybe<Scalars['Boolean']['input']>;
  expandMetrics?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  period?: InputMaybe<UserKpiPeriodInput>;
  sections: Array<KpiDashboardSectionCreateInput>;
  title: Scalars['String']['input'];
};

export type KpiWidgetParams = {
  __typename?: 'KpiWidgetParams';
  entity?: Maybe<UserKpiEntity>;
  entityDeclaration?: Maybe<UserKpiEntityDeclaration>;
  filteringMode: UserKpiFilteringMode;
  metric: UserKpiMetric;
  name?: Maybe<Scalars['String']['output']>;
  period?: Maybe<UserKpiPeriod>;
  policyStatus?: Maybe<Array<UserKpiPolicyStatus>>;
};

export type KpiWidgetParamsInput = {
  entityDeclaration?: InputMaybe<UserKpiEntityDeclarationInput>;
  filteringMode: UserKpiFilteringMode;
  metric: UserKpiMetric;
  name?: InputMaybe<Scalars['String']['input']>;
  period?: InputMaybe<UserKpiPeriodInput>;
  policyStatus?: InputMaybe<Array<UserKpiPolicyStatus>>;
};

export enum LeaderboardReportEntity {
  AccountExecutive = 'ACCOUNT_EXECUTIVE',
  AccountManager = 'ACCOUNT_MANAGER',
  Carrier = 'CARRIER',
  Department = 'DEPARTMENT',
  Industry = 'INDUSTRY',
  IndustryGroup = 'INDUSTRY_GROUP',
  IndustrySubgroup = 'INDUSTRY_SUBGROUP',
  PayTo = 'PAY_TO',
  Producer = 'PRODUCER',
  Product = 'PRODUCT'
}

export enum LeaderboardReportMetric {
  Premium = 'PREMIUM',
  Revenue = 'REVENUE'
}

export type LeaderboardWidgetParams = {
  __typename?: 'LeaderboardWidgetParams';
  carrierLevel?: Maybe<CarrierLevel>;
  entity: WidgetEntity;
  entityKeys?: Maybe<Array<WidgetEntity>>;
  filter?: Maybe<PolicyFilterOutput>;
  radioValue?: Maybe<Scalars['String']['output']>;
  sortMetric?: Maybe<PolicyMetric>;
};

export type LeaderboardWidgetParamsInput = {
  carrierLevel?: InputMaybe<CarrierLevel>;
  entity: WidgetEntity;
  entityKeys?: InputMaybe<Array<WidgetEntity>>;
  filter?: InputMaybe<PolicyFilter>;
  radioValue?: InputMaybe<Scalars['String']['input']>;
  sortMetric?: InputMaybe<PolicyMetric>;
};

export type Lifetime = {
  __typename?: 'Lifetime';
  metrics: LifetimeValueMetrics;
  paginatedClients: LifetimeAccountsPaginatedResult;
  paginatedIndustries: LifetimeIndustriesPaginatedResult;
};


export type LifetimeMetricsArgs = {
  filter: PolicyFilter;
  timestamp?: InputMaybe<Scalars['SimpleDate']['input']>;
};


export type LifetimePaginatedClientsArgs = {
  filter: PolicyFilter;
  pagination?: InputMaybe<LifetimeAccountsPaginationInput>;
  timestamp?: InputMaybe<Scalars['SimpleDate']['input']>;
};


export type LifetimePaginatedIndustriesArgs = {
  filter: PolicyFilter;
  pagination?: InputMaybe<LifetimeIndustriesPaginationInput>;
  timestamp?: InputMaybe<Scalars['SimpleDate']['input']>;
};

export type LifetimeAccount = {
  __typename?: 'LifetimeAccount';
  account: Client;
  /**
   * Account ID
   * @deprecated Use account field resolver
   */
  accountId?: Maybe<Scalars['String']['output']>;
  /** Account lifetime revenue */
  accountLifetimeRevenue: Scalars['Float']['output'];
  /**
   * Account name
   * @deprecated Use account field resolver
   */
  accountName?: Maybe<Scalars['String']['output']>;
  /** Gross margin for the account (0-1) */
  grossMargin: Scalars['Float']['output'];
  /** Industry ID */
  industryId?: Maybe<Scalars['String']['output']>;
  /** Industry level */
  industryLevel?: Maybe<Scalars['String']['output']>;
  /** Industry name */
  industryName?: Maybe<Scalars['String']['output']>;
  /** Industry NAICS */
  naics?: Maybe<Scalars['String']['output']>;
  /** Total costs for the account */
  totalCosts: Scalars['Float']['output'];
};

export type LifetimeAccountsPaginatedResult = {
  __typename?: 'LifetimeAccountsPaginatedResult';
  items: Array<LifetimeAccount>;
  totalHits: Scalars['Int']['output'];
};

export type LifetimeAccountsPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy: LifetimeAccountsSortingField;
  /** Total count will be different if we use sorting by metric with permissions */
  sortOrder?: InputMaybe<SortOrder>;
};

export enum LifetimeAccountsSortingField {
  AccountLifetimeRevenue = 'ACCOUNT_LIFETIME_REVENUE',
  GrossMargin = 'GROSS_MARGIN',
  TotalCosts = 'TOTAL_COSTS'
}

export type LifetimeIndustriesPaginatedResult = {
  __typename?: 'LifetimeIndustriesPaginatedResult';
  items: Array<LifetimeIndustry>;
  totalHits: Scalars['Int']['output'];
};

export type LifetimeIndustriesPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy: LifetimeIndustriesSortingField;
  /** Total count will be different if we use sorting by metric with permissions */
  sortOrder?: InputMaybe<SortOrder>;
};

export enum LifetimeIndustriesSortingField {
  AvgAccountLifetimeRevenue = 'AVG_ACCOUNT_LIFETIME_REVENUE',
  AvgExpectedLifespan = 'AVG_EXPECTED_LIFESPAN',
  AvgTotalCosts = 'AVG_TOTAL_COSTS',
  ChurnRate = 'CHURN_RATE',
  GrossMargin = 'GROSS_MARGIN',
  LifetimeValue = 'LIFETIME_VALUE'
}

export type LifetimeIndustry = {
  __typename?: 'LifetimeIndustry';
  /** Avg by account lifetime revenue */
  avgAccountLifetimeRevenue: Scalars['Float']['output'];
  /** Average expected lifespan in years, like 1.5 = 1 year and 6 months */
  avgExpectedLifespan: Scalars['Float']['output'];
  /** Avg by account total cost */
  avgTotalCosts: Scalars['Float']['output'];
  /** Churn rate by account (0-1) */
  churnRate: Scalars['Float']['output'];
  /** Gross margin for the industry (0-1) */
  grossMargin: Scalars['Float']['output'];
  /** Industry ID */
  industryId: Scalars['String']['output'];
  /** Industry level */
  industryLevel: Scalars['String']['output'];
  /** Industry name */
  industryName: Scalars['String']['output'];
  /** Used default churn rate */
  isDefaultChurnRate: Scalars['Boolean']['output'];
  /** Account LTV by industry */
  lifetimeValue: Scalars['Float']['output'];
  /** Industry NAICS */
  naics?: Maybe<Scalars['String']['output']>;
};

/** Lifetime metrics for multiple accounts */
export type LifetimeValueMetrics = {
  __typename?: 'LifetimeValueMetrics';
  /** Average expected lifespan in years, like 1.5 = 1 year and 6 months */
  avgExpectedLifespan: Scalars['Float']['output'];
  /** Avg lifetime revenue by accounts */
  avgLifetimeRevenue: Scalars['Float']['output'];
  /** Avg by costs for accounts */
  avgTotalCost: Scalars['Float']['output'];
  /** Churn rate for accounts (0-1) */
  churnRate: Scalars['Float']['output'];
  /** Gross margin for accounts (0-1) */
  grossMargin: Scalars['Float']['output'];
  /** Used default churn rate */
  isDefaultChurnRate: Scalars['Boolean']['output'];
  /** LTV for accounts */
  lifetimeValue: Scalars['Float']['output'];
  /** Total account(s) costs */
  totalCost: Scalars['Float']['output'];
  /** Sum lifetime revenue by accounts */
  totalLifetimeRevenue: Scalars['Float']['output'];
};

export type ListProductsMappingResponse = {
  __typename?: 'ListProductsMappingResponse';
  items: Array<CommandProductMapping>;
  totalHits: Scalars['Int']['output'];
};

export type ListsOfSavedOpportunityUpdateResult = {
  __typename?: 'ListsOfSavedOpportunityUpdateResult';
  updated: Array<SavedOpportunity>;
};

/** Use OR logic between counties/states. Postal codes must be provided if radius is used */
export type LocationFilter = {
  counties?: InputMaybe<Array<Scalars['String']['input']>>;
  postalCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  postalCodesRadius?: InputMaybe<LocationRadius>;
  states?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type LocationFilterOutput = {
  __typename?: 'LocationFilterOutput';
  counties?: Maybe<Array<Scalars['String']['output']>>;
  postalCodes?: Maybe<Array<Scalars['String']['output']>>;
  postalCodesRadius?: Maybe<LocationRadiusOutput>;
  states?: Maybe<Array<Scalars['String']['output']>>;
};

export type LocationRadius = {
  /** Search radius around specified location */
  radius: Scalars['Float']['input'];
  /** Unit of measurement for the radius */
  unit: LocationRadiusUnit;
};

export type LocationRadiusOutput = {
  __typename?: 'LocationRadiusOutput';
  /** Search radius around specified location */
  radius: Scalars['Float']['output'];
  /** Unit of measurement for the radius */
  unit: LocationRadiusUnit;
};

export enum LocationRadiusUnit {
  Kilometers = 'KILOMETERS',
  Miles = 'MILES'
}

export enum LossRunFolderStatus {
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  InUploading = 'IN_UPLOADING',
  ReadyForProcessing = 'READY_FOR_PROCESSING',
  Success = 'SUCCESS',
  UserInputRequired = 'USER_INPUT_REQUIRED'
}

export enum LossRunStatus {
  InProgress = 'IN_PROGRESS',
  Success = 'SUCCESS'
}

export type LossRuns = {
  __typename?: 'LossRuns';
  batchInfoUrl?: Maybe<Scalars['String']['output']>;
  filesList: Array<LossRunsFile>;
  folderData: LossRunsFolder;
  foldersList: Array<LossRunsFolder>;
  /** Returns NULL if tenant isn't Loss Runs client */
  remainingPages?: Maybe<Scalars['Float']['output']>;
  sharedBatchList: Array<SharedBatch>;
  /** Returns NULL if tenant isn't Loss Runs subscription client */
  subscriptionStatus?: Maybe<LossRunsSubscriptionPayload>;
};


export type LossRunsBatchInfoUrlArgs = {
  folderId: Scalars['String']['input'];
  shared?: InputMaybe<Scalars['Boolean']['input']>;
};


export type LossRunsFilesListArgs = {
  folderId: Scalars['String']['input'];
  shared?: InputMaybe<Scalars['Boolean']['input']>;
};


export type LossRunsFolderDataArgs = {
  folderId: Scalars['String']['input'];
  shared?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LossRunsFile = {
  __typename?: 'LossRunsFile';
  /** Optionally provided if error is specified in admin panel */
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  status: LossRunStatus;
  uploadedAt: Scalars['Timestamp']['output'];
  url: Scalars['String']['output'];
};

export type LossRunsFileUrl = {
  __typename?: 'LossRunsFileUrl';
  file: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type LossRunsFolder = {
  __typename?: 'LossRunsFolder';
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** Exists when status is SUCCESS */
  reportDownloadUrl?: Maybe<Scalars['String']['output']>;
  status: LossRunFolderStatus;
};

export enum LossRunsIntentType {
  Payment = 'PAYMENT',
  Setup = 'SETUP'
}

export type LossRunsPolicyUserInput = {
  carrierName?: InputMaybe<Scalars['String']['input']>;
  insuredName?: InputMaybe<Scalars['String']['input']>;
  lineOfBusiness?: InputMaybe<Scalars['String']['input']>;
  policyNumber?: InputMaybe<Scalars['String']['input']>;
  premium?: InputMaybe<Scalars['Float']['input']>;
};

export type LossRunsSubscribePayload = {
  __typename?: 'LossRunsSubscribePayload';
  clientSecret: Scalars['String']['output'];
  intentType: LossRunsIntentType;
};

export type LossRunsSubscriptionPayload = {
  __typename?: 'LossRunsSubscriptionPayload';
  /** Returns the end of the current period if the user has canceled their subscription */
  endsAt?: Maybe<Scalars['SimpleDate']['output']>;
  status: LossRunsSubscriptionStatus;
};

export enum LossRunsSubscriptionStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Inactive = 'INACTIVE'
}

export type LossRunsUserInput = {
  /** File ID where the user input is required */
  fileId: Scalars['String']['input'];
  input: LossRunsPolicyUserInput;
  /** Index of the policy in the array we are placing the user input */
  policyIndex: Scalars['Float']['input'];
};

export type LostWidgetParams = {
  __typename?: 'LostWidgetParams';
  entity: WidgetEntity;
  entityKeys?: Maybe<Array<WidgetEntity>>;
  filter?: Maybe<PolicyFilterOutput>;
  radioValue?: Maybe<Scalars['String']['output']>;
};

export type LostWidgetParamsInput = {
  entity: WidgetEntity;
  entityKeys?: InputMaybe<Array<WidgetEntity>>;
  filter?: InputMaybe<PolicyFilter>;
  radioValue?: InputMaybe<Scalars['String']['input']>;
};

export type Market = {
  __typename?: 'Market';
  adminCompany?: Maybe<AdminCompany>;
  availableViewModes: Array<CompanyViewType>;
  children: Array<Market>;
  /**
   * Possible values: 1, 2, 3. The Issuing Paper level has value 1.
   * Numeration from Issuing Paper to Ultimate
   */
  companyLevel: Scalars['Int']['output'];
  companyStatus: BrokerMarketStatus;
  companyType: MarketCompanyType;
  id: Scalars['ID']['output'];
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  metrics?: Maybe<EntityMetrics>;
  mode?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  parent?: Maybe<Market>;
  primaryAddress?: Maybe<Address>;
  /** @deprecated Use availableViewModes instead */
  primaryRole?: Maybe<CompanyPrimaryRole>;
  /** @deprecated AM Best data is no longer maintained (data provider contract ended). */
  rating?: Maybe<CompanyRating>;
  ultimateParent?: Maybe<Market>;
};


export type MarketChildrenArgs = {
  primaryRole?: InputMaybe<CompanyPrimaryRole>;
  viewMode?: InputMaybe<CompanyViewType>;
};

export enum MarketCompanyType {
  Carrier = 'CARRIER',
  Retailer = 'RETAILER'
}

export type MarketListPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<CarrierSortingField>;
  /** Total count will be different if we use sorting by metric with permissions */
  sortOrder?: InputMaybe<SortOrder>;
};

export type MarketMonolineRatio = {
  __typename?: 'MarketMonolineRatio';
  carrier: Market;
  metrics: MonolineRatioMetrics;
};

export type MarketMonolineRatioWithStats = {
  __typename?: 'MarketMonolineRatioWithStats';
  items: Array<MarketMonolineRatio>;
  statistics?: Maybe<MonolineRatioStatistics>;
};

export type MarketPaginatedResult = {
  __typename?: 'MarketPaginatedResult';
  items: Array<Market>;
  totalHits: Scalars['Int']['output'];
};

export type Markets = {
  __typename?: 'Markets';
  list: Array<Market>;
  /** @deprecated Please use `list` instead */
  paginated: MarketPaginatedResult;
};


export type MarketsListArgs = {
  primaryRole?: InputMaybe<CompanyPrimaryRole>;
  viewMode?: InputMaybe<CompanyViewType>;
};


export type MarketsPaginatedArgs = {
  pagination?: InputMaybe<MarketListPaginationInput>;
  primaryRole?: InputMaybe<CompanyPrimaryRole>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsWidgetParams = {
  __typename?: 'MetricsWidgetParams';
  entity?: Maybe<PolicyEntity>;
  filter?: Maybe<PolicyFilterOutput>;
};

export type MetricsWidgetParamsInput = {
  entity?: InputMaybe<PolicyEntity>;
  filter?: InputMaybe<PolicyFilter>;
};

export type MgaDataByEntity = {
  __typename?: 'MgaDataByEntity';
  byCarrier: Array<MgaMetricsByCarrier>;
  byDepartment: Array<MgaMetricsByDepartment>;
  byProducer: Array<MgaMetricsByProducer>;
  byProduct: Array<MgaMetricsByProduct>;
  byRetailAgency: Array<MgaMetricsByRetailAgency>;
};


export type MgaDataByEntityByCarrierArgs = {
  filter: PolicyFilter;
  pagination?: InputMaybe<MgaDataPaginationInput>;
};


export type MgaDataByEntityByDepartmentArgs = {
  filter: PolicyFilter;
  pagination?: InputMaybe<MgaDataPaginationInput>;
};


export type MgaDataByEntityByProducerArgs = {
  filter: PolicyFilter;
  pagination?: InputMaybe<MgaDataPaginationInput>;
};


export type MgaDataByEntityByProductArgs = {
  filter: PolicyFilter;
  pagination?: InputMaybe<MgaDataPaginationInput>;
};


export type MgaDataByEntityByRetailAgencyArgs = {
  filter: PolicyFilter;
  pagination?: InputMaybe<MgaDataPaginationInput>;
};

export type MgaDataPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<MgaDataSortingField>;
  sortOrder?: InputMaybe<SortOrder>;
};

export enum MgaDataSortingField {
  CarrierCount = 'CARRIER_COUNT',
  PolicyCount = 'POLICY_COUNT',
  Premium = 'PREMIUM',
  ProducerCount = 'PRODUCER_COUNT',
  ProductCount = 'PRODUCT_COUNT',
  RetailAgencyCount = 'RETAIL_AGENCY_COUNT',
  Revenue = 'REVENUE'
}

export enum MgaLeaderboardReportEntity {
  Carrier = 'CARRIER',
  Department = 'DEPARTMENT',
  Producer = 'PRODUCER',
  Product = 'PRODUCT',
  RetailAgency = 'RETAIL_AGENCY'
}

export type MgaMetrics = {
  __typename?: 'MgaMetrics';
  /** The total amount of the bounded submissions */
  boundedSubmissions: Scalars['Int']['output'];
  /** The count of distinct carriers for bound submissions */
  carrierCount: Scalars['Int']['output'];
  /** The total count of distinct policies */
  policyCount: Scalars['Int']['output'];
  premium: Scalars['Float']['output'];
  /** The count of distinct producers */
  producerCount: Scalars['Int']['output'];
  /** The count of distinct products for bound submissions */
  productCount: Scalars['Int']['output'];
  /** The total amount of the quotes */
  quoteCount: Scalars['Int']['output'];
  /** The total amount of the quoted submissions */
  quotedSubmissions: Scalars['Int']['output'];
  /** Quoted submissions to bound ratio in percentage where 1 = 100% */
  quotedToBindRatio: Scalars['Float']['output'];
  /** The total amount of the submissions */
  received: Scalars['Int']['output'];
  /** Received submissions to bound ratio in percentage where 1 = 100% */
  receivedToBindRatio: Scalars['Float']['output'];
  /** Received submissions to quoted ratio in percentage where 1 = 100% */
  receivedToQuotedRatio: Scalars['Float']['output'];
  /** The count of distinct retail agencies */
  retailAgencyCount: Scalars['Int']['output'];
  revenue: Scalars['Float']['output'];
};

export type MgaMetricsByCarrier = {
  __typename?: 'MgaMetricsByCarrier';
  carrier: Market;
  metrics: MgaMetrics;
};

export type MgaMetricsByDepartment = {
  __typename?: 'MgaMetricsByDepartment';
  department: Department;
  metrics: MgaMetrics;
};

export type MgaMetricsByProducer = {
  __typename?: 'MgaMetricsByProducer';
  metrics: MgaMetrics;
  user: User;
};

export type MgaMetricsByProduct = {
  __typename?: 'MgaMetricsByProduct';
  metrics: MgaMetrics;
  product: Product;
};

export type MgaMetricsByRetailAgency = {
  __typename?: 'MgaMetricsByRetailAgency';
  metrics: MgaMetrics;
  retailAgency: Market;
};

/** Available columns for MGA Policy Report */
export enum MgaPolicyReportColumn {
  /** Billed MGA revenue */
  BilledMgaRevenue = 'BILLED_MGA_REVENUE',
  /** Billed premium */
  BilledPremium = 'BILLED_PREMIUM',
  /** Account/insured name */
  ClientName = 'CLIENT_NAME',
  /** Account lookup code from source client */
  ClientNumber = 'CLIENT_NUMBER',
  /** Commission based on period filter (written/source/billed) */
  Commission = 'COMMISSION',
  /** Commission percentage based on period filter (written/source/billed) */
  CommissionPct = 'COMMISSION_PCT',
  /** Policy effective/start date */
  EffectiveDate = 'EFFECTIVE_DATE',
  /** Ennabl commission */
  EnnablCommission = 'ENNABL_COMMISSION',
  /** Ennabl commission percentage */
  EnnablCommissionPct = 'ENNABL_COMMISSION_PCT',
  /** Ennabl MGA commission */
  EnnablMgaCommission = 'ENNABL_MGA_COMMISSION',
  /** Ennabl MGA commission percentage */
  EnnablMgaCommissionPct = 'ENNABL_MGA_COMMISSION_PCT',
  /** Ennabl MGA revenue */
  EnnablMgaRevenue = 'ENNABL_MGA_REVENUE',
  /** Ennabl written premium */
  EnnablPremium = 'ENNABL_PREMIUM',
  /** Policy expiration date */
  ExpirationDate = 'EXPIRATION_DATE',
  /** Industry name */
  Industry = 'INDUSTRY',
  /** Insurance segment */
  InsuranceSegment = 'INSURANCE_SEGMENT',
  /**
   * AM Best rating of issuing paper
   * @deprecated AM Best data is no longer maintained (data provider contract ended).
   */
  IssuingPaperAmBestRating = 'ISSUING_PAPER_AM_BEST_RATING',
  /**
   * Financial size category (Roman numeral)
   * @deprecated AM Best data is no longer maintained (data provider contract ended).
   */
  IssuingPaperFinancialSize = 'ISSUING_PAPER_FINANCIAL_SIZE',
  /** Issuing paper name */
  IssuingPaperName = 'ISSUING_PAPER_NAME',
  /** MGA Commission based on period filter (written/source/billed) */
  MgaCommission = 'MGA_COMMISSION',
  /** MGA Commission percentage based on period filter (written/source/billed) */
  MgaCommissionPct = 'MGA_COMMISSION_PCT',
  /** MGA Revenue based on period filter (written/source/billed) */
  MgaRevenue = 'MGA_REVENUE',
  /** NAICS code */
  Naics = 'NAICS',
  /** Parent carrier name */
  ParentCarrierName = 'PARENT_CARRIER_NAME',
  /** Pay to market name */
  PayToName = 'PAY_TO_NAME',
  /** Policy number identifier */
  PolicyNumber = 'POLICY_NUMBER',
  /** Premium based on period filter (written/source/billed) */
  Premium = 'PREMIUM',
  /** UW/Brokers names */
  ProducerNames = 'PRODUCER_NAMES',
  /** Product name */
  Product = 'PRODUCT',
  /** Product lines (comma-separated) */
  ProductLines = 'PRODUCT_LINES',
  /** Retail agency city */
  RetailerCity = 'RETAILER_CITY',
  /** Retail agency name */
  RetailerName = 'RETAILER_NAME',
  /** Retail agency state/region */
  RetailerState = 'RETAILER_STATE',
  /** Retail agency postal code */
  RetailerZip = 'RETAILER_ZIP',
  /** Source commission */
  SourceCommission = 'SOURCE_COMMISSION',
  /** Source commission percentage */
  SourceCommissionPct = 'SOURCE_COMMISSION_PCT',
  /** Source MGA commission */
  SourceMgaCommission = 'SOURCE_MGA_COMMISSION',
  /** Source MGA commission percentage */
  SourceMgaCommissionPct = 'SOURCE_MGA_COMMISSION_PCT',
  /** Source MGA revenue */
  SourceMgaRevenue = 'SOURCE_MGA_REVENUE',
  /** Source premium */
  SourcePremium = 'SOURCE_PREMIUM',
  /** Ultimate carrier name */
  UltimateCarrierName = 'ULTIMATE_CARRIER_NAME'
}

export type MgaPolicyReportColumnConfig = {
  /** Custom header name for this column */
  header?: InputMaybe<Scalars['String']['input']>;
  /** The column to include in the report */
  key: MgaPolicyReportColumn;
};

export type MgaPolicyReportColumnConfigOutput = {
  __typename?: 'MgaPolicyReportColumnConfigOutput';
  /** Custom header name for this column */
  header?: Maybe<Scalars['String']['output']>;
  /** The column to include in the report */
  key: MgaPolicyReportColumn;
};

export type MgaProducerGoalPerformance = {
  __typename?: 'MgaProducerGoalPerformance';
  /** Premium in cents */
  mgaPremium: Scalars['Float']['output'];
  /** Revenue in cents */
  mgaRevenue: Scalars['Float']['output'];
};

export type MgaProducerPremiumGoal = {
  __typename?: 'MgaProducerPremiumGoal';
  /** In cents */
  value: Scalars['Float']['output'];
};

export type MgaProducerRevenueGoal = {
  __typename?: 'MgaProducerRevenueGoal';
  /** In cents */
  value: Scalars['Float']['output'];
};

export enum MgaReportColumn {
  BoundedSubmissions = 'BOUNDED_SUBMISSIONS',
  CarrierCount = 'CARRIER_COUNT',
  EntityName = 'ENTITY_NAME',
  Policies = 'POLICIES',
  Premium = 'PREMIUM',
  ProducerCount = 'PRODUCER_COUNT',
  ProductCount = 'PRODUCT_COUNT',
  QuotedSubmissions = 'QUOTED_SUBMISSIONS',
  QuotedToBindRatio = 'QUOTED_TO_BIND_RATIO',
  Quotes = 'QUOTES',
  Received = 'RECEIVED',
  ReceivedToBindRatio = 'RECEIVED_TO_BIND_RATIO',
  ReceivedToQuotedRatio = 'RECEIVED_TO_QUOTED_RATIO',
  RetailAgencyCount = 'RETAIL_AGENCY_COUNT',
  Revenue = 'REVENUE'
}

export type MgaReportColumnDefinition = {
  /** The column to include in the report */
  column: MgaReportColumn;
  /** The label for the column */
  label: Scalars['String']['input'];
};

export enum MgaReportEntity {
  Carrier = 'CARRIER',
  Department = 'DEPARTMENT',
  Producer = 'PRODUCER',
  Product = 'PRODUCT',
  RetailAgency = 'RETAIL_AGENCY'
}

export type MgaReportParameters = {
  /** The columns definitions to include in the report */
  columns: Array<MgaReportColumnDefinition>;
  /** The entity to aggregate the data by */
  entity: MgaReportEntity;
};

export type MgaSubmission = {
  __typename?: 'MgaSubmission';
  metrics: MgaSubmissionMetrics;
  table: Array<MgaSubmissionTableEntry>;
};


export type MgaSubmissionMetricsArgs = {
  filter: PolicyFilter;
};


export type MgaSubmissionTableArgs = {
  filter: PolicyFilter;
};

export type MgaSubmissionMetrics = {
  __typename?: 'MgaSubmissionMetrics';
  /** The total amount of the bounded submissions */
  boundedSubmissions: Scalars['Int']['output'];
  /** The count of distinct carriers for bound submissions */
  carrierCount: Scalars['Int']['output'];
  /** Total policies count */
  policies: Scalars['Int']['output'];
  /** Premium in cents */
  premium: Scalars['Float']['output'];
  /** The count of distinct producers */
  producerCount: Scalars['Int']['output'];
  /** The count of distinct products for bound submissions */
  productCount: Scalars['Int']['output'];
  /** The total amount of the quoted submissions */
  quotedSubmissions: Scalars['Int']['output'];
  /** Quoted submissions to bound ratio in percentage where 1 = 100% */
  quotedToBindRatio: Scalars['Float']['output'];
  /** The total amount of the quotes */
  quotes: Scalars['Int']['output'];
  /** Quotes to policies ratio in percentage where 1 = 100% */
  quotesToPoliciesRatio: Scalars['Float']['output'];
  /** The total amount of the submissions */
  received: Scalars['Int']['output'];
  /** Received submissions to bound ratio in percentage where 1 = 100% */
  receivedToBindRatio: Scalars['Float']['output'];
  /** Received submissions to quoted ratio in percentage where 1 = 100% */
  receivedToQuotedRatio: Scalars['Float']['output'];
  /** Rejected quotes count */
  rejectedQuotes: Scalars['Int']['output'];
  /** Rejected quotes to quoted submissions ratio in percentage where 1 = 100% */
  rejectedToQuotedRatio: Scalars['Float']['output'];
  /** The count of distinct retail agencies */
  retailAgencyCount: Scalars['Int']['output'];
  /** Revenue in cents */
  revenue: Scalars['Float']['output'];
};

export type MgaSubmissionTableEntry = {
  __typename?: 'MgaSubmissionTableEntry';
  /** The total amount of the bound submissions by product line submissions aggregation */
  bound: Scalars['Int']['output'];
  /** The premium by product line submissions aggregation in cents */
  premium: Scalars['Int']['output'];
  /** The product line which is used for submission aggregation */
  product: Product;
  /** Quote to bind ratio by product line submissions aggregation in percentage where 1 = 100% */
  quoteToBindRatio: Scalars['Float']['output'];
  /** The total amount of the quoted submissions by product line submissions aggregation */
  quoted: Scalars['Int']['output'];
  /** The total amount of the received submissions by product line submissions aggregation */
  received: Scalars['Int']['output'];
  /** Received to bind ratio by product line submissions aggregation in percentage where 1 = 100% */
  receivedToBindRatio: Scalars['Float']['output'];
  /** The revenue by product line submissions aggregation in cents */
  revenue: Scalars['Int']['output'];
};

export type MonolineOpportunityV2 = {
  __typename?: 'MonolineOpportunityV2';
  id: Scalars['ID']['output'];
  policy: Policy;
  saved?: Maybe<SavedOpportunityMonoline>;
};

export type MonolineOpportunityV2PaginatedResult = {
  __typename?: 'MonolineOpportunityV2PaginatedResult';
  items: Array<MonolineOpportunityV2>;
  totalHits: Scalars['Int']['output'];
};

export type MonolinePolicyLists = {
  __typename?: 'MonolinePolicyLists';
  monoline: Array<Policy>;
  multiline: Array<Policy>;
};

/** Entity types for monoline ratio reports */
export enum MonolineRatioEntity {
  Carrier = 'CARRIER',
  Department = 'DEPARTMENT',
  Producer = 'PRODUCER',
  Product = 'PRODUCT'
}

/** Filter entities by threshold position */
export enum MonolineRatioEntityFilter {
  Above = 'ABOVE',
  All = 'ALL',
  Below = 'BELOW'
}

export type MonolineRatioMetrics = {
  __typename?: 'MonolineRatioMetrics';
  accounts: Scalars['Int']['output'];
  /** Number of monoline accounts */
  monolineAccounts: Scalars['Int']['output'];
  /** Percentage of monoline accounts */
  monolineAccountsPct: Scalars['Float']['output'];
  /** @deprecated Use monolineAccountsPct */
  monolinePct: Scalars['Float']['output'];
  /** Number of monoline policies */
  monolinePolicies: Scalars['Int']['output'];
  /** Percentage of monoline policies */
  monolinePoliciesPct: Scalars['Float']['output'];
  /** Number of multiline accounts */
  multilineAccounts: Scalars['Int']['output'];
  /** Percentage of multiline accounts */
  multilineAccountsPct: Scalars['Float']['output'];
  /** @deprecated Use multilineAccountsPct */
  multilinePct: Scalars['Float']['output'];
  /** Number of multiline policies */
  multilinePolicies: Scalars['Int']['output'];
  /** Percentage of multiline policies */
  multilinePoliciesPct: Scalars['Float']['output'];
  policies: Scalars['Int']['output'];
  premium: Scalars['Float']['output'];
  revenue: Scalars['Float']['output'];
};

export type MonolineRatioPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Field to sort by */
  sortBy?: InputMaybe<MonolineRatioSortField>;
  /** Total count will be different if we use sorting by metric with permissions */
  sortOrder?: InputMaybe<SortOrder>;
};

export type MonolineRatioParamsInput = {
  /** Filter items with multiline ratio above this value */
  aboveRatio?: InputMaybe<Scalars['Float']['input']>;
  /** Filter items with multiline ratio below this value */
  belowRatio?: InputMaybe<Scalars['Float']['input']>;
  /** Threshold multiline ratio for statistics calculation */
  threshold?: InputMaybe<Scalars['Float']['input']>;
  /** Mode for threshold calculation - ACCOUNT (default) or POLICY */
  thresholdMode?: InputMaybe<ThresholdMode>;
};

/** Fields available for sorting monoline ratios */
export enum MonolineRatioSortField {
  ClientCount = 'CLIENT_COUNT',
  MonolinePct = 'MONOLINE_PCT',
  MultilinePct = 'MULTILINE_PCT',
  PolicyCount = 'POLICY_COUNT',
  Premium = 'PREMIUM',
  Revenue = 'REVENUE'
}

export type MonolineRatioStatistics = {
  __typename?: 'MonolineRatioStatistics';
  /** Number of entities above the threshold */
  aboveThreshold: Scalars['Int']['output'];
  /** Number of entities below the threshold */
  belowThreshold: Scalars['Int']['output'];
  /** Threshold value for statistics calculation */
  threshold?: Maybe<Scalars['Float']['output']>;
  /** Total number of entities */
  total: Scalars['Int']['output'];
};

export type MonolineRatios = {
  __typename?: 'MonolineRatios';
  byCarrier: MarketMonolineRatioWithStats;
  byDepartment: DepartmentMonolineRatioWithStats;
  byProducer: ProducerMonolineRatioWithStats;
  byProduct: ProductMonolineRatioWithStats;
  policyLists: MonolinePolicyLists;
  productPolicyLists: MonolinePolicyLists;
};


export type MonolineRatiosByCarrierArgs = {
  filter?: InputMaybe<PolicyFilter>;
  level?: InputMaybe<CarrierLevel>;
  pagination?: InputMaybe<MonolineRatioPaginationInput>;
  params?: InputMaybe<MonolineRatioParamsInput>;
};


export type MonolineRatiosByDepartmentArgs = {
  filter?: InputMaybe<PolicyFilter>;
  pagination?: InputMaybe<MonolineRatioPaginationInput>;
  params?: InputMaybe<MonolineRatioParamsInput>;
};


export type MonolineRatiosByProducerArgs = {
  filter?: InputMaybe<PolicyFilter>;
  pagination?: InputMaybe<MonolineRatioPaginationInput>;
  params?: InputMaybe<MonolineRatioParamsInput>;
};


export type MonolineRatiosByProductArgs = {
  filter?: InputMaybe<PolicyFilter>;
  pagination?: InputMaybe<MonolineRatioPaginationInput>;
  params?: InputMaybe<MonolineRatioParamsInput>;
};


export type MonolineRatiosPolicyListsArgs = {
  filter: PolicyFilter;
};


export type MonolineRatiosProductPolicyListsArgs = {
  filter?: InputMaybe<PolicyFilter>;
  productId: Scalars['ID']['input'];
};

export type MonolineRatiosWidgetParams = {
  __typename?: 'MonolineRatiosWidgetParams';
  entity: WidgetEntity;
  entityFilter?: Maybe<MonolineRatioEntityFilter>;
  entityKeys?: Maybe<Array<WidgetEntity>>;
  filter?: Maybe<PolicyFilterOutput>;
  sortBy?: Maybe<MonolineRatioSortField>;
  sortOrder?: Maybe<SortOrder>;
  threshold?: Maybe<Scalars['Float']['output']>;
  thresholdMode: ThresholdMode;
};

export type MonolineRatiosWidgetParamsInput = {
  entity: WidgetEntity;
  entityFilter?: InputMaybe<MonolineRatioEntityFilter>;
  entityKeys?: InputMaybe<Array<WidgetEntity>>;
  filter?: InputMaybe<PolicyFilter>;
  sortBy?: InputMaybe<MonolineRatioSortField>;
  sortOrder?: InputMaybe<SortOrder>;
  threshold?: InputMaybe<Scalars['Float']['input']>;
  thresholdMode: ThresholdMode;
};

export type Month = {
  __typename?: 'Month';
  date: Scalars['Timestamp']['output'];
  isoString: Scalars['String']['output'];
};

export type MonthlyTrends = {
  __typename?: 'MonthlyTrends';
  currentPeriod: Array<TrendDataPoint>;
  currentPeriodRange: DateRangeOutput;
  previousPeriod: Array<TrendDataPoint>;
  previousPeriodRange: DateRangeOutput;
};

export type Mutation = {
  __typename?: 'Mutation';
  addDashboardSection: Dashboard;
  addIntegrationResponseToFavorites: AddResponseToFavoritesPayload;
  addOpportunitiesToList: SavedOpportunitiesPutResult;
  addOpportunityList: OpportunityList;
  addSavedPage: SavedPage;
  addSavedPages: SaveManyPagesResult;
  cancelLossRunsSubscription: Scalars['Boolean']['output'];
  createAggregatedCustomReport: UserReport;
  /** @deprecated deprecated */
  createCompanyProspect: CreateCompanyProspectPayload;
  createCustomQueryReport: UserReport;
  /** @deprecated deprecated */
  createDolCompanyProspect: CreateDolCompanyProspectPayload;
  createEnnablUserRole: EnnablUserRole;
  /** @deprecated deprecated */
  createIndividualProspect: CreateIndividualProspectPayload;
  createKpiDashboard: KpiDashboard;
  createPlainCustomReport: UserReport;
  createReminder: Reminder;
  createReportTemplate: ReportTemplate;
  createUserReportPreset: CreateUserReportPresetPayload;
  deleteBatchShare: Scalars['Boolean']['output'];
  deleteDashboard: Scalars['Boolean']['output'];
  /** Deletes documents in the specified folders */
  deleteDocumentFolders: DeleteDocumentFoldersResponse;
  /** @deprecated Use deleteDocumentsV1 */
  deleteDocuments: Array<DeleteDocumentPayload>;
  deleteDocumentsV1: Array<DeleteDocumentPayload>;
  deleteEnnablUsersBatch: Scalars['Boolean']['output'];
  deleteFilter: StoredFiltersDeleteResponse;
  deleteKpiDashboard: KpiDashboard;
  deleteOpportunityList: DeleteOpportunityListPayload;
  /** @deprecated deprecated */
  deleteOpportunityReport: DeleteOpportunityReportPayload;
  deletePermanentlySavedOpportunities: SavedOpportunitiesPermanentlyDeleteResult;
  /** @deprecated Not needed anymore */
  deleteProspect: DeleteProspectPayload;
  /** @deprecated deprecated */
  deleteProspectsByIds: DeleteProspectPayload;
  deleteReminders: DeleteRemindersPayload;
  deleteReportTemplate: Scalars['Boolean']['output'];
  deleteSavedOpportunities: SavedOpportunitiesPutResult;
  deleteSavedOpportunityItem: SavedOpportunitiesPutOneResult;
  deleteSavedPage: DeleteSavedPagePayload;
  deleteUserReportPreset: DeleteUserReportPresetPayload;
  documentCompareUploadFiles: Array<DocumentsCompareFileUrl>;
  documentProcessingCreateFolder: LossRunsFolder;
  documentProcessingDeleteFolder: Scalars['Boolean']['output'];
  documentProcessingRun: LossRunsFolder;
  documentsCompareChangePremiumFile: DocumentsCompareGroup;
  documentsCompareCreateGroup: DocumentsCompareGroup;
  documentsCompareDeleteFile: Scalars['Boolean']['output'];
  documentsCompareDeleteGroup: Scalars['Boolean']['output'];
  documentsCompareDeleteGroups: Scalars['Boolean']['output'];
  documentsCompareGroupResetIsNewFlag: DocumentsCompareGroup;
  documentsCompareRenameGroup: DocumentsCompareGroup;
  documentsCompareRun: DocumentsCompareGroup;
  downloadAccountExecutiveTopIndustryReport: UserReport;
  downloadAccountExecutiveTopProductReport: UserReport;
  downloadAccountGrowthReport: UserReport;
  downloadAccountGrowthReportMga: UserReport;
  downloadAccountLeaderboardReport: UserReport;
  downloadAccountLostReport: UserReport;
  downloadAccountManagerAccountBookProfile: UserReport;
  downloadAccountManagerAccountSizeReport: UserReport;
  downloadAccountManagerProducerSupportReport: UserReport;
  downloadAccountManagerRenewalReport: UserReport;
  downloadAccountManagerReport: UserReport;
  downloadAccountManagerTopCarriersReport: UserReport;
  downloadAccountManagerTopIndustriesReport: UserReport;
  downloadAccountManagerTopProductsReport: UserReport;
  downloadActivityKpiReport: UserReport;
  downloadActivityLeaderboardReport: UserReport;
  downloadAggregatedReport: UserReport;
  downloadAvgAccountSizeReport: UserReport;
  downloadBookPerformanceReportMga: UserReport;
  downloadCarrierAppetiteReport: UserReport;
  /** @deprecated Carrier Downgrades report has been discontinued (AM Best data provider contract ended). */
  downloadCarrierDowngradesReport: UserReport;
  downloadCarrierPDFReport: UserReport;
  downloadClientNaicsReport: UserReport;
  downloadDataAuditReport: UserReport;
  downloadDataManagementAgencyReport: UserReport;
  downloadEnrichmentCompanyMappingsReport: UserReport;
  downloadKpiXlsxReport: UserReport;
  /** @deprecated use downloadLeaderboardReportV2 */
  downloadLeaderboardReport: UserReport;
  downloadLeaderboardReportMga: UserReport;
  downloadLeaderboardReportV2: UserReport;
  downloadLocationPDFReport: UserReport;
  downloadLossRunsReport: UserReport;
  downloadMgaPolicyReport: UserReport;
  downloadMonolineRatiosPolicyReport: UserReport;
  downloadMonolineRatiosProductPolicyReport: UserReport;
  downloadMonolineRatiosReport: UserReport;
  downloadOpportunityRecommendationDnbData?: Maybe<DnbCompany>;
  downloadOutflowInflowReport: UserReport;
  downloadPolicyXlsxReport: UserReport;
  downloadPremiumAccountSizeReport: UserReport;
  downloadPremiumFlowReport: UserReport;
  downloadProducerCreditReport: UserReport;
  downloadProducerTopIndustryReport: UserReport;
  downloadProducerTopProductReport: UserReport;
  downloadProductionCreditXlsxReport: UserReport;
  /** @deprecated deprecated */
  downloadProspectsReport: UserReport;
  downloadRetentionInsightsReport: UserReport;
  downloadRetentionXLSXReport: UserReport;
  downloadRoiCrossSellReport: UserReport;
  downloadSavedOpportunitiesReport: UserReport;
  downloadScore360ClientsReport: UserReport;
  downloadScore360ProducersReport: UserReport;
  downloadSubmissionsReportMga: UserReport;
  downloadUserReportByGroupId: UserReport;
  downloadUserReportByPresetId: UserReport;
  downloadUsersReport: UserReport;
  generateCrossSellReport: OpportunityCrossSellReport;
  generateSourceUploadDownloadUrl: Scalars['String']['output'];
  getDocumentDownloadUrls: Array<Maybe<Scalars['String']['output']>>;
  getDocumentUploadUrls: GetDocumentUploadUrlsResponse;
  /** @deprecated Use getDocumentUploadUrls */
  getDocumentsPresignedUploadUrls: Array<DocumentPresignedUploadUrl>;
  getTableauSecret: TableauToken;
  importDashboard: Dashboard;
  importKpiDashboard: KpiDashboard;
  /** Index docs as NOT_STARTED before the event comes from S3/SQS/Lambda */
  indexDocumentUploads: Array<DocumentMetadata>;
  insuranceCompanyMappingSelectSuggestion: EnrichmentProcessingTokenResponse;
  inviteEnnablUser: EnnablUser;
  lifetimeMultipleAccountsReport: UserReport;
  lifetimeMultipleIndustriesReport: UserReport;
  lifetimeSingleAccountReport: UserReport;
  lossRunsUploadFiles: Array<LossRunsFileUrl>;
  /** False mean that not all inputs were saved */
  lossRunsUserInput: Scalars['Boolean']['output'];
  moveDocumentsToFolder: ChangeDocumentFolderPayload;
  productMappingOverride: EnrichmentProcessingTokenResponse;
  productMappingSelectSuggestion: EnrichmentProcessingTokenResponse;
  productMappingUpdateTree: EnrichmentProcessingTokenResponse;
  removeEnnablUserRole: Scalars['Boolean']['output'];
  removeIntegrationResponseFromFavorites: RemoveResponseFromFavoritesPayload;
  removeOpportunitiesFromList: SavedOpportunitiesPutResult;
  renameDocumentFolder: ChangeDocumentFolderPayload;
  renameKpiDashboard: KpiDashboard;
  /** @deprecated deprecated */
  renameOpportunityReport: RenameOpportunityReportPayload;
  reorderFilters: StoredFiltersUpdateLastUserResponse;
  reorderSavedDocumentsFilters: Scalars['Boolean']['output'];
  reorderSavedPolicyFilters: Scalars['Boolean']['output'];
  reportLossRunIssue: Scalars['Boolean']['output'];
  resendEnnablUserInviteEmail: Scalars['Boolean']['output'];
  restoreSavedOpportunities: SavedOpportunitiesPutResult;
  saveFilter: StoredFiltersCreateResponse;
  /** @deprecated deprecated */
  saveOpportunityReport: SaveOpportunityReportPayload;
  savePageFilter: PageSettings;
  saveToListByClientFilter: SavedOpportunitiesCountPutResult;
  saveToListByPolicyFilter: SavedOpportunitiesCountPutResult;
  saveToListClientOpportunities: SavedOpportunitiesPutResult;
  saveToListCrossSellByReportId: SavedOpportunitiesCountPutResult;
  saveToListDnbNetNewOpportunities: SavedOpportunitiesPutResult;
  saveToListDolCompanies: SavedOpportunitiesPutResult;
  saveToListHazardhubAddress: SavedOpportunitiesPutOneResult;
  saveToListNetNewOpportunityRecommendations: SavedOpportunitiesPutResult;
  saveToListRocketReachNetNewOpportunities: SavedOpportunitiesPutResult;
  saveToListTopCrossSellRecommendations: SavedOpportunitiesCountPutResult;
  saveUserPageSettings: PageSettings;
  setCompanyStatus: BrokerMarketStatusUpdateResult;
  setCrossSellProducerGoal: UpdateProducerGoalPayload;
  setCurrentDashboard: Scalars['Boolean']['output'];
  setCurrentKpiDashboard: Scalars['Boolean']['output'];
  setHazardhubCachedIdToClient: SetHazardhubCachedIdResponse;
  setNetNewProducerGoal: UpdateProducerGoalPayload;
  setPremiumMgaProducerGoal: UpdateProducerGoalPayload;
  setRetentionProducerGoal: UpdateProducerGoalPayload;
  setRevenueMgaProducerGoal: UpdateProducerGoalPayload;
  setRocketReachIdToClient: SetRocketReachIdResponse;
  setUserTimeZoneSettings: Scalars['Boolean']['output'];
  shareHomeDashboard: Scalars['String']['output'];
  shareKpiDashboard: Scalars['String']['output'];
  shareLossRunsBatch: Scalars['Boolean']['output'];
  sourceDataApproveSubmission: SourceDataUpload;
  sourceDataDeleteUpload: Scalars['Boolean']['output'];
  sourceDataInitUpload: SourceDataUploadInitResult;
  sourceDataSubmitCustomMapping: SourceDataUpload;
  sourceDataSubmitMapping: SourceDataUpload;
  sourceDataValidateUpload: SourceDataUpload;
  subscribeLossRuns: LossRunsSubscribePayload;
  unlinkUserFromAms: EnnablUser;
  updateEnnablUser: EnnablUser;
  updateEnnablUserRole: EnnablUserRole;
  updateEnnablUsersBatch: Array<EnnablUser>;
  updateFilter: StoredFiltersUpdateResponse;
  updateFilterLastUsed: StoredFiltersUpdateLastUserResponse;
  updateKpiDashboard: KpiDashboard;
  updateListsOfOpportunities: ListsOfSavedOpportunityUpdateResult;
  updateOpportunityList: OpportunityList;
  updateReportTemplate: ReportTemplate;
  updateUserReportPreset: UpdateUserReportPresetPayload;
  updateUserReportPresetSchedule: UpdateUserReportPresetPayload;
  upsertDashboards: Array<Dashboard>;
  upsertDocumentsFilter: StoredDocumentsFilter;
  upsertPolicyFilter: StoredPolicyFilter;
};


export type MutationAddDashboardSectionArgs = {
  dashboardId: Scalars['ID']['input'];
  section: DashboardSectionUpsertInput;
};


export type MutationAddIntegrationResponseToFavoritesArgs = {
  integrationResponseId: Scalars['ID']['input'];
  policyId?: InputMaybe<Scalars['ID']['input']>;
  service: IntegrationServiceName;
};


export type MutationAddOpportunitiesToListArgs = {
  listId: Scalars['ID']['input'];
  opportunityIds: Array<Scalars['ID']['input']>;
  producerId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddOpportunityListArgs = {
  opportunityList: OpportunityListCreateInput;
  producerId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddSavedPageArgs = {
  savedPage: SavedPageInput;
};


export type MutationAddSavedPagesArgs = {
  savedPages: Array<SavedPageInput>;
};


export type MutationCreateAggregatedCustomReportArgs = {
  params: CustomAggregatedPreviewParams;
  reportName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateCompanyProspectArgs = {
  params: ProspectCompanyCreateInput;
};


export type MutationCreateCustomQueryReportArgs = {
  params: CustomQueryPreviewParams;
  reportName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateDolCompanyProspectArgs = {
  params: ProspectDolCompanyCreateInput;
};


export type MutationCreateEnnablUserRoleArgs = {
  input: EnnablUserRoleCreateInput;
};


export type MutationCreateIndividualProspectArgs = {
  params: ProspectIndividualCreateInput;
};


export type MutationCreateKpiDashboardArgs = {
  dashboard: KpiDashboardCreateInput;
};


export type MutationCreatePlainCustomReportArgs = {
  params: CustomPlainPreviewParams;
  reportName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateReminderArgs = {
  producerId?: InputMaybe<Scalars['String']['input']>;
  reminder: ReminderInput;
  savedOpportunityId: Scalars['String']['input'];
};


export type MutationCreateReportTemplateArgs = {
  template: ReportTemplateInput;
};


export type MutationCreateUserReportPresetArgs = {
  preset: UserReportPresetInput;
};


export type MutationDeleteBatchShareArgs = {
  batchId: Scalars['String']['input'];
};


export type MutationDeleteDashboardArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDocumentFoldersArgs = {
  folders: Array<Scalars['String']['input']>;
};


export type MutationDeleteDocumentsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationDeleteDocumentsV1Args = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationDeleteEnnablUsersBatchArgs = {
  input: BatchEnnablUsersDeleteInput;
};


export type MutationDeleteFilterArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteKpiDashboardArgs = {
  dashboardId: Scalars['String']['input'];
};


export type MutationDeleteOpportunityListArgs = {
  id: Scalars['ID']['input'];
  producerId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteOpportunityReportArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeletePermanentlySavedOpportunitiesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteProspectArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProspectsByIdsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteRemindersArgs = {
  producerId?: InputMaybe<Scalars['String']['input']>;
  reminderIds: Array<Scalars['String']['input']>;
};


export type MutationDeleteReportTemplateArgs = {
  templateId: Scalars['ID']['input'];
};


export type MutationDeleteSavedOpportunitiesArgs = {
  ids: Array<Scalars['ID']['input']>;
  producerId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteSavedOpportunityItemArgs = {
  itemId: Scalars['ID']['input'];
  producerId?: InputMaybe<Scalars['String']['input']>;
  savedOpportunityId: Scalars['ID']['input'];
};


export type MutationDeleteSavedPageArgs = {
  url: Scalars['String']['input'];
};


export type MutationDeleteUserReportPresetArgs = {
  presetId: Scalars['String']['input'];
};


export type MutationDocumentCompareUploadFilesArgs = {
  files: Array<DocumentsCompareFileInput>;
  groupId: Scalars['String']['input'];
};


export type MutationDocumentProcessingCreateFolderArgs = {
  name: Scalars['String']['input'];
};


export type MutationDocumentProcessingDeleteFolderArgs = {
  folderId: Scalars['String']['input'];
};


export type MutationDocumentProcessingRunArgs = {
  folderId: Scalars['String']['input'];
};


export type MutationDocumentsCompareChangePremiumFileArgs = {
  fileId: Scalars['String']['input'];
  groupId: Scalars['String']['input'];
};


export type MutationDocumentsCompareCreateGroupArgs = {
  name: Scalars['String']['input'];
};


export type MutationDocumentsCompareDeleteFileArgs = {
  fileId: Scalars['String']['input'];
  groupId: Scalars['String']['input'];
};


export type MutationDocumentsCompareDeleteGroupArgs = {
  groupId: Scalars['String']['input'];
};


export type MutationDocumentsCompareDeleteGroupsArgs = {
  groupIds: Array<Scalars['String']['input']>;
};


export type MutationDocumentsCompareGroupResetIsNewFlagArgs = {
  groupId: Scalars['String']['input'];
};


export type MutationDocumentsCompareRenameGroupArgs = {
  groupId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationDocumentsCompareRunArgs = {
  groupId: Scalars['String']['input'];
};


export type MutationDownloadAccountExecutiveTopIndustryReportArgs = {
  filter?: InputMaybe<PolicyFilter>;
};


export type MutationDownloadAccountExecutiveTopProductReportArgs = {
  filter?: InputMaybe<PolicyFilter>;
};


export type MutationDownloadAccountGrowthReportArgs = {
  entity: AccountsReportEntity;
  filter?: InputMaybe<PolicyFilter>;
};


export type MutationDownloadAccountGrowthReportMgaArgs = {
  entity: AccountsReportEntity;
  filter?: InputMaybe<PolicyFilter>;
};


export type MutationDownloadAccountLeaderboardReportArgs = {
  filter?: InputMaybe<PolicyFilter>;
};


export type MutationDownloadAccountLostReportArgs = {
  entity: AccountsReportEntity;
  filter?: InputMaybe<PolicyFilter>;
};


export type MutationDownloadAccountManagerAccountBookProfileArgs = {
  filter?: InputMaybe<PolicyFilter>;
};


export type MutationDownloadAccountManagerAccountSizeReportArgs = {
  filter?: InputMaybe<PolicyFilter>;
};


export type MutationDownloadAccountManagerProducerSupportReportArgs = {
  filter?: InputMaybe<PolicyFilter>;
};


export type MutationDownloadAccountManagerRenewalReportArgs = {
  filter?: InputMaybe<PolicyFilter>;
};


export type MutationDownloadAccountManagerReportArgs = {
  filter?: InputMaybe<PolicyFilter>;
};


export type MutationDownloadAccountManagerTopCarriersReportArgs = {
  filter?: InputMaybe<PolicyFilter>;
};


export type MutationDownloadAccountManagerTopIndustriesReportArgs = {
  filter?: InputMaybe<PolicyFilter>;
};


export type MutationDownloadAccountManagerTopProductsReportArgs = {
  filter?: InputMaybe<PolicyFilter>;
};


export type MutationDownloadActivityKpiReportArgs = {
  filter: PolicyFilter;
};


export type MutationDownloadActivityLeaderboardReportArgs = {
  entity: ActivityLeaderboardEntity;
  filter: PolicyFilter;
};


export type MutationDownloadAggregatedReportArgs = {
  aggregateBy: AggregateByInput;
  columns: Array<AggregatedColumnConfig>;
  filter?: InputMaybe<PolicyFilter>;
};


export type MutationDownloadAvgAccountSizeReportArgs = {
  entity: AccountsReportEntity;
  filter?: InputMaybe<PolicyFilter>;
};


export type MutationDownloadBookPerformanceReportMgaArgs = {
  filter?: InputMaybe<PolicyFilter>;
};


export type MutationDownloadCarrierAppetiteReportArgs = {
  componentFilter: PolicyFilter;
  globalFilter: PolicyFilter;
  level?: InputMaybe<CarrierLevel>;
};


export type MutationDownloadCarrierPdfReportArgs = {
  carrierId: Scalars['String']['input'];
  carrierLevel: CarrierLevel;
  companyFilterType?: InputMaybe<CompanyFilterType>;
  filter?: InputMaybe<PolicyFilter>;
  meta?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<CarrierPdfReportOptions>;
  templateUrl: Scalars['String']['input'];
};


export type MutationDownloadDataAuditReportArgs = {
  auditType: DataAuditReportType;
  fileType: UserReportFileType;
  includeSourceData?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationDownloadEnrichmentCompanyMappingsReportArgs = {
  externalSystemIds?: InputMaybe<Array<Scalars['String']['input']>>;
  linkedWithAdminCompany?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDownloadKpiXlsxReportArgs = {
  filter: PolicyFilter;
  metric: PolicyMetric;
  reportName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDownloadLeaderboardReportArgs = {
  carrierLevel?: InputMaybe<CarrierLevel>;
  entity: ReportEntity;
  filter?: InputMaybe<PolicyFilter>;
};


export type MutationDownloadLeaderboardReportMgaArgs = {
  entity: MgaLeaderboardReportEntity;
  filter?: InputMaybe<PolicyFilter>;
};


export type MutationDownloadLeaderboardReportV2Args = {
  carrierLevel?: InputMaybe<CarrierLevel>;
  entity: LeaderboardReportEntity;
  filter?: InputMaybe<PolicyFilter>;
  metric?: InputMaybe<LeaderboardReportMetric>;
  payToLevel?: InputMaybe<PayToLevel>;
};


export type MutationDownloadLocationPdfReportArgs = {
  jsonBody: Scalars['String']['input'];
  templateUrl: Scalars['String']['input'];
};


export type MutationDownloadLossRunsReportArgs = {
  batchId: Scalars['String']['input'];
  filter?: InputMaybe<BatchFilter>;
  shared?: InputMaybe<Scalars['Boolean']['input']>;
  templateUrl: Scalars['String']['input'];
};


export type MutationDownloadMgaPolicyReportArgs = {
  columns?: InputMaybe<Array<MgaPolicyReportColumnConfig>>;
  filter?: InputMaybe<PolicyFilter>;
  reportName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDownloadMonolineRatiosPolicyReportArgs = {
  filter: PolicyFilter;
  productId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDownloadMonolineRatiosProductPolicyReportArgs = {
  filter?: InputMaybe<PolicyFilter>;
  productId: Scalars['ID']['input'];
};


export type MutationDownloadMonolineRatiosReportArgs = {
  carrierLevel?: InputMaybe<CarrierLevel>;
  entity: MonolineRatioEntity;
  filter?: InputMaybe<PolicyFilter>;
  params?: InputMaybe<MonolineRatioParamsInput>;
};


export type MutationDownloadOpportunityRecommendationDnbDataArgs = {
  recommendationId: Scalars['String']['input'];
};


export type MutationDownloadOutflowInflowReportArgs = {
  carrierLevel?: InputMaybe<CarrierLevel>;
  filter?: InputMaybe<PolicyFilter>;
  outflowInflowDrillDownFilter?: InputMaybe<OutflowInflowDrillDownFilter>;
  outflowInflowFilter?: InputMaybe<OutflowInflowFilterInput>;
};


export type MutationDownloadPolicyXlsxReportArgs = {
  filter?: InputMaybe<PolicyFilter>;
  includeSourceData?: InputMaybe<Scalars['Boolean']['input']>;
  reportName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDownloadPremiumAccountSizeReportArgs = {
  carrierLevel?: InputMaybe<CarrierLevel>;
  entity: AccountsReportEntity;
  filter?: InputMaybe<PolicyFilter>;
};


export type MutationDownloadPremiumFlowReportArgs = {
  carrierLevel?: InputMaybe<CarrierLevel>;
  filter?: InputMaybe<PolicyFilter>;
  premiumFlowType: PremiumFlowType;
};


export type MutationDownloadProducerCreditReportArgs = {
  filter?: InputMaybe<PolicyFilter>;
  producerId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDownloadProducerTopIndustryReportArgs = {
  filter?: InputMaybe<PolicyFilter>;
};


export type MutationDownloadProducerTopProductReportArgs = {
  filter?: InputMaybe<PolicyFilter>;
};


export type MutationDownloadProductionCreditXlsxReportArgs = {
  filter?: InputMaybe<PolicyFilter>;
};


export type MutationDownloadRetentionInsightsReportArgs = {
  filter?: InputMaybe<PolicyFilter>;
  params: RetentionInsightsParametersInput;
};


export type MutationDownloadRetentionXlsxReportArgs = {
  filter?: InputMaybe<PolicyFilter>;
  params?: InputMaybe<RetentionParametersInput>;
};


export type MutationDownloadSavedOpportunitiesReportArgs = {
  filter?: InputMaybe<SavedOpportunitiesFilter>;
  producerId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDownloadScore360ClientsReportArgs = {
  filter?: InputMaybe<Score360Filter>;
  viewMode?: InputMaybe<Score360ViewMode>;
};


export type MutationDownloadScore360ProducersReportArgs = {
  filter?: InputMaybe<Score360Filter>;
};


export type MutationDownloadSubmissionsReportMgaArgs = {
  filter?: InputMaybe<PolicyFilter>;
  reportParams: MgaReportParameters;
};


export type MutationDownloadUserReportByGroupIdArgs = {
  groupId: Scalars['String']['input'];
};


export type MutationDownloadUserReportByPresetIdArgs = {
  presetId: Scalars['String']['input'];
};


export type MutationGenerateCrossSellReportArgs = {
  filter: CrossSellGeneratorFilter;
};


export type MutationGenerateSourceUploadDownloadUrlArgs = {
  uploadId: Scalars['ID']['input'];
};


export type MutationGetDocumentDownloadUrlsArgs = {
  files: Array<DocumentDownloadUrlInput>;
};


export type MutationGetDocumentUploadUrlsArgs = {
  filenames: Array<Scalars['String']['input']>;
  folder?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGetDocumentsPresignedUploadUrlsArgs = {
  filenames: Array<Scalars['String']['input']>;
};


export type MutationImportDashboardArgs = {
  shareId: Scalars['String']['input'];
};


export type MutationImportKpiDashboardArgs = {
  shareId: Scalars['String']['input'];
};


export type MutationIndexDocumentUploadsArgs = {
  batchId: Scalars['String']['input'];
  files: Array<IndexDocumentsItemInput>;
  folder?: InputMaybe<Scalars['String']['input']>;
};


export type MutationInsuranceCompanyMappingSelectSuggestionArgs = {
  dataSourceId: Scalars['String']['input'];
  mappingsIds: Array<Scalars['ID']['input']>;
  suggestionId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationInviteEnnablUserArgs = {
  input: EnnablUserInviteInput;
};


export type MutationLifetimeMultipleAccountsReportArgs = {
  date?: InputMaybe<Scalars['SimpleDate']['input']>;
  filter: PolicyFilter;
};


export type MutationLifetimeMultipleIndustriesReportArgs = {
  date?: InputMaybe<Scalars['SimpleDate']['input']>;
  filter: PolicyFilter;
};


export type MutationLifetimeSingleAccountReportArgs = {
  clientId: Scalars['ID']['input'];
  date?: InputMaybe<Scalars['SimpleDate']['input']>;
  filter: PolicyFilter;
};


export type MutationLossRunsUploadFilesArgs = {
  filenames: Array<Scalars['String']['input']>;
  folderId: Scalars['String']['input'];
};


export type MutationLossRunsUserInputArgs = {
  folderId: Scalars['String']['input'];
  input: Array<LossRunsUserInput>;
  shared?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationMoveDocumentsToFolderArgs = {
  folder?: InputMaybe<Scalars['String']['input']>;
  ids: Array<Scalars['String']['input']>;
};


export type MutationProductMappingOverrideArgs = {
  enrichedProductId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationProductMappingSelectSuggestionArgs = {
  dataSourceId: Scalars['String']['input'];
  mappingIds: Array<Scalars['ID']['input']>;
  suggestionId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationProductMappingUpdateTreeArgs = {
  group?: InputMaybe<Scalars['String']['input']>;
  ids: Array<Scalars['ID']['input']>;
  insuranceSegment?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  superGroup?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRemoveEnnablUserRoleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveIntegrationResponseFromFavoritesArgs = {
  integrationResponseId: Scalars['ID']['input'];
  service: IntegrationServiceName;
};


export type MutationRemoveOpportunitiesFromListArgs = {
  listId: Scalars['ID']['input'];
  opportunityIds: Array<Scalars['ID']['input']>;
  producerId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRenameDocumentFolderArgs = {
  newName: Scalars['String']['input'];
  oldName: Scalars['String']['input'];
};


export type MutationRenameKpiDashboardArgs = {
  dashboardId: Scalars['String']['input'];
  dashboardName: Scalars['String']['input'];
};


export type MutationRenameOpportunityReportArgs = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationReorderFiltersArgs = {
  filterIds: Array<Scalars['String']['input']>;
};


export type MutationReorderSavedDocumentsFiltersArgs = {
  ids: Array<Scalars['ID']['input']>;
  tag: Scalars['String']['input'];
};


export type MutationReorderSavedPolicyFiltersArgs = {
  ids: Array<Scalars['ID']['input']>;
  tag: Scalars['String']['input'];
};


export type MutationReportLossRunIssueArgs = {
  folderId: Scalars['String']['input'];
  message: Scalars['String']['input'];
  shared?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationResendEnnablUserInviteEmailArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationRestoreSavedOpportunitiesArgs = {
  ids: Array<Scalars['ID']['input']>;
  producerId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSaveFilterArgs = {
  payload: StoredFiltersCreatePayload;
};


export type MutationSaveOpportunityReportArgs = {
  id: Scalars['String']['input'];
};


export type MutationSavePageFilterArgs = {
  filter: PolicyFilter;
  pageId: Scalars['ID']['input'];
};


export type MutationSaveToListByClientFilterArgs = {
  excludeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  filter: ClientFilter;
  label: SavedOpportunityLabel;
  listIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  producerId?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSaveToListByPolicyFilterArgs = {
  excludeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  filter: PolicyFilter;
  label: SavedOpportunityLabel;
  listIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  producerId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSaveToListClientOpportunitiesArgs = {
  label?: InputMaybe<SavedOpportunityLabel>;
  listIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  opportunities: Array<SavedOpportunityCrossSellRecommendationInput>;
  producerId?: InputMaybe<Scalars['String']['input']>;
  reminder?: InputMaybe<ReminderInput>;
};


export type MutationSaveToListCrossSellByReportIdArgs = {
  excludeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  label: SavedOpportunityLabel;
  listIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  producerId?: InputMaybe<Scalars['String']['input']>;
  reportId: Scalars['String']['input'];
};


export type MutationSaveToListDnbNetNewOpportunitiesArgs = {
  inputs: Array<SavedOpportunityDnbNetNewInput>;
  listIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  producerId?: InputMaybe<Scalars['String']['input']>;
  reminder?: InputMaybe<ReminderInput>;
};


export type MutationSaveToListDolCompaniesArgs = {
  inputs: Array<SavedOpportunityDolNetNewInput>;
  listIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  producerId?: InputMaybe<Scalars['String']['input']>;
  reminder?: InputMaybe<ReminderInput>;
};


export type MutationSaveToListHazardhubAddressArgs = {
  cachedId: Scalars['String']['input'];
  listIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  producerId?: InputMaybe<Scalars['String']['input']>;
  reminder?: InputMaybe<ReminderInput>;
};


export type MutationSaveToListNetNewOpportunityRecommendationsArgs = {
  listIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  recommendationIds: Array<Scalars['String']['input']>;
  reminder?: InputMaybe<ReminderInput>;
};


export type MutationSaveToListRocketReachNetNewOpportunitiesArgs = {
  inputs: Array<SavedOpportunityRocketReachNetNewInput>;
  listIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  producerId?: InputMaybe<Scalars['String']['input']>;
  reminder?: InputMaybe<ReminderInput>;
};


export type MutationSaveToListTopCrossSellRecommendationsArgs = {
  excludeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  listIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  producerId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSaveUserPageSettingsArgs = {
  settings: PageSettingsInput;
};


export type MutationSetCompanyStatusArgs = {
  companyId: Scalars['String']['input'];
  status: BrokerMarketStatus;
};


export type MutationSetCrossSellProducerGoalArgs = {
  metric?: InputMaybe<ProducerGoalMetric>;
  producerId?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  year: Scalars['Int']['input'];
};


export type MutationSetCurrentDashboardArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSetCurrentKpiDashboardArgs = {
  dashboardId: Scalars['String']['input'];
};


export type MutationSetHazardhubCachedIdToClientArgs = {
  clientId: Scalars['ID']['input'];
  hazardhubCachedId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationSetNetNewProducerGoalArgs = {
  metric?: InputMaybe<ProducerGoalMetric>;
  producerId?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  year: Scalars['Int']['input'];
};


export type MutationSetPremiumMgaProducerGoalArgs = {
  producerId?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  year: Scalars['Int']['input'];
};


export type MutationSetRetentionProducerGoalArgs = {
  metric?: InputMaybe<ProducerGoalMetric>;
  producerId?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  year: Scalars['Int']['input'];
};


export type MutationSetRevenueMgaProducerGoalArgs = {
  producerId?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  year: Scalars['Int']['input'];
};


export type MutationSetRocketReachIdToClientArgs = {
  clientId: Scalars['ID']['input'];
  rocketReachId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationSetUserTimeZoneSettingsArgs = {
  timeZone?: InputMaybe<Scalars['String']['input']>;
};


export type MutationShareHomeDashboardArgs = {
  id: Scalars['ID']['input'];
};


export type MutationShareKpiDashboardArgs = {
  dashboardId: Scalars['String']['input'];
};


export type MutationShareLossRunsBatchArgs = {
  batchId: Scalars['String']['input'];
  userIds: Array<Scalars['String']['input']>;
};


export type MutationSourceDataApproveSubmissionArgs = {
  acknowledge?: InputMaybe<Array<SourceDataGateAcknowledgementInput>>;
  externalSystemId?: InputMaybe<Scalars['ID']['input']>;
  uploadId: Scalars['String']['input'];
};


export type MutationSourceDataDeleteUploadArgs = {
  externalSystemId?: InputMaybe<Scalars['ID']['input']>;
  uploadId: Scalars['String']['input'];
};


export type MutationSourceDataInitUploadArgs = {
  amsType: AmsType;
  externalSystemId?: InputMaybe<Scalars['ID']['input']>;
  fileName: Scalars['String']['input'];
  sha256?: InputMaybe<Scalars['String']['input']>;
  sizeBytes?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSourceDataSubmitCustomMappingArgs = {
  externalSystemId?: InputMaybe<Scalars['ID']['input']>;
  mapping: Array<SourceDataMappingInput>;
  uploadId: Scalars['String']['input'];
};


export type MutationSourceDataSubmitMappingArgs = {
  externalSystemId?: InputMaybe<Scalars['ID']['input']>;
  uploadId: Scalars['String']['input'];
};


export type MutationSourceDataValidateUploadArgs = {
  externalSystemId?: InputMaybe<Scalars['ID']['input']>;
  uploadId: Scalars['String']['input'];
};


export type MutationUnlinkUserFromAmsArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationUpdateEnnablUserArgs = {
  input: EnnablUserUpdateInput;
};


export type MutationUpdateEnnablUserRoleArgs = {
  id: Scalars['ID']['input'];
  input: EnnablUserRoleUpdateInput;
};


export type MutationUpdateEnnablUsersBatchArgs = {
  input: BatchEnnablUsersUpdateInput;
};


export type MutationUpdateFilterArgs = {
  id: Scalars['ID']['input'];
  payload: StoredFiltersUpdatePayload;
};


export type MutationUpdateFilterLastUsedArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUpdateKpiDashboardArgs = {
  dashboard: KpiDashboardUpdateInput;
};


export type MutationUpdateListsOfOpportunitiesArgs = {
  listIds: Array<Scalars['ID']['input']>;
  opportunityIds: Array<Scalars['ID']['input']>;
  producerId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateOpportunityListArgs = {
  opportunityList: OpportunityListUpdateInput;
  producerId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateReportTemplateArgs = {
  template: ReportTemplateInput;
  templateId: Scalars['ID']['input'];
};


export type MutationUpdateUserReportPresetArgs = {
  preset: UserReportPresetInput;
  presetId: Scalars['String']['input'];
};


export type MutationUpdateUserReportPresetScheduleArgs = {
  presetId: Scalars['String']['input'];
  schedule?: InputMaybe<ReportSubscriptionScheduleInput>;
};


export type MutationUpsertDashboardsArgs = {
  input: Array<DashboardUpsertInput>;
};


export type MutationUpsertDocumentsFilterArgs = {
  input: UpsertDocumentsFilter;
};


export type MutationUpsertPolicyFilterArgs = {
  input: UpsertPolicyFilter;
};

export type NetNewOpportunityRecommendation = {
  __typename?: 'NetNewOpportunityRecommendation';
  address?: Maybe<ProspectAddress>;
  employees?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  industry?: Maybe<Industry>;
  /** Company or Individual name */
  name: Scalars['String']['output'];
  prospect?: Maybe<Prospect>;
  revenue?: Maybe<Scalars['Float']['output']>;
};

export type NetNewOpportunityRecommendationPaginatedResult = {
  __typename?: 'NetNewOpportunityRecommendationPaginatedResult';
  items: Array<NetNewOpportunityRecommendation>;
  totalHits: Scalars['Int']['output'];
};

export type NetNewOpportunityRecommendationPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<NetNewOpportunityRecommendationSortingField>;
  /** Total count will be different if we use sorting by metric with permissions */
  sortOrder?: InputMaybe<SortOrder>;
};

export enum NetNewOpportunityRecommendationSortingField {
  CompanyName = 'COMPANY_NAME'
}

export type Opportunities = {
  __typename?: 'Opportunities';
  targetIndustry: Array<TargetIndustryOpportunity>;
  targetIndustryV2: Array<TargetIndustryOpportunityV2>;
};


export type OpportunitiesTargetIndustryArgs = {
  filter?: InputMaybe<PolicyFilter>;
};


export type OpportunitiesTargetIndustryV2Args = {
  filter?: InputMaybe<PolicyFilter>;
  industryParentId?: InputMaybe<Scalars['ID']['input']>;
};

export type OpportunitiesWidgetParams = {
  __typename?: 'OpportunitiesWidgetParams';
  entity: WidgetEntity;
  entityKeys?: Maybe<Array<WidgetEntity>>;
  filter?: Maybe<PolicyFilterOutput>;
  tableEntity?: Maybe<WidgetEntity>;
};

export type OpportunitiesWidgetParamsInput = {
  entity: WidgetEntity;
  entityKeys?: InputMaybe<Array<WidgetEntity>>;
  filter?: InputMaybe<PolicyFilter>;
  tableEntity?: InputMaybe<WidgetEntity>;
};

export type OpportunityAggregationByMonth = {
  __typename?: 'OpportunityAggregationByMonth';
  count: Scalars['Int']['output'];
  month: Month;
};

export type OpportunityAggregationByProducer = {
  __typename?: 'OpportunityAggregationByProducer';
  count: Scalars['Int']['output'];
  producer: User;
};

export type OpportunityCrossSellRecord = {
  __typename?: 'OpportunityCrossSellRecord';
  client: Client;
  /** Item could be null if mapping was changed */
  productsBought: Array<Maybe<Product>>;
  /** Item could be null if mapping was changed */
  productsNotBought: Array<Maybe<Product>>;
};

export type OpportunityCrossSellReport = {
  __typename?: 'OpportunityCrossSellReport';
  records: Array<OpportunityCrossSellRecord>;
  report: OpportunityReport;
  total: OpportunityOverviewTotal;
};

export type OpportunityList = {
  __typename?: 'OpportunityList';
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['Timestamp']['output'];
};

export type OpportunityListCreateInput = {
  title: Scalars['String']['input'];
};

export type OpportunityListUpdateInput = {
  id: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};

export type OpportunityLists = {
  __typename?: 'OpportunityLists';
  all: Array<OpportunityList>;
};


export type OpportunityListsAllArgs = {
  producerId?: InputMaybe<Scalars['String']['input']>;
};

export type OpportunityOverviewTotal = {
  __typename?: 'OpportunityOverviewTotal';
  clients: Scalars['Int']['output'];
  policies: Scalars['Int']['output'];
  /** @deprecated Not needed */
  revenue?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Not needed */
  revenueBand: Band;
  /** ((Unique count of agency clients purchasing at least one products bought AND at least one products not bought) / (Unique count of agency clients purchasing at least one products bought)) */
  similarClientsBuyingPct?: Maybe<Scalars['Float']['output']>;
  totalUpsellAmount?: Maybe<Scalars['Float']['output']>;
};

export type OpportunityRecommendation = {
  __typename?: 'OpportunityRecommendation';
  product: Product;
  rate: Scalars['Float']['output'];
  saved?: Maybe<SavedOpportunityCrossSell>;
};

export type OpportunityRecords = {
  __typename?: 'OpportunityRecords';
  records: Array<OpportunityCrossSellRecord>;
  report: OpportunityReport;
};

export type OpportunityReport = {
  __typename?: 'OpportunityReport';
  category: OpportunityReportCategory;
  createdAt: Scalars['Timestamp']['output'];
  criteria: CrossSellReportCriteria;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type: OpportunityReportType;
};

export enum OpportunityReportCategory {
  Recent = 'RECENT',
  Saved = 'SAVED'
}

export type OpportunityReportList = {
  __typename?: 'OpportunityReportList';
  items: Array<OpportunityReport>;
};

export enum OpportunityReportType {
  CrossSell = 'CROSS_SELL'
}

export type OpportunityReports = {
  __typename?: 'OpportunityReports';
  getById?: Maybe<OpportunityCrossSellReport>;
  /** @deprecated deprecated */
  list: OpportunityReportList;
  /** @deprecated deprecated */
  recent: OpportunityReportList;
  /** @deprecated deprecated */
  reportRecords: OpportunityRecords;
};


export type OpportunityReportsGetByIdArgs = {
  id: Scalars['String']['input'];
  pagination?: InputMaybe<CrossSellPaginationInput>;
};


export type OpportunityReportsRecentArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type OpportunityReportsReportRecordsArgs = {
  id: Scalars['String']['input'];
  pagination?: InputMaybe<CrossSellPaginationInput>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type OutflowInflow = {
  __typename?: 'OutflowInflow';
  chartData: OutflowInflowChartData;
  drillDownData: Array<Policy>;
};


export type OutflowInflowChartDataArgs = {
  carrierLevel?: InputMaybe<CarrierLevel>;
  filter?: InputMaybe<PolicyFilter>;
  outflowInflowFilter?: InputMaybe<OutflowInflowFilterInput>;
};


export type OutflowInflowDrillDownDataArgs = {
  carrierLevel?: InputMaybe<CarrierLevel>;
  filter?: InputMaybe<PolicyFilter>;
  outflowInflowDrillDownFilter?: InputMaybe<OutflowInflowDrillDownFilter>;
  outflowInflowFilter?: InputMaybe<OutflowInflowFilterInput>;
};

export type OutflowInflowChartData = {
  __typename?: 'OutflowInflowChartData';
  flows: Array<OutflowInflowFlowItem>;
  inflowTotal: OutflowInflowTotal;
  inflows: Array<OutflowInflowMarket>;
  outflowTotal: OutflowInflowTotal;
  outflows: Array<OutflowInflowMarket>;
  products: Array<OutflowInflowProduct>;
};

export type OutflowInflowDrillDownFilter = {
  inflowMarketId?: InputMaybe<Scalars['String']['input']>;
  outflowMarketId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
};

export type OutflowInflowFilter = {
  __typename?: 'OutflowInflowFilter';
  industryIds?: Maybe<Array<Scalars['String']['output']>>;
  inflowCarrierIds?: Maybe<Array<Scalars['String']['output']>>;
  outflowCarrierIds?: Maybe<Array<Scalars['String']['output']>>;
  productIds?: Maybe<Array<Scalars['String']['output']>>;
  size?: Maybe<Scalars['Int']['output']>;
};

export type OutflowInflowFilterInput = {
  industryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  inflowCarrierIds?: InputMaybe<Array<Scalars['String']['input']>>;
  outflowCarrierIds?: InputMaybe<Array<Scalars['String']['input']>>;
  productIds?: InputMaybe<Array<Scalars['String']['input']>>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type OutflowInflowFlowItem = {
  __typename?: 'OutflowInflowFlowItem';
  inflowMarket: Market;
  outflowMarket: Market;
  policyCount: Scalars['Int']['output'];
  premium: Scalars['Float']['output'];
  product: Product;
};

export type OutflowInflowMarket = {
  __typename?: 'OutflowInflowMarket';
  id: Scalars['ID']['output'];
  market: Market;
  policyCount: Scalars['Int']['output'];
  premium: Scalars['Float']['output'];
};

export type OutflowInflowProduct = {
  __typename?: 'OutflowInflowProduct';
  id: Scalars['ID']['output'];
  policyCount: Scalars['Int']['output'];
  premium: Scalars['Float']['output'];
  product: Product;
};

export type OutflowInflowTotal = {
  __typename?: 'OutflowInflowTotal';
  marketCount: Scalars['Int']['output'];
  policyCount: Scalars['Int']['output'];
  premium: Scalars['Float']['output'];
  productCount: Scalars['Int']['output'];
  revenue: Scalars['Float']['output'];
};

export type OutputRange = {
  __typename?: 'OutputRange';
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
};

export type PageCustomSettings = {
  __typename?: 'PageCustomSettings';
  id: Scalars['ID']['output'];
  /** string or JSON containing data for a custom setting */
  value: Scalars['String']['output'];
};

export type PageCustomSettingsInput = {
  id: Scalars['ID']['input'];
  /** string or JSON containing data for a custom setting */
  value: Scalars['String']['input'];
};

export type PageSectionSettings = {
  __typename?: 'PageSectionSettings';
  collapsed: Scalars['Boolean']['output'];
  hidden: Scalars['Boolean']['output'];
  sectionId: Scalars['ID']['output'];
};

export type PageSectionSettingsInput = {
  collapsed: Scalars['Boolean']['input'];
  hidden: Scalars['Boolean']['input'];
  sectionId: Scalars['ID']['input'];
};

export type PageSettings = {
  __typename?: 'PageSettings';
  customSettings?: Maybe<Array<PageCustomSettings>>;
  filter?: Maybe<PolicyFilterOutput>;
  pageId: Scalars['ID']['output'];
  sections?: Maybe<Array<PageSectionSettings>>;
};

export type PageSettingsInput = {
  customSettings?: InputMaybe<Array<PageCustomSettingsInput>>;
  pageId: Scalars['ID']['input'];
  sections?: InputMaybe<Array<PageSectionSettingsInput>>;
};

export type ParticipantsCount = {
  __typename?: 'ParticipantsCount';
  /** Source: participants_boy_total */
  beginOfYearTotal?: Maybe<Scalars['Int']['output']>;
  /** Source: participants_boy_total_active */
  beginOfYearTotalActive?: Maybe<Scalars['Int']['output']>;
  /** Source: participants_eoy_total_active */
  endOfYearTotal?: Maybe<Scalars['Int']['output']>;
  /** Source: participants_eoy_total_active */
  endOfYearTotalActive?: Maybe<Scalars['Int']['output']>;
};

export enum PayToLevel {
  ChildPayTo = 'CHILD_PAY_TO',
  ParentPayTo = 'PARENT_PAY_TO',
  UltimateParentPayTo = 'ULTIMATE_PARENT_PAY_TO'
}

/** Builds percentile filters for entity by metric */
export type PercentileFilter = {
  entity: PolicyEntity;
  from?: InputMaybe<Scalars['Float']['input']>;
  metric: PolicyMetric;
  to?: InputMaybe<Scalars['Float']['input']>;
};

export type PercentileFilterOutput = {
  __typename?: 'PercentileFilterOutput';
  entity: PolicyEntity;
  from?: Maybe<Scalars['Float']['output']>;
  metric: PolicyMetric;
  to?: Maybe<Scalars['Float']['output']>;
};

export type Period = {
  /** BILLED - get metrics from billed transaction. WRITTEN - get metrics from written policies. */
  amountType?: InputMaybe<PolicyAmountType>;
  /** Only for FROM_TO */
  from?: InputMaybe<Scalars['SimpleDate']['input']>;
  /** Not working for IN_FORCE */
  inclusionDateType?: InputMaybe<InclusionDateType>;
  /** Only for YTD, ROLLING_12, and IN_FORCE */
  timestamp?: InputMaybe<Scalars['SimpleDate']['input']>;
  /** Only for FROM_TO */
  to?: InputMaybe<Scalars['SimpleDate']['input']>;
  type?: InputMaybe<PeriodType>;
};

export type PeriodOutput = {
  __typename?: 'PeriodOutput';
  /** BILLED - get metrics from billed transaction. WRITTEN - get metrics from written policies. */
  amountType?: Maybe<PolicyAmountType>;
  /** Only for FROM_TO */
  from?: Maybe<Scalars['SimpleDate']['output']>;
  /** Not working for IN_FORCE */
  inclusionDateType?: Maybe<InclusionDateType>;
  /** Only for YTD, ROLLING_12, and IN_FORCE */
  timestamp?: Maybe<Scalars['SimpleDate']['output']>;
  /** Only for FROM_TO */
  to?: Maybe<Scalars['SimpleDate']['output']>;
  type?: Maybe<PeriodType>;
};

/** Time period or exact date */
export enum PeriodType {
  AllTime = 'ALL_TIME',
  FromTo = 'FROM_TO',
  InForce = 'IN_FORCE',
  Rolling_12Months = 'ROLLING_12_MONTHS',
  Ytd = 'YTD'
}

export type PlacementAnalysisOptions = {
  ignoreDirect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PoliciesWidgetParams = {
  __typename?: 'PoliciesWidgetParams';
  filter?: Maybe<PolicyFilterOutput>;
};

export type PoliciesWidgetParamsInput = {
  filter?: InputMaybe<PolicyFilter>;
};

export type Policy = {
  __typename?: 'Policy';
  accountExecutives?: Maybe<Array<User>>;
  accountManager?: Maybe<User>;
  amsPolicyStatus: AmsPolicyStatus;
  /** Annualized written amounts for the policy, based on AMS written */
  annualizedWritten?: Maybe<Amount>;
  /** Billed amounts for the policy (for all time) */
  billed: Amount;
  cancelDate?: Maybe<Scalars['SimpleDate']['output']>;
  carrier?: Maybe<Market>;
  client: Client;
  clientAgencyCodes?: Maybe<Array<Scalars['String']['output']>>;
  dataIssues?: Maybe<Array<PolicyDataIssue>>;
  /** Lowest level department */
  department: Department;
  detailedStatus: DetailedPolicyStatus;
  endDate: Scalars['SimpleDate']['output'];
  /** min of cancelDate and endDate */
  expirationDate: Scalars['SimpleDate']['output'];
  /** Amount for the policy based on "PolicyFilter.period". For written amount type equal to `written`, for billed - sum of amounts of filtered transactions */
  filteredAmount: Amount;
  id: Scalars['ID']['output'];
  industry?: Maybe<Industry>;
  industryGroup?: Maybe<Industry>;
  industrySubGroup?: Maybe<Industry>;
  insuranceSegment?: Maybe<Product>;
  intermediary?: Maybe<Market>;
  isClientLost?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Deprecated */
  isCrossSell: Scalars['Boolean']['output'];
  isInForce: Scalars['Boolean']['output'];
  isLost: Scalars['Boolean']['output'];
  isRewrite: Scalars['Boolean']['output'];
  /** @deprecated Deprecated */
  isWinBack: Scalars['Boolean']['output'];
  issuingPaper?: Maybe<Market>;
  mgaBind: Scalars['Float']['output'];
  mgaCommission?: Maybe<Scalars['Float']['output']>;
  mgaQuote: Scalars['Float']['output'];
  /** Retail Agency for MGAs */
  mgaRetailAgency?: Maybe<Market>;
  mgaRevenue?: Maybe<Scalars['Float']['output']>;
  naicsSourceConfidenceScore?: Maybe<Scalars['String']['output']>;
  nextPolicyStartDate?: Maybe<Scalars['SimpleDate']['output']>;
  payTo?: Maybe<Market>;
  policyAgencyCodes?: Maybe<Array<Scalars['String']['output']>>;
  policyNumber?: Maybe<Scalars['String']['output']>;
  policySources?: Maybe<Array<Scalars['String']['output']>>;
  /** @deprecated use producers */
  producer?: Maybe<User>;
  producers?: Maybe<Array<User>>;
  product?: Maybe<Product>;
  productGroup?: Maybe<Product>;
  productLines: Array<Product>;
  productSuperGroup?: Maybe<Product>;
  renewalStage?: Maybe<Scalars['String']['output']>;
  renewalStatus: RenewalStatus;
  revenueBand: Band;
  sourceCarrier?: Maybe<SimpleEntity>;
  sourceClient?: Maybe<SimpleEntity>;
  sourceClientNumber?: Maybe<Scalars['String']['output']>;
  sourceIntermediary?: Maybe<SimpleEntity>;
  sourceProduct?: Maybe<SimpleEntity>;
  sourceWritten: Amount;
  startDate: Scalars['SimpleDate']['output'];
  transactions: Array<Transaction>;
  upcomingRenewalState?: Maybe<UpcomingRenewalState>;
  written: Amount;
};

export enum PolicyAmountType {
  /** Written amount normalized to 12 months, based on AMS written */
  AnnualizedWritten = 'ANNUALIZED_WRITTEN',
  /** Already transmitted payments */
  Billed = 'BILLED',
  /** AMS data of what is expected in total from policy */
  SourceWritten = 'SOURCE_WRITTEN',
  /** Ennabl Estimate of what is expected in total from policy */
  Written = 'WRITTEN'
}

export enum PolicyDataIssue {
  CompanyMissingNaics = 'COMPANY_MISSING_NAICS',
  Duplicate = 'DUPLICATE',
  FlatCanceled = 'FLAT_CANCELED',
  InvalidDates = 'INVALID_DATES',
  InvalidPolicyNumber = 'INVALID_POLICY_NUMBER',
  MissingAccountManager = 'MISSING_ACCOUNT_MANAGER',
  MissingBillings = 'MISSING_BILLINGS',
  MissingIssuingPaper = 'MISSING_ISSUING_PAPER',
  MissingLineOfBusiness = 'MISSING_LINE_OF_BUSINESS',
  MissingProducer = 'MISSING_PRODUCER',
  OutstandingRevenue = 'OUTSTANDING_REVENUE',
  Underestimated = 'UNDERESTIMATED',
  UnmappedMarket = 'UNMAPPED_MARKET',
  UnmappedProduct = 'UNMAPPED_PRODUCT'
}

export type PolicyDataIssuesGroup = {
  /** To identify the group in the response */
  id: Scalars['String']['input'];
  issues: Array<PolicyDataIssue>;
};

export enum PolicyEntity {
  AccountExecutive = 'ACCOUNT_EXECUTIVE',
  AccountManager = 'ACCOUNT_MANAGER',
  Client = 'CLIENT',
  Industry = 'INDUSTRY',
  IndustryGroup = 'INDUSTRY_GROUP',
  IndustrySubgroup = 'INDUSTRY_SUBGROUP',
  IssuingPaper = 'ISSUING_PAPER',
  Producer = 'PRODUCER',
  Product = 'PRODUCT',
  ProductGroup = 'PRODUCT_GROUP',
  ProductInsuranceSegment = 'PRODUCT_INSURANCE_SEGMENT',
  ProductSuperGroup = 'PRODUCT_SUPER_GROUP',
  UltimateParentCarrier = 'ULTIMATE_PARENT_CARRIER',
  UltimateParentIntermediary = 'ULTIMATE_PARENT_INTERMEDIARY'
}

export type PolicyFilter = {
  /** @deprecated use userFilters */
  accountManagerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  accountSize?: InputMaybe<FilterRange>;
  /** Filter only for activities entity, does not work for policies and other entities */
  activityFilter?: InputMaybe<ActivityFilter>;
  /** Additional periods to refine processed policy set. It has limited support, consult before use */
  additionalPeriods?: InputMaybe<Array<Period>>;
  /** @deprecated use CompanyFilters */
  allLevelCarrierIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated use CompanyFilters */
  allLevelIntermediaryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  brokerMarketStatuses?: InputMaybe<Array<BrokerMarketStatus>>;
  /** @deprecated use CompanyFilters */
  carrierIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated AM Best data is no longer maintained (data provider contract ended). */
  carrierRatings?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated use CompanyFilters */
  childIntermediaryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  clientAgencyCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  clientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * search policies by client name
   * @deprecated Not needed anymore. Let's implement flexible text-filter if needed.
   */
  clientName?: InputMaybe<Scalars['String']['input']>;
  clientStatuses?: InputMaybe<Array<AggClientStatus>>;
  /** Search bounds for commission percentage */
  commissionPctRange?: InputMaybe<FilterRange>;
  companyEmployeesSizeRange?: InputMaybe<FilterRange>;
  /** use this object to set up combination of company filters that is needed */
  companyFilters?: InputMaybe<CompanyFilters>;
  /**
   * filters company by top level carrier, issuing paper or intermediary
   * @deprecated use CompanyFilters
   */
  companyIds?: InputMaybe<Array<Scalars['String']['input']>>;
  companySalesRange?: InputMaybe<FilterRange>;
  /** @deprecated Use location filter */
  counties?: InputMaybe<Array<Scalars['String']['input']>>;
  dataIssues?: InputMaybe<Array<PolicyDataIssue>>;
  datasourceType?: InputMaybe<DatasourceType>;
  departmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Special field that will be applied to some reports (where we show Department / BizOrg column), and byDepartment aggregation, by default it will be the first level, where children length > 1 */
  departmentLevel?: InputMaybe<DepartmentLevel>;
  /** Policies without intermediary */
  direct?: InputMaybe<Scalars['Boolean']['input']>;
  /** use this object to set up industry filters */
  industryFilters?: InputMaybe<Array<IndustryFilter>>;
  /** @deprecated Use industryFilters */
  industryGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Use industryFilters */
  industryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Use industryFilters */
  industrySubGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated use CompanyFilters */
  intermediaryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  isCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Deprecated */
  isClientCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  isClientLost?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Deprecated */
  isCrossSell?: InputMaybe<Scalars['Boolean']['input']>;
  /** filters lost policies by detailed lost reason */
  isExpiredAndNonRenewed?: InputMaybe<Scalars['Boolean']['input']>;
  isFee?: InputMaybe<Scalars['Boolean']['input']>;
  isLost?: InputMaybe<Scalars['Boolean']['input']>;
  /** If client has only one product */
  isMonoline?: InputMaybe<Scalars['Boolean']['input']>;
  isRenewable?: InputMaybe<Scalars['Boolean']['input']>;
  isRewrite?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated use CompanyFilters */
  issuingPaperIds?: InputMaybe<Array<Scalars['String']['input']>>;
  location?: InputMaybe<LocationFilter>;
  /** Serialized JSON metadata field for FE */
  metadata?: InputMaybe<Scalars['String']['input']>;
  /** Search bounds for MGA commission percentage */
  mgaCommissionPctRange?: InputMaybe<FilterRange>;
  naicsSourceConfidenceScore?: InputMaybe<Array<FilterRange>>;
  /** @deprecated use CompanyFilters */
  parentCarrierIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated use CompanyFilters */
  parentIntermediaryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Aggregation-based filter, incompatible with other aggregation-based filters */
  percentileFilter?: InputMaybe<PercentileFilter>;
  period?: InputMaybe<Period>;
  policyAgencyCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** explicitly specify policy set */
  policyIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated use policySourcesFilter instead */
  policySources?: InputMaybe<Array<Scalars['String']['input']>>;
  policySourcesFilter?: InputMaybe<PolicySourceFilter>;
  policyStatusType?: InputMaybe<PolicyStatusType>;
  policyStatuses?: InputMaybe<Array<AggPolicyStatus>>;
  /** Use AND logic between objects */
  policyStatusesAnd?: InputMaybe<Array<PolicyStatusFilter>>;
  premiumAccountSize?: InputMaybe<FilterRange>;
  /** @deprecated use userFilters */
  producerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  productFilters?: InputMaybe<Array<ProductPolicyFilter>>;
  /** @deprecated Use productFilters */
  productGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Use productFilters */
  productIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Use productFilters */
  productInsuranceSegmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Use productFilters */
  productSuperGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** search policies by keyword */
  query?: InputMaybe<Scalars['String']['input']>;
  /**
   * Companies with AM Best rank
   * @deprecated AM Best data is no longer maintained (data provider contract ended).
   */
  ranked?: InputMaybe<Scalars['Boolean']['input']>;
  renewalStatus?: InputMaybe<RenewalStatus>;
  retailAgencyCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Retail agency (client for MGAs) */
  retailAgencyIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Retail agency state/region for MGAs */
  retailAgencyStates?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceAgencyStatuses?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceCompanyIds?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceProductIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * US states iso 3166 codes
   * @deprecated Use location filter
   */
  states?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Used for updating of stored last used time */
  storedId?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use CompanyFilters */
  ultimateCarrierIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated use CompanyFilters */
  ultimateIntermediaryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  userFilters?: InputMaybe<UserFilters>;
  userFiltersAnd?: InputMaybe<Array<UserFilters>>;
};

export type PolicyFilterOutput = {
  __typename?: 'PolicyFilterOutput';
  /** @deprecated use userFilters */
  accountManagerIds?: Maybe<Array<Scalars['String']['output']>>;
  accountSize?: Maybe<FilterRangeOutput>;
  /** Filter only for activities entity, does not work for policies and other entities */
  activityFilter?: Maybe<ActivityFilterOutput>;
  /** Additional periods to refine processed policy set. It has limited support, consult before use */
  additionalPeriods?: Maybe<Array<PeriodOutput>>;
  /** @deprecated use CompanyFilters */
  allLevelCarrierIds?: Maybe<Array<Scalars['String']['output']>>;
  /** @deprecated use CompanyFilters */
  allLevelIntermediaryIds?: Maybe<Array<Scalars['String']['output']>>;
  brokerMarketStatuses?: Maybe<Array<BrokerMarketStatus>>;
  /** @deprecated use CompanyFilters */
  carrierIds?: Maybe<Array<Scalars['String']['output']>>;
  /** @deprecated AM Best data is no longer maintained (data provider contract ended). */
  carrierRatings?: Maybe<Array<Scalars['String']['output']>>;
  /** @deprecated use CompanyFilters */
  childIntermediaryIds?: Maybe<Array<Scalars['String']['output']>>;
  clientAgencyCodes?: Maybe<Array<Scalars['String']['output']>>;
  clientIds?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * search policies by client name
   * @deprecated Not needed anymore. Let's implement flexible text-filter if needed.
   */
  clientName?: Maybe<Scalars['String']['output']>;
  clientStatuses?: Maybe<Array<AggClientStatus>>;
  /** Search bounds for commission percentage */
  commissionPctRange?: Maybe<FilterRangeOutput>;
  companyEmployeesSizeRange?: Maybe<FilterRangeOutput>;
  /** use this object to set up combination of company filters that is needed */
  companyFilters?: Maybe<CompanyFiltersOutput>;
  /**
   * filters company by top level carrier, issuing paper or intermediary
   * @deprecated use CompanyFilters
   */
  companyIds?: Maybe<Array<Scalars['String']['output']>>;
  companySalesRange?: Maybe<FilterRangeOutput>;
  /** @deprecated Use location filter */
  counties?: Maybe<Array<Scalars['String']['output']>>;
  dataIssues?: Maybe<Array<PolicyDataIssue>>;
  datasourceType?: Maybe<DatasourceType>;
  departmentIds?: Maybe<Array<Scalars['String']['output']>>;
  /** Special field that will be applied to some reports (where we show Department / BizOrg column), and byDepartment aggregation, by default it will be the first level, where children length > 1 */
  departmentLevel?: Maybe<DepartmentLevel>;
  /** Policies without intermediary */
  direct?: Maybe<Scalars['Boolean']['output']>;
  /** use this object to set up industry filters */
  industryFilters?: Maybe<Array<IndustryFilterOutput>>;
  /** @deprecated Use industryFilters */
  industryGroupIds?: Maybe<Array<Scalars['String']['output']>>;
  /** @deprecated Use industryFilters */
  industryIds?: Maybe<Array<Scalars['String']['output']>>;
  /** @deprecated Use industryFilters */
  industrySubGroupIds?: Maybe<Array<Scalars['String']['output']>>;
  /** @deprecated use CompanyFilters */
  intermediaryIds?: Maybe<Array<Scalars['String']['output']>>;
  isCancelled?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Deprecated */
  isClientCancelled?: Maybe<Scalars['Boolean']['output']>;
  isClientLost?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Deprecated */
  isCrossSell?: Maybe<Scalars['Boolean']['output']>;
  /** filters lost policies by detailed lost reason */
  isExpiredAndNonRenewed?: Maybe<Scalars['Boolean']['output']>;
  isFee?: Maybe<Scalars['Boolean']['output']>;
  isLost?: Maybe<Scalars['Boolean']['output']>;
  /** If client has only one product */
  isMonoline?: Maybe<Scalars['Boolean']['output']>;
  isRenewable?: Maybe<Scalars['Boolean']['output']>;
  isRewrite?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use CompanyFilters */
  issuingPaperIds?: Maybe<Array<Scalars['String']['output']>>;
  location?: Maybe<LocationFilterOutput>;
  /** Serialized JSON metadata field for FE */
  metadata?: Maybe<Scalars['String']['output']>;
  /** Search bounds for MGA commission percentage */
  mgaCommissionPctRange?: Maybe<FilterRangeOutput>;
  naicsSourceConfidenceScore?: Maybe<Array<FilterRangeOutput>>;
  /** @deprecated use CompanyFilters */
  parentCarrierIds?: Maybe<Array<Scalars['String']['output']>>;
  /** @deprecated use CompanyFilters */
  parentIntermediaryIds?: Maybe<Array<Scalars['String']['output']>>;
  /** Aggregation-based filter, incompatible with other aggregation-based filters */
  percentileFilter?: Maybe<PercentileFilterOutput>;
  period?: Maybe<PeriodOutput>;
  policyAgencyCodes?: Maybe<Array<Scalars['String']['output']>>;
  /** explicitly specify policy set */
  policyIds?: Maybe<Array<Scalars['String']['output']>>;
  /** @deprecated use policySourcesFilter instead */
  policySources?: Maybe<Array<Scalars['String']['output']>>;
  policySourcesFilter?: Maybe<PolicySourceFilterOutput>;
  policyStatusType?: Maybe<PolicyStatusType>;
  policyStatuses?: Maybe<Array<AggPolicyStatus>>;
  /** Use AND logic between objects */
  policyStatusesAnd?: Maybe<Array<PolicyStatusFilterOutput>>;
  premiumAccountSize?: Maybe<FilterRangeOutput>;
  /** @deprecated use userFilters */
  producerIds?: Maybe<Array<Scalars['String']['output']>>;
  productFilters?: Maybe<Array<ProductPolicyFilterOutput>>;
  /** @deprecated Use productFilters */
  productGroupIds?: Maybe<Array<Scalars['String']['output']>>;
  /** @deprecated Use productFilters */
  productIds?: Maybe<Array<Scalars['String']['output']>>;
  /** @deprecated Use productFilters */
  productInsuranceSegmentIds?: Maybe<Array<Scalars['String']['output']>>;
  /** @deprecated Use productFilters */
  productSuperGroupIds?: Maybe<Array<Scalars['String']['output']>>;
  /** search policies by keyword */
  query?: Maybe<Scalars['String']['output']>;
  /**
   * Companies with AM Best rank
   * @deprecated AM Best data is no longer maintained (data provider contract ended).
   */
  ranked?: Maybe<Scalars['Boolean']['output']>;
  renewalStatus?: Maybe<RenewalStatus>;
  retailAgencyCodes?: Maybe<Array<Scalars['String']['output']>>;
  /** Retail agency (client for MGAs) */
  retailAgencyIds?: Maybe<Array<Scalars['String']['output']>>;
  /** Retail agency state/region for MGAs */
  retailAgencyStates?: Maybe<Array<Scalars['String']['output']>>;
  sourceAgencyStatuses?: Maybe<Array<Scalars['String']['output']>>;
  sourceCompanyIds?: Maybe<Array<Scalars['String']['output']>>;
  sourceProductIds?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * US states iso 3166 codes
   * @deprecated Use location filter
   */
  states?: Maybe<Array<Scalars['String']['output']>>;
  /** Used for updating of stored last used time */
  storedId?: Maybe<Scalars['String']['output']>;
  /** @deprecated use CompanyFilters */
  ultimateCarrierIds?: Maybe<Array<Scalars['String']['output']>>;
  /** @deprecated use CompanyFilters */
  ultimateIntermediaryIds?: Maybe<Array<Scalars['String']['output']>>;
  userFilters?: Maybe<UserFiltersOutput>;
  userFiltersAnd?: Maybe<Array<UserFiltersOutput>>;
};

export type PolicyListPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<PolicySortBy>;
  /** Total count will be different if we use sorting by metric with permissions */
  sortOrder?: InputMaybe<SortOrder>;
};

export enum PolicyMetric {
  AccountExecutiveDistinctCount = 'ACCOUNT_EXECUTIVE_DISTINCT_COUNT',
  AccountManagerDistinctCount = 'ACCOUNT_MANAGER_DISTINCT_COUNT',
  AvgPoliciesPerAm = 'AVG_POLICIES_PER_AM',
  AvgPremiumPerClient = 'AVG_PREMIUM_PER_CLIENT',
  AvgProducersPerAm = 'AVG_PRODUCERS_PER_AM',
  AvgProductPerClient = 'AVG_PRODUCT_PER_CLIENT',
  AvgRevenuePerAm = 'AVG_REVENUE_PER_AM',
  AvgRevenuePerClient = 'AVG_REVENUE_PER_CLIENT',
  /** @deprecated Use ULTIMATE_CARRIER_DISTINCT_COUNT instead */
  CarrierDistinctCount = 'CARRIER_DISTINCT_COUNT',
  ClientDistinctCount = 'CLIENT_DISTINCT_COUNT',
  CommissionAvg = 'COMMISSION_AVG',
  CommissionPctAvg = 'COMMISSION_PCT_AVG',
  CommissionSum = 'COMMISSION_SUM',
  DepartmentDistinctCount = 'DEPARTMENT_DISTINCT_COUNT',
  FeeSum = 'FEE_SUM',
  IndustryDistinctCount = 'INDUSTRY_DISTINCT_COUNT',
  IntermediaryDistinctCount = 'INTERMEDIARY_DISTINCT_COUNT',
  IssuingPaperDistinctCount = 'ISSUING_PAPER_DISTINCT_COUNT',
  MedianRevenuePerClient = 'MEDIAN_REVENUE_PER_CLIENT',
  MgaBindRatio = 'MGA_BIND_RATIO',
  MgaCommissionAvg = 'MGA_COMMISSION_AVG',
  MgaCommissionSum = 'MGA_COMMISSION_SUM',
  MgaRetailAgencyDistinctCount = 'MGA_RETAIL_AGENCY_DISTINCT_COUNT',
  MgaRevenueSum = 'MGA_REVENUE_SUM',
  NextRenewal = 'NEXT_RENEWAL',
  ParentCarrierDistinctCount = 'PARENT_CARRIER_DISTINCT_COUNT',
  PolicyCount = 'POLICY_COUNT',
  PremiumAvg = 'PREMIUM_AVG',
  PremiumSum = 'PREMIUM_SUM',
  PreviousCarrierDistinctCount = 'PREVIOUS_CARRIER_DISTINCT_COUNT',
  ProducerDistinctCount = 'PRODUCER_DISTINCT_COUNT',
  ProductDistinctCount = 'PRODUCT_DISTINCT_COUNT',
  RevenueAvg = 'REVENUE_AVG',
  RevenueSum = 'REVENUE_SUM',
  UltimateCarrierDistinctCount = 'ULTIMATE_CARRIER_DISTINCT_COUNT'
}

export enum PolicySortBy {
  BilledPremium = 'BILLED_PREMIUM',
  BilledRevenue = 'BILLED_REVENUE',
  EndDate = 'END_DATE',
  ExpirationDate = 'EXPIRATION_DATE',
  MgaRevenue = 'MGA_REVENUE',
  PolicyNumber = 'POLICY_NUMBER',
  Premium = 'PREMIUM',
  Revenue = 'REVENUE',
  StartDate = 'START_DATE'
}

/** Uses OR logic inside */
export type PolicySourceFilter = {
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  sources?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PolicySourceFilterOutput = {
  __typename?: 'PolicySourceFilterOutput';
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  sources?: Maybe<Array<Scalars['String']['output']>>;
};

export type PolicyStatusFilter = {
  /** Filter by AMS policy status codes. Uses OR logic between codes. */
  codes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Uses OR logic between statuses */
  statuses?: InputMaybe<Array<AggPolicyStatus>>;
};

/** OR logic between options */
export type PolicyStatusFilterOutput = {
  __typename?: 'PolicyStatusFilterOutput';
  /** Filter by AMS policy status codes. Uses OR logic between codes. */
  codes?: Maybe<Array<Scalars['String']['output']>>;
  /** Uses OR logic between statuses */
  statuses?: Maybe<Array<AggPolicyStatus>>;
};

export enum PolicyStatusType {
  /** Use retention fields taken from AMS */
  Ams = 'AMS',
  /** Use retention fields calculated by Ennabl */
  Ennabl = 'ENNABL'
}

export type PremiumFlow = {
  __typename?: 'PremiumFlow';
  bcoChart: PremiumFlowChartData;
  icoChart: PremiumFlowChartIcoData;
  intermediaryChart: PremiumFlowChartData;
  reportData: Array<PremiumFlowChartItem>;
};


export type PremiumFlowBcoChartArgs = {
  carrierLevel?: InputMaybe<CarrierLevel>;
  filter?: InputMaybe<PolicyFilter>;
};


export type PremiumFlowIcoChartArgs = {
  carrierLevel?: InputMaybe<CarrierLevel>;
  filter?: InputMaybe<PolicyFilter>;
};


export type PremiumFlowIntermediaryChartArgs = {
  carrierLevel?: InputMaybe<CarrierLevel>;
  filter?: InputMaybe<PolicyFilter>;
};


export type PremiumFlowReportDataArgs = {
  carrierLevel?: InputMaybe<CarrierLevel>;
  filter?: InputMaybe<PolicyFilter>;
  premiumFlowType: PremiumFlowType;
};

export type PremiumFlowChartData = {
  __typename?: 'PremiumFlowChartData';
  affiliates: PremiumFlowSectionData;
  direct: PremiumFlowSectionData;
};

export type PremiumFlowChartIcoData = {
  __typename?: 'PremiumFlowChartIcoData';
  direct: PremiumFlowSectionData;
  intermediary: PremiumFlowSectionData;
};

export type PremiumFlowChartItem = {
  __typename?: 'PremiumFlowChartItem';
  clientCount: Scalars['Int']['output'];
  commissionPctAvg?: Maybe<Scalars['Float']['output']>;
  commissionSum?: Maybe<Scalars['Float']['output']>;
  industryCount: Scalars['Int']['output'];
  /** @deprecated Use ultimateParent instead */
  issuingPaper?: Maybe<Market>;
  market: Market;
  /** @deprecated Use ultimateParent instead */
  payTo?: Maybe<Market>;
  policyCount: Scalars['Int']['output'];
  premiumSum: Scalars['Float']['output'];
  productCount: Scalars['Int']['output'];
  revenueSum: Scalars['Float']['output'];
  ultimateParent?: Maybe<Market>;
};

export type PremiumFlowSectionData = {
  __typename?: 'PremiumFlowSectionData';
  commissionPctAvg?: Maybe<Scalars['Float']['output']>;
  items: Array<PremiumFlowChartItem>;
  premiumSum: Scalars['Float']['output'];
};

export enum PremiumFlowType {
  Bco = 'BCO',
  Ico = 'ICO',
  Intermediary = 'INTERMEDIARY'
}

export type PremiumFlowWidgetParams = {
  __typename?: 'PremiumFlowWidgetParams';
  filter?: Maybe<PolicyFilterOutput>;
  withEntityTable?: Maybe<Scalars['Boolean']['output']>;
};

export type PremiumFlowWidgetParamsInput = {
  filter?: InputMaybe<PolicyFilter>;
  withEntityTable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PremiumOutflowInflowWidgetParams = {
  __typename?: 'PremiumOutflowInflowWidgetParams';
  filter?: Maybe<PolicyFilterOutput>;
  outflowInflowFilter?: Maybe<OutflowInflowFilter>;
};

export type PremiumOutflowInflowWidgetParamsInput = {
  filter?: InputMaybe<PolicyFilter>;
  outflowInflowFilter?: InputMaybe<OutflowInflowFilterInput>;
};

export type ProducerCredit = {
  __typename?: 'ProducerCredit';
  fullCredit: ProducerFullCreditPaginatedResult;
  sharedCredit: ProducerSharedCreditPaginatedResult;
};


export type ProducerCreditFullCreditArgs = {
  filter?: InputMaybe<PolicyFilter>;
  pagination?: InputMaybe<ProducerCreditPaginationInput>;
  producerId?: InputMaybe<Scalars['String']['input']>;
};


export type ProducerCreditSharedCreditArgs = {
  filter?: InputMaybe<PolicyFilter>;
  pagination?: InputMaybe<ProducerCreditPaginationInput>;
  producerId?: InputMaybe<Scalars['String']['input']>;
};

export type ProducerCreditPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<ProducerCreditSortingField>;
  /** Total count will be different if we use sorting by metric with permissions */
  sortOrder?: InputMaybe<SortOrder>;
};

export enum ProducerCreditSortingField {
  ClientName = 'CLIENT_NAME',
  IndustryName = 'INDUSTRY_NAME',
  PolicyCount = 'POLICY_COUNT',
  ProducerShare = 'PRODUCER_SHARE',
  Revenue = 'REVENUE',
  SharedWith = 'SHARED_WITH'
}

export type ProducerCrossSellGoal = {
  __typename?: 'ProducerCrossSellGoal';
  metric: ProducerGoalMetric;
  /** In cents */
  value: Scalars['Float']['output'];
};

export type ProducerFullCreditPaginatedResult = {
  __typename?: 'ProducerFullCreditPaginatedResult';
  items: Array<ProducerFullCreditRow>;
  totalHits: Scalars['Int']['output'];
};

export type ProducerFullCreditRow = {
  __typename?: 'ProducerFullCreditRow';
  client: Client;
  policies: Scalars['Int']['output'];
  revenue: Scalars['Float']['output'];
};

export type ProducerGoal = {
  __typename?: 'ProducerGoal';
  crossSellGoal?: Maybe<ProducerCrossSellGoal>;
  mgaPerformance: MgaProducerGoalPerformance;
  mgaPremiumGoal?: Maybe<MgaProducerPremiumGoal>;
  mgaRevenueGoal?: Maybe<MgaProducerRevenueGoal>;
  netNewGoal?: Maybe<ProducerNetNewGoal>;
  performance: ProducerGoalPerformance;
  retentionGoal?: Maybe<ProducerRetentionGoal>;
  year: Scalars['Int']['output'];
};


export type ProducerGoalMgaPerformanceArgs = {
  amountType?: InputMaybe<PolicyAmountType>;
};


export type ProducerGoalPerformanceArgs = {
  amountType?: InputMaybe<PolicyAmountType>;
};

export enum ProducerGoalMetric {
  Premium = 'PREMIUM',
  Revenue = 'REVENUE'
}

export type ProducerGoalPerformance = {
  __typename?: 'ProducerGoalPerformance';
  crossSell: ProducerGoalPerformanceValues;
  netNew: ProducerGoalPerformanceValues;
  retention: RetentionGoalPerformance;
};

export type ProducerGoalPerformanceValues = {
  __typename?: 'ProducerGoalPerformanceValues';
  clients: Scalars['Float']['output'];
  /** In cents */
  premium: Scalars['Float']['output'];
  /** In cents */
  revenue: Scalars['Float']['output'];
};

export type ProducerGoals = {
  __typename?: 'ProducerGoals';
  getForYear: ProducerGoal;
};


export type ProducerGoalsGetForYearArgs = {
  producerId?: InputMaybe<Scalars['String']['input']>;
  year: Scalars['Int']['input'];
};

export type ProducerMonolineRatio = {
  __typename?: 'ProducerMonolineRatio';
  metrics: MonolineRatioMetrics;
  producer: User;
};

export type ProducerMonolineRatioWithStats = {
  __typename?: 'ProducerMonolineRatioWithStats';
  items: Array<ProducerMonolineRatio>;
  statistics?: Maybe<MonolineRatioStatistics>;
};

export type ProducerNetNewGoal = {
  __typename?: 'ProducerNetNewGoal';
  metric: ProducerGoalMetric;
  /** In cents */
  value: Scalars['Float']['output'];
};

export type ProducerPortal = {
  __typename?: 'ProducerPortal';
  crossSell: CrossSellOpportunityRecommendationPaginatedResult;
  crossSellFilters: Array<CrossSellFilter>;
  monoline: MonolineOpportunityV2PaginatedResult;
  netNew: NetNewOpportunityRecommendationPaginatedResult;
  netNewById?: Maybe<NetNewOpportunityRecommendation>;
  renewals: RenewalsOpportunityPaginatedResult;
  userIdByProducerId?: Maybe<AuthUser>;
  winBackV2: WinBackOpportunityV2PaginatedResult;
};


export type ProducerPortalCrossSellArgs = {
  pagination?: InputMaybe<CrossSellOpportunityRecommendationPaginationInput>;
  producerId?: InputMaybe<Scalars['String']['input']>;
};


export type ProducerPortalMonolineArgs = {
  filter?: InputMaybe<PolicyFilter>;
  pagination?: InputMaybe<PolicyListPaginationInput>;
  producerId?: InputMaybe<Scalars['String']['input']>;
};


export type ProducerPortalNetNewArgs = {
  pagination?: InputMaybe<NetNewOpportunityRecommendationPaginationInput>;
  producerId?: InputMaybe<Scalars['String']['input']>;
};


export type ProducerPortalNetNewByIdArgs = {
  recommendationId: Scalars['String']['input'];
};


export type ProducerPortalRenewalsArgs = {
  filter?: InputMaybe<PolicyFilter>;
  pagination?: InputMaybe<RenewalsListPaginationInput>;
  producerId?: InputMaybe<Scalars['String']['input']>;
};


export type ProducerPortalUserIdByProducerIdArgs = {
  producerId: Scalars['String']['input'];
};


export type ProducerPortalWinBackV2Args = {
  filter?: InputMaybe<PolicyFilter>;
  pagination?: InputMaybe<PolicyListPaginationInput>;
  producerId?: InputMaybe<Scalars['String']['input']>;
};

export type ProducerRank = {
  __typename?: 'ProducerRank';
  filter?: Maybe<Scalars['String']['output']>;
  metricType?: Maybe<Scalars['String']['output']>;
};

export type ProducerRankEdge = {
  __typename?: 'ProducerRankEdge';
  filter?: Maybe<Scalars['String']['output']>;
  metricType?: Maybe<Scalars['String']['output']>;
};

export type ProducerRetentionGoal = {
  __typename?: 'ProducerRetentionGoal';
  metric: ProducerGoalMetric;
  /** Percentage, 0-1 */
  value: Scalars['Float']['output'];
};

export type ProducerSharedCreditPaginatedResult = {
  __typename?: 'ProducerSharedCreditPaginatedResult';
  items: Array<ProducerSharedCreditRow>;
  totalHits: Scalars['Int']['output'];
};

export type ProducerSharedCreditRow = {
  __typename?: 'ProducerSharedCreditRow';
  client: Client;
  myShare: Scalars['Float']['output'];
  policies: Scalars['Int']['output'];
  revenue: Scalars['Float']['output'];
  sharedWith: Array<User>;
};

export type ProducersSupportedWidgetParams = {
  __typename?: 'ProducersSupportedWidgetParams';
  filter?: Maybe<PolicyFilterOutput>;
  metric: PolicyMetric;
  metricKeys?: Maybe<Array<PolicyMetric>>;
};

export type ProducersSupportedWidgetParamsInput = {
  filter?: InputMaybe<PolicyFilter>;
  metric: PolicyMetric;
  metricKeys?: InputMaybe<Array<PolicyMetric>>;
};

export type Product = {
  __typename?: 'Product';
  adminProduct?: Maybe<AdminProduct>;
  children?: Maybe<Array<Product>>;
  id: Scalars['ID']['output'];
  /** Null for insurance segment itself */
  insuranceSegment?: Maybe<Product>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isPackage?: Maybe<Scalars['Boolean']['output']>;
  level: ProductLevel;
  metrics?: Maybe<EntityMetrics>;
  name: Scalars['String']['output'];
  parent?: Maybe<Product>;
};

export type ProductActivityFilterOutput = {
  __typename?: 'ProductActivityFilterOutput';
  productGroupIds?: Maybe<Array<Scalars['String']['output']>>;
  productIds?: Maybe<Array<Scalars['String']['output']>>;
  productInsuranceSegmentIds?: Maybe<Array<Scalars['String']['output']>>;
  productSuperGroupIds?: Maybe<Array<Scalars['String']['output']>>;
};

export type ProductAdmin = {
  __typename?: 'ProductAdmin';
  allProducts: Array<AdminProductExtended>;
  insuranceCompanySearchMappings: Array<AdminInsuranceCompany>;
  searchProducts: Array<AdminProductExtended>;
};


export type ProductAdminInsuranceCompanySearchMappingsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
};


export type ProductAdminSearchProductsArgs = {
  query: Scalars['String']['input'];
};

export type ProductFilter = {
  isFee?: InputMaybe<Scalars['Boolean']['input']>;
  isOpportunity?: InputMaybe<Scalars['Boolean']['input']>;
  isPackage?: InputMaybe<Scalars['Boolean']['input']>;
  isRenewable?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ProductLevel {
  Group = 'GROUP',
  InsuranceSegment = 'INSURANCE_SEGMENT',
  Product = 'PRODUCT',
  SuperGroup = 'SUPER_GROUP'
}

export type ProductListPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<ProductSortingField>;
  /** Total count will be different if we use sorting by metric with permissions */
  sortOrder?: InputMaybe<SortOrder>;
};

export type ProductMonolineRatio = {
  __typename?: 'ProductMonolineRatio';
  metrics: MonolineRatioMetrics;
  product: Product;
};

export type ProductMonolineRatioWithStats = {
  __typename?: 'ProductMonolineRatioWithStats';
  items: Array<ProductMonolineRatio>;
  statistics?: Maybe<MonolineRatioStatistics>;
};

export type ProductPaginatedResult = {
  __typename?: 'ProductPaginatedResult';
  items: Array<Product>;
  totalHits: Scalars['Int']['output'];
};

/** Filters policies and transactions by product ids. Products inside one ProductFilter are filtered using OR logic */
export type ProductPolicyFilter = {
  productGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  productIds?: InputMaybe<Array<Scalars['String']['input']>>;
  productInsuranceSegmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  productLineIds?: InputMaybe<Array<Scalars['String']['input']>>;
  productSuperGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ProductPolicyFilterOutput = {
  __typename?: 'ProductPolicyFilterOutput';
  productGroupIds?: Maybe<Array<Scalars['String']['output']>>;
  productIds?: Maybe<Array<Scalars['String']['output']>>;
  productInsuranceSegmentIds?: Maybe<Array<Scalars['String']['output']>>;
  productLineIds?: Maybe<Array<Scalars['String']['output']>>;
  productSuperGroupIds?: Maybe<Array<Scalars['String']['output']>>;
};

export type ProductRank = {
  __typename?: 'ProductRank';
  filter?: Maybe<Scalars['String']['output']>;
  metricType?: Maybe<Scalars['String']['output']>;
};

export type ProductRankEdge = {
  __typename?: 'ProductRankEdge';
  filter?: Maybe<Scalars['String']['output']>;
  metricType?: Maybe<Scalars['String']['output']>;
};

export enum ProductSortingField {
  Commission = 'COMMISSION',
  Id = 'ID',
  Name = 'NAME',
  Premium = 'PREMIUM',
  Revenue = 'REVENUE'
}

export type ProductionCredit = {
  __typename?: 'ProductionCredit';
  accountExecutives?: Maybe<Array<User>>;
  accountManager?: Maybe<User>;
  amsPolicyStatus: AmsPolicyStatus;
  /** Annualized ennabl written amounts for the production credit */
  annualizedWritten?: Maybe<Amount>;
  cancelDate?: Maybe<Scalars['SimpleDate']['output']>;
  carrier?: Maybe<Market>;
  client: Client;
  clientAgencyCodes?: Maybe<Array<Scalars['String']['output']>>;
  /** Lowest level department */
  department: Department;
  detailedStatus: DetailedPolicyStatus;
  endDate: Scalars['SimpleDate']['output'];
  /** min of cancelDate and endDate */
  expirationDate: Scalars['SimpleDate']['output'];
  /** Amount for the policy based on "PolicyFilter.period". For written amount type equal to `written`, for billed - sum of amounts of filtered transactions */
  filteredAmount: Amount;
  id: Scalars['ID']['output'];
  industry?: Maybe<Industry>;
  industryGroup?: Maybe<Industry>;
  industrySubGroup?: Maybe<Industry>;
  insuranceSegment?: Maybe<Product>;
  intermediary?: Maybe<Market>;
  /** @deprecated Deprecated */
  isCrossSell: Scalars['Boolean']['output'];
  isInForce: Scalars['Boolean']['output'];
  isLost: Scalars['Boolean']['output'];
  isRewrite: Scalars['Boolean']['output'];
  /** @deprecated Deprecated */
  isWinBack: Scalars['Boolean']['output'];
  issuingPaper?: Maybe<Market>;
  naicsSourceConfidenceScore?: Maybe<Scalars['String']['output']>;
  nextPolicyStartDate?: Maybe<Scalars['SimpleDate']['output']>;
  payTo?: Maybe<Market>;
  policyAgencyCodes?: Maybe<Array<Scalars['String']['output']>>;
  policyBilledAmount?: Maybe<Amount>;
  policyFilteredAmount: Amount;
  policyNumber?: Maybe<Scalars['String']['output']>;
  policySourceWrittenAmount?: Maybe<Amount>;
  policySources?: Maybe<Array<Scalars['String']['output']>>;
  policyWrittenAmount?: Maybe<Amount>;
  producer?: Maybe<User>;
  product?: Maybe<Product>;
  productGroup?: Maybe<Product>;
  productLines: Array<Product>;
  productSuperGroup?: Maybe<Product>;
  productionCreditPercentage: Scalars['Float']['output'];
  renewalStage?: Maybe<Scalars['String']['output']>;
  renewalStatus: RenewalStatus;
  sourceClientNumber?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['SimpleDate']['output'];
  upcomingRenewalState?: Maybe<UpcomingRenewalState>;
};

export type Products = {
  __typename?: 'Products';
  /** @deprecated Use paginated instead */
  list: Array<Product>;
  paginated: ProductPaginatedResult;
  paginatedRestricted: ProductPaginatedResult;
  tree: Array<Product>;
  treeRestricted: Array<Product>;
};


export type ProductsListArgs = {
  filter?: InputMaybe<ProductFilter>;
  pagination?: InputMaybe<ProductListPaginationInput>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type ProductsPaginatedArgs = {
  filter?: InputMaybe<ProductFilter>;
  pagination?: InputMaybe<ProductListPaginationInput>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type ProductsPaginatedRestrictedArgs = {
  filter?: InputMaybe<ProductFilter>;
  pagination?: InputMaybe<ProductListPaginationInput>;
  query?: InputMaybe<Scalars['String']['input']>;
  roleId?: InputMaybe<Scalars['String']['input']>;
};


export type ProductsTreeArgs = {
  filter?: InputMaybe<ProductFilter>;
};


export type ProductsTreeRestrictedArgs = {
  filter?: InputMaybe<ProductFilter>;
  roleId?: InputMaybe<Scalars['String']['input']>;
};

export type ProductsPerClient = {
  __typename?: 'ProductsPerClient';
  byAccountExecutive: Array<ProductsPerClientByUser>;
  byCarrier: Array<ProductsPerClientByCarrier>;
  byDepartment: Array<ProductsPerClientByDepartment>;
  byIndustry: Array<ProductsPerClientByIndustry>;
  byInsuranceSegment: Array<ProductsPerClientByInsuranceSegment>;
  byPolicyStatus: Array<ProductsPerClientByPolicyStatus>;
  byProducer: Array<ProductsPerClientByUser>;
};


export type ProductsPerClientByAccountExecutiveArgs = {
  filter: PolicyFilter;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductsPerClientByCarrierArgs = {
  filter: PolicyFilter;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductsPerClientByDepartmentArgs = {
  filter: PolicyFilter;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductsPerClientByIndustryArgs = {
  filter: PolicyFilter;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductsPerClientByInsuranceSegmentArgs = {
  filter: PolicyFilter;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductsPerClientByPolicyStatusArgs = {
  filter: PolicyFilter;
};


export type ProductsPerClientByProducerArgs = {
  filter: PolicyFilter;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductsPerClientByCarrier = {
  __typename?: 'ProductsPerClientByCarrier';
  entity: Market;
  statistic: ProductsPerClientStatistic;
};

export type ProductsPerClientByDepartment = {
  __typename?: 'ProductsPerClientByDepartment';
  entity: Department;
  statistic: ProductsPerClientStatistic;
};

export type ProductsPerClientByIndustry = {
  __typename?: 'ProductsPerClientByIndustry';
  entity: Industry;
  statistic: ProductsPerClientStatistic;
};

export type ProductsPerClientByInsuranceSegment = {
  __typename?: 'ProductsPerClientByInsuranceSegment';
  entity: Product;
  statistic: ProductsPerClientStatistic;
};

export type ProductsPerClientByPolicyStatus = {
  __typename?: 'ProductsPerClientByPolicyStatus';
  entity: AggPolicyStatus;
  statistic: ProductsPerClientStatistic;
};

export type ProductsPerClientByUser = {
  __typename?: 'ProductsPerClientByUser';
  entity: User;
  statistic: ProductsPerClientStatistic;
};

export type ProductsPerClientStatistic = {
  __typename?: 'ProductsPerClientStatistic';
  avg: Scalars['Float']['output'];
  max: Scalars['Float']['output'];
  maxClientCount: Scalars['Float']['output'];
  min: Scalars['Float']['output'];
  minClientCount: Scalars['Float']['output'];
  mode: Scalars['Float']['output'];
  modeClientCount: Scalars['Float']['output'];
};

export type Prospect = {
  __typename?: 'Prospect';
  address?: Maybe<ProspectAddress>;
  created: Scalars['Timestamp']['output'];
  createdByAdmin: Scalars['Boolean']['output'];
  /** @deprecated Use prospectFor instead */
  createdByUser?: Maybe<AuthUser>;
  detailsFetched: Scalars['Boolean']['output'];
  /** Is not optimized for requesting in lists */
  dnbData?: Maybe<DnbCompany>;
  /** Applicable only for companies */
  duns?: Maybe<Scalars['String']['output']>;
  emails: Array<ProspectEmail>;
  forms5500?: Maybe<Array<Form5500>>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  opportunityRecommendations?: Maybe<Array<OpportunityRecommendation>>;
  phones: Array<ProspectPhone>;
  prospectFor: Array<AuthUser>;
  /** Is not optimized for requesting in lists */
  rocketReachData?: Maybe<RocketReachPerson>;
  savedOpportunity?: Maybe<SavedOpportunity>;
  /** @deprecated Does not make sense anymore */
  source: ProspectSource;
  type: ProspectType;
};


export type ProspectSavedOpportunityArgs = {
  producerId?: InputMaybe<Scalars['String']['input']>;
};

export type ProspectAddress = {
  __typename?: 'ProspectAddress';
  city?: Maybe<Scalars['String']['output']>;
  /** USA or any other string for other countries. */
  country?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  regionCode?: Maybe<Scalars['String']['output']>;
  streetLine1?: Maybe<Scalars['String']['output']>;
  streetLine2?: Maybe<Scalars['String']['output']>;
};

export type ProspectCompanyCreateInput = {
  dnbId: Scalars['String']['input'];
};

export type ProspectDolCompanyCreateInput = {
  fein: Scalars['String']['input'];
};

export type ProspectEmail = {
  __typename?: 'ProspectEmail';
  email: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type ProspectIndividualCreateInput = {
  rocketReachId: Scalars['String']['input'];
};

export type ProspectPaginatedResult = {
  __typename?: 'ProspectPaginatedResult';
  items: Array<Prospect>;
  totalHits: Scalars['Int']['output'];
};

export type ProspectPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<ProspectSortingField>;
  /** Total count will be different if we use sorting by metric with permissions */
  sortOrder?: InputMaybe<SortOrder>;
};

export type ProspectPhone = {
  __typename?: 'ProspectPhone';
  isdCode?: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export enum ProspectSortingField {
  Name = 'NAME'
}

export enum ProspectSource {
  OpportunityFinder = 'OPPORTUNITY_FINDER'
}

export enum ProspectType {
  Company = 'COMPANY',
  DolCompany = 'DOL_COMPANY',
  Individual = 'INDIVIDUAL'
}

export type Prospects = {
  __typename?: 'Prospects';
  allProspects: Array<Prospect>;
  paginated: ProspectPaginatedResult;
  prospectById?: Maybe<Prospect>;
};


export type ProspectsPaginatedArgs = {
  pagination?: InputMaybe<ProspectPaginationInput>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type ProspectsProspectByIdArgs = {
  id: Scalars['ID']['input'];
};

export type Query = {
  __typename?: 'Query';
  activities: Activities;
  aggregateMonolineOpportunity: AggregateMonolineOpportunity;
  aggregatePolicy: AggregatedPolicy;
  aggregateWinBackOpportunity: AggregateWinBackOpportunity;
  /** Returns AggPolicyStatus and underlying source codes. Make sense only for AMS policy status - not for Ennabl. */
  amsPolicyStatuses: Array<AmsPolicyStatusWithCodes>;
  bands: Bands;
  carrierAppetite: CarrierAppetite;
  client: Client;
  clients: Clients;
  commissionsDistribution: CommissionsDistribution;
  contacts: Contacts;
  customReporting: CustomReporting;
  dashboards: Dashboards;
  departments: Departments;
  /** @deprecated Only for Afore - the new version will replace this */
  documents: Documents;
  documentsCompare: DocumentsCompare;
  /** @deprecated Use documentsV1 */
  documentsV0: DocumentsV0;
  documentsV1: DocumentsV1;
  ennablRoles: EnnablRoles;
  ennablUsers: AuthUsers;
  enrichmentMappings: EnrichmentMappings;
  externalSystems: Array<ExternalSystem>;
  globalCarrierAppetite: GlobalCarrierAppetite;
  industries: Industries;
  industry: Industry;
  integrations: Integrations;
  lastEtl?: Maybe<EtlInfo>;
  lifetime: Lifetime;
  lossRuns: LossRuns;
  market: Market;
  markets: Markets;
  mgaDataByEntity: MgaDataByEntity;
  mgaSearch: SearchResult;
  mgaSubmission: MgaSubmission;
  monolineRatios: MonolineRatios;
  opportunities: Opportunities;
  opportunityReports: OpportunityReports;
  policies: Array<Policy>;
  policiesByNumber: Array<Policy>;
  premiumFlow: PremiumFlow;
  premiumOutflowInflow: OutflowInflow;
  producerCredit: ProducerCredit;
  producerGoals: ProducerGoals;
  producerPortal: ProducerPortal;
  product: Product;
  productAdmin: ProductAdmin;
  productionCreditTable: Array<ProductionCredit>;
  products: Products;
  productsPerClient: ProductsPerClient;
  prospects: Prospects;
  reminders: Reminders;
  reportTemplates: ReportTemplates;
  retention: RetentionResolverResponse;
  savedOpportunities: SavedOpportunities;
  savedPages: SavedPages;
  score360: Score360;
  score360Categories: Array<Score360Category>;
  search: SearchResult;
  sourceCodes: SourceCodes;
  sourceDataUploads: SourceDataUploads;
  storedFilters: StoredFilters;
  storedFiltersV2: StoredFiltersV2;
  tableau: Tableau;
  trends: Trends;
  user: User;
  userInfo: UserInfo;
  userKpiDashboards: UserKpiDashboards;
  userManagement: UserManagement;
  userPageSettings?: Maybe<PageSettings>;
  userReportPresets: UserReportPresets;
  userReports: UserReports;
  userSettings?: Maybe<Array<PageSettings>>;
  users: Users;
};


export type QueryAggregatePolicyArgs = {
  cacheId?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PolicyFilter>;
};


export type QueryClientArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCommissionsDistributionArgs = {
  commissionType: CommissionType;
  filter: PolicyFilter;
};


export type QueryIndustryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryIntegrationsArgs = {
  emulateLimitError?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryMarketArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMgaSearchArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
  userFilter?: InputMaybe<SearchUserFilter>;
};


export type QueryPoliciesArgs = {
  filter?: InputMaybe<PolicyFilter>;
  pagination?: InputMaybe<PolicyListPaginationInput>;
};


export type QueryPoliciesByNumberArgs = {
  policyNumber: Scalars['String']['input'];
};


export type QueryProductArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProductionCreditTableArgs = {
  filter?: InputMaybe<PolicyFilter>;
  pagination?: InputMaybe<PolicyListPaginationInput>;
};


export type QuerySearchArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  producerMode?: InputMaybe<Scalars['Boolean']['input']>;
  query: Scalars['String']['input'];
  userFilter?: InputMaybe<SearchUserFilter>;
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserPageSettingsArgs = {
  pageId: Scalars['ID']['input'];
};

export type Range = {
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
};

export type Rating = {
  __typename?: 'Rating';
  /** @deprecated AM Best data is no longer maintained (data provider contract ended). */
  title: Scalars['String']['output'];
};

export type Reminder = {
  __typename?: 'Reminder';
  createdAt: Scalars['Timestamp']['output'];
  date: Scalars['Timestamp']['output'];
  id: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  savedOpportunity: SavedOpportunity;
  types: Array<ReminderType>;
};

export type ReminderInput = {
  date: Scalars['Timestamp']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  types: Array<ReminderType>;
};

export enum ReminderType {
  Call = 'CALL',
  Email = 'EMAIL',
  Visit = 'VISIT'
}

export type Reminders = {
  __typename?: 'Reminders';
  paginated: RemindersPaginatedResult;
};


export type RemindersPaginatedArgs = {
  pagination?: InputMaybe<RemindersPaginationInput>;
  producerId?: InputMaybe<Scalars['String']['input']>;
};

export type RemindersPaginatedResult = {
  __typename?: 'RemindersPaginatedResult';
  items: Array<Reminder>;
  totalHits: Scalars['Int']['output'];
};

export type RemindersPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<RemindersPaginationSortingField>;
  /** Total count will be different if we use sorting by metric with permissions */
  sortOrder?: InputMaybe<SortOrder>;
};

export enum RemindersPaginationSortingField {
  Date = 'DATE'
}

export type RemoveResponseFromFavoritesPayload = {
  __typename?: 'RemoveResponseFromFavoritesPayload';
  success: Scalars['Boolean']['output'];
};

export type RenameOpportunityReportPayload = {
  __typename?: 'RenameOpportunityReportPayload';
  report: OpportunityReport;
};

export enum RenewalStatus {
  New = 'NEW',
  Renewed = 'RENEWED'
}

export type RenewalsListPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<RenewalsSortingField>;
  /** Total count will be different if we use sorting by metric with permissions */
  sortOrder?: InputMaybe<SortOrder>;
};

export type RenewalsOpportunity = {
  __typename?: 'RenewalsOpportunity';
  accountManager?: Maybe<User>;
  /** @deprecated use policy instead */
  billed: Amount;
  carrier?: Maybe<Market>;
  client?: Maybe<Client>;
  /**
   * min of cancelDate and endDate
   * @deprecated use policy instead
   */
  expirationDate: Scalars['SimpleDate']['output'];
  /** to use for caching */
  id: Scalars['ID']['output'];
  policy: Policy;
  /** @deprecated use policy instead */
  policyNumber?: Maybe<Scalars['String']['output']>;
  producers?: Maybe<Array<User>>;
  product?: Maybe<Product>;
  saved?: Maybe<SavedOpportunityRenewal>;
  /** @deprecated use policy instead */
  written: Amount;
};

export type RenewalsOpportunityPaginatedResult = {
  __typename?: 'RenewalsOpportunityPaginatedResult';
  items: Array<RenewalsOpportunity>;
  totalClients: Scalars['Float']['output'];
  totalHits: Scalars['Int']['output'];
};

export enum RenewalsSortingField {
  BilledPremium = 'BILLED_PREMIUM',
  BilledRevenue = 'BILLED_REVENUE',
  ExpirationDate = 'EXPIRATION_DATE',
  PolicyNumber = 'POLICY_NUMBER',
  Premium = 'PREMIUM',
  Revenue = 'REVENUE',
  StartDate = 'START_DATE'
}

export enum ReportEntity {
  Carrier = 'CARRIER',
  Industry = 'INDUSTRY',
  Producer = 'PRODUCER',
  Product = 'PRODUCT'
}

/** contains parameters to generate a report */
export type ReportParameters = {
  __typename?: 'ReportParameters';
  /** applicable to account reports */
  accountReportEntity?: Maybe<AccountsReportEntity>;
  /** applicable to reports by carrier, default is Ultimate Parent */
  carrierLevel?: Maybe<CarrierLevel>;
  /** applicable to custom aggregated reports */
  customAggregatedParameters?: Maybe<CustomAggregatedPreviewParamsOutput>;
  /** applicable to custom aggregated reports */
  customPlainParameters?: Maybe<CustomPlainPreviewParamsOutput>;
  /** applicable to custom query reports */
  customQueryParameters?: Maybe<CustomQueryPreviewParamsOutput>;
  /** applicable to data audit reports */
  dataAuditReportType?: Maybe<DataAuditReportType>;
  date?: Maybe<Scalars['SimpleDate']['output']>;
  fileType: UserReportFileType;
  filterName?: Maybe<Scalars['String']['output']>;
  /** applicable to policy and production credit lists reports */
  includeSourceData?: Maybe<Scalars['Boolean']['output']>;
  /** applicable to leaderboard reports */
  leaderboardReportEntity?: Maybe<LeaderboardReportEntity>;
  metric?: Maybe<PolicyMetric>;
  /** applicable to MGA policy report - configurable columns */
  mgaPolicyReportColumns?: Maybe<Array<MgaPolicyReportColumnConfigOutput>>;
  /** applicable to reports with PolicyFilter parameter */
  policyFilter?: Maybe<PolicyFilterOutput>;
  /** @deprecated We have id in the preset and it's not an appropriate cache key for ReportParameters */
  presetId?: Maybe<Scalars['ID']['output']>;
  /** applicable to leaderboard report */
  reportEntity?: Maybe<ReportEntity>;
  /** applicable to retention insight report */
  retentionInsightParameters?: Maybe<RetentionInsightsParameters>;
  /** applicable to retention reports */
  retentionParameters?: Maybe<RetentionParameters>;
  /** applicable to score-360 reports */
  score360Parameters?: Maybe<Score360ReportParameters>;
  /** applicable to saved opportunity reports */
  userId?: Maybe<Scalars['ID']['output']>;
};

export type ReportParametersInput = {
  /** applicable to custom aggregated reports */
  customAggregatedParameters?: InputMaybe<CustomAggregatedPreviewParams>;
  /** applicable to custom plain reports */
  customPlainParameters?: InputMaybe<CustomPlainPreviewParams>;
  /** applicable to custom query reports */
  customQueryParameters?: InputMaybe<CustomQueryPreviewParams>;
  /**
   * applicable to data audit reports
   * @deprecated use group name instead
   */
  dataAuditReportType?: InputMaybe<DataAuditReportType>;
  fileType: UserReportFileType;
  /** applicable to policy and production credit lists reports */
  includeSourceData?: InputMaybe<Scalars['Boolean']['input']>;
  /** applicable to MGA policy report - configurable columns */
  mgaPolicyReportColumns?: InputMaybe<Array<MgaPolicyReportColumnConfig>>;
  /** applicable to reports with PolicyFilter */
  policyFilter?: InputMaybe<PolicyFilter>;
  /** applicable to leaderboard report */
  reportEntity?: InputMaybe<ReportEntity>;
};

export type ReportSubscriptionSchedule = {
  __typename?: 'ReportSubscriptionSchedule';
  /** 1-31 */
  daysOfMonth?: Maybe<Array<Scalars['Int']['output']>>;
  /** 1-7. 1 is Monday */
  daysOfWeek?: Maybe<Array<Scalars['Int']['output']>>;
  repeatEach?: Maybe<ReportSubscriptionScheduleRepetition>;
  subscribeEnnablUserIds?: Maybe<Array<Scalars['ID']['output']>>;
};

export type ReportSubscriptionScheduleInput = {
  /** 1-31 */
  daysOfMonth?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** 1-7. 1 is Monday */
  daysOfWeek?: InputMaybe<Array<Scalars['Int']['input']>>;
  repeatEach?: InputMaybe<ReportSubscriptionScheduleRepetitionInput>;
  subscribeEnnablUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ReportSubscriptionScheduleRepetition = {
  __typename?: 'ReportSubscriptionScheduleRepetition';
  startAt: Scalars['Timestamp']['output'];
  type: ReportSubscriptionScheduleRepetitionType;
  /** 1-inf */
  value: Scalars['Int']['output'];
};

export type ReportSubscriptionScheduleRepetitionInput = {
  startAt: Scalars['Timestamp']['input'];
  type: ReportSubscriptionScheduleRepetitionType;
  /** 1-inf */
  value: Scalars['Int']['input'];
};

export enum ReportSubscriptionScheduleRepetitionType {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK'
}

export type ReportTemplate = {
  __typename?: 'ReportTemplate';
  createdAt: Scalars['Timestamp']['output'];
  createdBy: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  reportParameters: ReportParameters;
  skipPolicyFilter: Scalars['Boolean']['output'];
  type: UserReportType;
  updatedAt: Scalars['Timestamp']['output'];
};

export type ReportTemplateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  reportParameters: ReportParametersInput;
  skipPolicyFilter?: InputMaybe<Scalars['Boolean']['input']>;
  type: UserReportType;
};

export type ReportTemplates = {
  __typename?: 'ReportTemplates';
  all: Array<ReportTemplate>;
  byId: ReportTemplate;
};


export type ReportTemplatesByIdArgs = {
  templateId: Scalars['ID']['input'];
};

export type Retention = {
  __typename?: 'Retention';
  retainedPct?: Maybe<Scalars['Float']['output']>;
  retainedValue?: Maybe<Scalars['Float']['output']>;
  totalValue?: Maybe<Scalars['Float']['output']>;
};

export type RetentionByCarrier = {
  __typename?: 'RetentionByCarrier';
  item: Market;
  retention: RetentionByMetric;
};

export type RetentionByDepartment = {
  __typename?: 'RetentionByDepartment';
  item: Department;
  retention: RetentionByMetric;
};

export type RetentionByIndustry = {
  __typename?: 'RetentionByIndustry';
  item: Industry;
  retention: RetentionByMetric;
};

export type RetentionByMetric = {
  __typename?: 'RetentionByMetric';
  clientCount: Retention;
  policyCount: Retention;
  premium: Retention;
  revenue: Retention;
};

export type RetentionByProduct = {
  __typename?: 'RetentionByProduct';
  item: Product;
  retention: RetentionByMetric;
};

export type RetentionByUser = {
  __typename?: 'RetentionByUser';
  item?: Maybe<User>;
  retention: RetentionByMetric;
};

export type RetentionGoalPerformance = {
  __typename?: 'RetentionGoalPerformance';
  premiumPct: Scalars['Float']['output'];
  revenuePct: Scalars['Float']['output'];
};

export type RetentionInsightsParameters = {
  __typename?: 'RetentionInsightsParameters';
  carrierLevel?: Maybe<CarrierLevel>;
  entity: RetentionReportEntity;
  /** Provided Id. If not set then values without entity will return. */
  entityId?: Maybe<Scalars['String']['output']>;
};

export type RetentionInsightsParametersInput = {
  carrierLevel?: InputMaybe<CarrierLevel>;
  entity: RetentionReportEntity;
  /** Provided Id. If not set then values without entity will return. */
  entityId?: InputMaybe<Scalars['String']['input']>;
};

export enum RetentionMetric {
  ClientCount = 'CLIENT_COUNT',
  PolicyCount = 'POLICY_COUNT',
  Premium = 'PREMIUM',
  Revenue = 'REVENUE'
}

export type RetentionMonthlyTrends = {
  __typename?: 'RetentionMonthlyTrends';
  period: Array<RetentionTrendDataPoint>;
  periodRange: DateRangeOutput;
};

export type RetentionParameters = {
  __typename?: 'RetentionParameters';
  carrierLevel?: Maybe<CarrierLevel>;
  entity: RetentionReportEntity;
  entityIds?: Maybe<Array<Scalars['String']['output']>>;
  includeEmpty?: Maybe<Scalars['Boolean']['output']>;
  metric: RetentionPolicyMetric;
};

export type RetentionParametersInput = {
  carrierLevel?: InputMaybe<CarrierLevel>;
  entity: RetentionReportEntity;
  entityIds?: InputMaybe<Array<Scalars['String']['input']>>;
  includeEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  metric: RetentionPolicyMetric;
};

export enum RetentionPolicyMetric {
  ClientCount = 'CLIENT_COUNT',
  PolicyCount = 'POLICY_COUNT',
  Premium = 'PREMIUM',
  Revenue = 'REVENUE'
}

export enum RetentionReportEntity {
  AccountExecutive = 'ACCOUNT_EXECUTIVE',
  AccountManager = 'ACCOUNT_MANAGER',
  Carrier = 'CARRIER',
  Department = 'DEPARTMENT',
  Industry = 'INDUSTRY',
  /** @deprecated don't use it, will be removed soon */
  PolicyType = 'POLICY_TYPE',
  Producer = 'PRODUCER',
  Product = 'PRODUCT'
}

export type RetentionResolverResponse = {
  __typename?: 'RetentionResolverResponse';
  byAccountExecutive: Array<RetentionByUser>;
  byAccountManager: Array<RetentionByUser>;
  byCarrier: Array<RetentionByCarrier>;
  byDepartment: Array<RetentionByDepartment>;
  byIndustry: Array<RetentionByIndustry>;
  byProducer: Array<RetentionByUser>;
  byProduct: Array<RetentionByProduct>;
  total: RetentionByMetric;
};


export type RetentionResolverResponseByAccountExecutiveArgs = {
  filter: PolicyFilter;
};


export type RetentionResolverResponseByAccountManagerArgs = {
  filter: PolicyFilter;
};


export type RetentionResolverResponseByCarrierArgs = {
  carrierLevel?: InputMaybe<CarrierLevel>;
  filter: PolicyFilter;
};


export type RetentionResolverResponseByDepartmentArgs = {
  filter: PolicyFilter;
};


export type RetentionResolverResponseByIndustryArgs = {
  filter: PolicyFilter;
};


export type RetentionResolverResponseByProducerArgs = {
  filter: PolicyFilter;
};


export type RetentionResolverResponseByProductArgs = {
  filter: PolicyFilter;
};


export type RetentionResolverResponseTotalArgs = {
  filter: PolicyFilter;
};

export type RetentionTrendDataPoint = {
  __typename?: 'RetentionTrendDataPoint';
  begin: Scalars['SimpleDate']['output'];
  end: Scalars['SimpleDate']['output'];
  retainedPct: Scalars['Float']['output'];
  retainedValue: Scalars['Float']['output'];
  totalValue: Scalars['Float']['output'];
};

export type RetentionTrendsByMonthInput = {
  filter: PolicyFilter;
  metric: RetentionMetric;
};

export type RocketReachEducation = {
  __typename?: 'RocketReachEducation';
  degree?: Maybe<Scalars['String']['output']>;
  endYear?: Maybe<Scalars['Int']['output']>;
  major?: Maybe<Scalars['String']['output']>;
  school?: Maybe<Scalars['String']['output']>;
  startYear?: Maybe<Scalars['Int']['output']>;
};

export type RocketReachEmail = {
  __typename?: 'RocketReachEmail';
  email?: Maybe<Scalars['String']['output']>;
  lastValidationCheck?: Maybe<Scalars['Timestamp']['output']>;
  smtpValid?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type RocketReachJob = {
  __typename?: 'RocketReachJob';
  company?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['SimpleDate']['output']>;
  isCurrent: Scalars['Boolean']['output'];
  lastUpdated?: Maybe<Scalars['Timestamp']['output']>;
  startDate?: Maybe<Scalars['SimpleDate']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type RocketReachLocation = {
  /** Country iso3166alpha2code */
  country?: InputMaybe<Scalars['String']['input']>;
  /** city, town, village, etc */
  locality?: InputMaybe<Scalars['String']['input']>;
  /** Search radius around specified locations. Postal code or either country, region and locality must be specified */
  locationRadius?: InputMaybe<RocketReachLocationRadius>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  /** state, province, region, etc */
  region?: InputMaybe<Scalars['String']['input']>;
};

export type RocketReachLocationRadius = {
  /** Search radius around specified location */
  radius: Scalars['Float']['input'];
  /** Unit of measurement for the radius */
  unit: LocationRadiusUnit;
};

export type RocketReachPerson = {
  __typename?: 'RocketReachPerson';
  /** Parsed from location */
  city?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  currentTitle?: Maybe<Scalars['String']['output']>;
  educations: Array<RocketReachEducation>;
  emails: Array<RocketReachEmail>;
  id: Scalars['ID']['output'];
  jobs: Array<RocketReachJob>;
  links: Array<RocketReachUrl>;
  location?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  normalizedTitle?: Maybe<Scalars['String']['output']>;
  phones: Array<RocketReachPhone>;
  profilePic?: Maybe<Scalars['String']['output']>;
  prospect?: Maybe<Prospect>;
  /** 2-letter region code, only US, parsed from location */
  region?: Maybe<Scalars['String']['output']>;
  skills: Array<Scalars['String']['output']>;
  status: RocketReachUpdateStatus;
};


export type RocketReachPersonProspectArgs = {
  anyOwner?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RocketReachPersonCached = {
  __typename?: 'RocketReachPersonCached';
  data: RocketReachPerson;
  lastUpdated: Scalars['Timestamp']['output'];
};

export type RocketReachPhone = {
  __typename?: 'RocketReachPhone';
  number?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** If many parameters provided with multiple values, it's interpreted as an “AND” between filters, and “OR” within the filters. */
export type RocketReachQuery = {
  /** @deprecated Use companyIndustry */
  companyIndustryTags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Current employer */
  companyName?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Dollars */
  companyRevenue?: InputMaybe<Range>;
  /** Dollars */
  companySize?: InputMaybe<Range>;
  /**
   * Country iso3166alpha2code
   * @deprecated Use locations[i].country
   */
  country?: InputMaybe<Array<Scalars['String']['input']>>;
  degree?: InputMaybe<Array<Scalars['String']['input']>>;
  department?: InputMaybe<Array<Scalars['String']['input']>>;
  keyword?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * city, town, village, etc
   * @deprecated Use locations[i].locality
   */
  locality?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Use specific filters for location */
  location?: InputMaybe<Array<Scalars['String']['input']>>;
  locations?: InputMaybe<Array<RocketReachLocation>>;
  major?: InputMaybe<Array<Scalars['String']['input']>>;
  managementLevel?: InputMaybe<Array<Scalars['String']['input']>>;
  naicsCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A fuzzy-matched name, or exact if surrounded by quotes */
  name?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Deprecated in v2. Use title. */
  normalizedTitle?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Use locations[i].postalCode */
  postalCode?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * state, province, region, etc
   * @deprecated Use locations[i].region
   */
  region?: InputMaybe<Array<Scalars['String']['input']>>;
  sicCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RocketReachSearchData = {
  __typename?: 'RocketReachSearchData';
  city?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  currentTitle?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use integrations.searchClient query instead */
  ennablClientId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  links: Array<RocketReachUrl>;
  location?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  normalizedTitle?: Maybe<Scalars['String']['output']>;
  profilePic?: Maybe<Scalars['String']['output']>;
  prospect?: Maybe<Prospect>;
  /** 2-letter region code */
  region?: Maybe<Scalars['String']['output']>;
  teaser?: Maybe<RocketReachTeaser>;
};


export type RocketReachSearchDataProspectArgs = {
  anyOwner?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RocketReachSearchItem = {
  __typename?: 'RocketReachSearchItem';
  data: RocketReachSearchData;
  score: Scalars['Float']['output'];
};

export type RocketReachSearchResult = {
  __typename?: 'RocketReachSearchResult';
  items: Array<RocketReachSearchItem>;
  /** Offset for the next page */
  next: Scalars['Float']['output'];
  offset: Scalars['Float']['output'];
  totalHits: Scalars['Float']['output'];
};

export type RocketReachTeaser = {
  __typename?: 'RocketReachTeaser';
  emails: Array<Scalars['String']['output']>;
  officePhones: Array<Scalars['String']['output']>;
  phones: Array<Scalars['String']['output']>;
  preview: Array<Scalars['String']['output']>;
};

export enum RocketReachUpdateStatus {
  Complete = 'COMPLETE',
  Failed = 'FAILED',
  NotQueued = 'NOT_QUEUED',
  Progress = 'PROGRESS',
  Searching = 'SEARCHING',
  Waiting = 'WAITING'
}

export type RocketReachUrl = {
  __typename?: 'RocketReachUrl';
  type?: Maybe<RocketReachUrlType>;
  typeSource: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export enum RocketReachUrlType {
  Aboutme = 'ABOUTME',
  Angel = 'ANGEL',
  Angellist = 'ANGELLIST',
  Crunchbase = 'CRUNCHBASE',
  Facebook = 'FACEBOOK',
  Github = 'GITHUB',
  Google = 'GOOGLE',
  Googleplus = 'GOOGLEPLUS',
  Gravatar = 'GRAVATAR',
  Hi5 = 'HI5',
  Klout = 'KLOUT',
  Linkedin = 'LINKEDIN',
  Meetup = 'MEETUP',
  Pinterest = 'PINTEREST',
  Quora = 'QUORA',
  Twitter = 'TWITTER'
}

export type SaveManyPagesResult = {
  __typename?: 'SaveManyPagesResult';
  savedPages: Array<SavedPage>;
};

export type SaveOpportunityReportPayload = {
  __typename?: 'SaveOpportunityReportPayload';
  report: OpportunityReport;
};

export type SavedOpportunities = {
  __typename?: 'SavedOpportunities';
  byId?: Maybe<SavedOpportunity>;
  deleted: SavedOpportunityPaginatedResult;
  /** Net new opportunities count with no details fetched */
  netNewInProgressCount?: Maybe<Scalars['Int']['output']>;
  opportunityLists: OpportunityLists;
  paginated: SavedOpportunityPaginatedResult;
};


export type SavedOpportunitiesByIdArgs = {
  id: Scalars['ID']['input'];
  producerId?: InputMaybe<Scalars['String']['input']>;
};


export type SavedOpportunitiesDeletedArgs = {
  pagination?: InputMaybe<SavedOpportunityPaginationInput>;
  producerId?: InputMaybe<Scalars['String']['input']>;
};


export type SavedOpportunitiesNetNewInProgressCountArgs = {
  producerId?: InputMaybe<Scalars['String']['input']>;
};


export type SavedOpportunitiesPaginatedArgs = {
  filter?: InputMaybe<SavedOpportunitiesFilter>;
  pagination?: InputMaybe<SavedOpportunityPaginationInput>;
  producerId?: InputMaybe<Scalars['String']['input']>;
};

export type SavedOpportunitiesCountPutResult = {
  __typename?: 'SavedOpportunitiesCountPutResult';
  updated: Scalars['Float']['output'];
};

export type SavedOpportunitiesFilter = {
  label?: InputMaybe<SavedOpportunityLabel>;
  listId?: InputMaybe<Scalars['ID']['input']>;
  /** Text search by title */
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum SavedOpportunitiesPaginationSortingField {
  CreateDate = 'CREATE_DATE',
  CustomerEmployees = 'CUSTOMER_EMPLOYEES',
  CustomerName = 'CUSTOMER_NAME',
  Industry = 'INDUSTRY',
  NextRenewalDate = 'NEXT_RENEWAL_DATE',
  PremiumInForce = 'PREMIUM_IN_FORCE',
  ProductAmount = 'PRODUCT_AMOUNT',
  Title = 'TITLE',
  UpdateDate = 'UPDATE_DATE'
}

export type SavedOpportunitiesPermanentlyDeleteResult = {
  __typename?: 'SavedOpportunitiesPermanentlyDeleteResult';
  success: Scalars['Boolean']['output'];
};

export type SavedOpportunitiesPutOneResult = {
  __typename?: 'SavedOpportunitiesPutOneResult';
  updated: SavedOpportunity;
};

export type SavedOpportunitiesPutResult = {
  __typename?: 'SavedOpportunitiesPutResult';
  updated: Array<Maybe<SavedOpportunity>>;
};

export type SavedOpportunity = {
  __typename?: 'SavedOpportunity';
  /** Long-time resolving, only for ADDRESS type */
  addressData?: Maybe<HazardhubResponse>;
  /** Only for CLIENT type */
  client?: Maybe<Client>;
  created: Scalars['Timestamp']['output'];
  deleted?: Maybe<Scalars['Timestamp']['output']>;
  id: Scalars['ID']['output'];
  labels: Array<SavedOpportunityLabel>;
  lists?: Maybe<Array<OpportunityList>>;
  /** Only for PROSPECT type */
  prospect?: Maybe<Prospect>;
  reminders?: Maybe<Array<Reminder>>;
  reportId?: Maybe<Scalars['String']['output']>;
  /** Only for CLIENT type */
  savedCrossSell: Array<SavedOpportunityCrossSell>;
  /** Only for CLIENT type */
  savedRenewals: Array<SavedOpportunityRenewal>;
  /** Only for CLIENT type */
  savedWinBack: Array<SavedOpportunityWinBack>;
  title: Scalars['String']['output'];
  type: SavedOpportunityType;
  updated: Scalars['Timestamp']['output'];
};


export type SavedOpportunityRemindersArgs = {
  producerId?: InputMaybe<Scalars['String']['input']>;
};

export type SavedOpportunityCrossSell = {
  __typename?: 'SavedOpportunityCrossSell';
  created: Scalars['Timestamp']['output'];
  fromNotBoughtSearch: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  product?: Maybe<Product>;
};

export type SavedOpportunityCrossSellRecommendationInput = {
  clientId: Scalars['String']['input'];
  crossSellNotBoughtProductIds?: InputMaybe<Array<Scalars['String']['input']>>;
  crossSellProductIds?: InputMaybe<Array<Scalars['String']['input']>>;
  renewalPolicyIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** policy IDs */
  winBackOpportunityIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SavedOpportunityDnbNetNewInput = {
  duns: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type SavedOpportunityDolNetNewInput = {
  fein: Scalars['String']['input'];
};

export enum SavedOpportunityLabel {
  CrossSell = 'CROSS_SELL',
  Monoline = 'MONOLINE',
  NetNew = 'NET_NEW',
  Renewal = 'RENEWAL',
  WinBack = 'WIN_BACK'
}

export type SavedOpportunityMonoline = {
  __typename?: 'SavedOpportunityMonoline';
  created: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  /** Null if policy is not found */
  policy?: Maybe<Policy>;
};

export type SavedOpportunityPaginatedResult = {
  __typename?: 'SavedOpportunityPaginatedResult';
  items: Array<SavedOpportunity>;
  totalHits: Scalars['Int']['output'];
};

export type SavedOpportunityPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SavedOpportunitiesPaginationSortingField>;
  /** Total count will be different if we use sorting by metric with permissions */
  sortOrder?: InputMaybe<SortOrder>;
};

export type SavedOpportunityRenewal = {
  __typename?: 'SavedOpportunityRenewal';
  created: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  /** Null if policy is not found */
  policy?: Maybe<Policy>;
};

export type SavedOpportunityRocketReachNetNewInput = {
  name: Scalars['String']['input'];
  rocketReachId: Scalars['String']['input'];
};

export enum SavedOpportunityType {
  Address = 'ADDRESS',
  Client = 'CLIENT',
  Prospect = 'PROSPECT'
}

export type SavedOpportunityWinBack = {
  __typename?: 'SavedOpportunityWinBack';
  created: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  /** Null if policy is not found */
  policy?: Maybe<Policy>;
};

export type SavedPage = {
  __typename?: 'SavedPage';
  createdAt: Scalars['Timestamp']['output'];
  iconType?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type SavedPageInput = {
  iconType?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export type SavedPages = {
  __typename?: 'SavedPages';
  all?: Maybe<Array<SavedPage>>;
  isPageSaved: Scalars['Boolean']['output'];
};


export type SavedPagesIsPageSavedArgs = {
  url: Scalars['String']['input'];
};

export type Score360 = {
  __typename?: 'Score360';
  averageScore: Score360AverageScore;
  clients: Score360ClientPaginatedResult;
  clientsCount: Scalars['Int']['output'];
  producers: Score360ProducerPaginatedResult;
};


export type Score360AverageScoreArgs = {
  filter?: InputMaybe<Score360Filter>;
  viewMode?: InputMaybe<Score360ViewMode>;
};


export type Score360ClientsArgs = {
  filter?: InputMaybe<Score360Filter>;
  pagination?: InputMaybe<Score360ClientPaginationInput>;
  query?: InputMaybe<Scalars['String']['input']>;
  viewMode?: InputMaybe<Score360ViewMode>;
};


export type Score360ClientsCountArgs = {
  filter?: InputMaybe<Score360Filter>;
  viewMode?: InputMaybe<Score360ViewMode>;
};


export type Score360ProducersArgs = {
  filter?: InputMaybe<Score360Filter>;
  pagination?: InputMaybe<Score360ProducerPaginationInput>;
  query?: InputMaybe<Scalars['String']['input']>;
};

/** Average score per revenue band and total */
export type Score360AverageScore = {
  __typename?: 'Score360AverageScore';
  large: Scalars['Float']['output'];
  medium: Scalars['Float']['output'];
  small: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
};

/** Category to bucket clients by */
export type Score360Category = {
  __typename?: 'Score360Category';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** UI sort order of this category */
  order: Scalars['Float']['output'];
};

export type Score360ClientPaginatedResult = {
  __typename?: 'Score360ClientPaginatedResult';
  items: Array<Score360ClientRow>;
  totalHits: Scalars['Int']['output'];
};

export type Score360ClientPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Enables pagination by client field. Incompatible with sortByCategoryId field */
  sortBy?: InputMaybe<Score360ClientSortingField>;
  /** Enables pagination by score category. Incompatible with sortBy field */
  sortByCategoryId?: InputMaybe<Scalars['String']['input']>;
  /** Total count will be different if we use sorting by metric with permissions */
  sortOrder?: InputMaybe<SortOrder>;
};

/** Primary producer of a client with business in category */
export type Score360ClientProducer = {
  __typename?: 'Score360ClientProducer';
  category: Score360Category;
  producer: User;
};

/** Model for client 360 table */
export type Score360ClientRow = {
  __typename?: 'Score360ClientRow';
  categories: Array<Score360Category>;
  client: Client;
  producers: Array<Score360ClientProducer>;
  score: Scalars['Float']['output'];
};

export enum Score360ClientSortingField {
  Name = 'NAME',
  Producers = 'PRODUCERS',
  RevenueBand = 'REVENUE_BAND',
  Score = 'SCORE'
}

export type Score360Filter = {
  accountSize?: InputMaybe<FilterRange>;
  departmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  industryFilter?: InputMaybe<IndustryFilter>;
  producerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  producerIdsAndSourceCodes?: InputMaybe<Array<UserIdAndSourceCodes>>;
  score360?: InputMaybe<FilterRange>;
};

export type Score360FilterOutput = {
  __typename?: 'Score360FilterOutput';
  accountSize?: Maybe<FilterRangeOutput>;
  departmentIds?: Maybe<Array<Scalars['String']['output']>>;
  industryFilter?: Maybe<IndustryFilterOutput>;
  producerIds?: Maybe<Array<Scalars['String']['output']>>;
  producerIdsAndSourceCodes?: Maybe<Array<UserIdAndSourceCodesOutput>>;
  score360?: Maybe<FilterRangeOutput>;
};

export type Score360ProducerPaginatedResult = {
  __typename?: 'Score360ProducerPaginatedResult';
  items: Array<Score360ProducerRow>;
  totalHits: Scalars['Int']['output'];
};

export type Score360ProducerPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Score360ProducerSortingField>;
  /** Total count will be different if we use sorting by metric with permissions */
  sortOrder?: InputMaybe<SortOrder>;
};

/** Model for producer 360 table */
export type Score360ProducerRow = {
  __typename?: 'Score360ProducerRow';
  averageScore: Score360AverageScore;
  producer: User;
};

export enum Score360ProducerSortingField {
  LargeScore = 'LARGE_SCORE',
  MediumScore = 'MEDIUM_SCORE',
  Name = 'NAME',
  SmallScore = 'SMALL_SCORE',
  TotalScore = 'TOTAL_SCORE'
}

export type Score360ReportParameters = {
  __typename?: 'Score360ReportParameters';
  filter: Score360FilterOutput;
  viewMode: Score360ViewMode;
};

/** Defines the flow for score360 page */
export enum Score360ViewMode {
  FullBook = 'FULL_BOOK',
  ProducerBook = 'PRODUCER_BOOK'
}

export type SearchEntity = Client | Industry | Market | Product | Prospect | SearchPage | User;

export type SearchPage = {
  __typename?: 'SearchPage';
  id: Scalars['ID']['output'];
  subTab?: Maybe<Scalars['String']['output']>;
  tab?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type SearchResult = {
  __typename?: 'SearchResult';
  results: Array<SearchResultItem>;
};

export type SearchResultItem = {
  __typename?: 'SearchResultItem';
  /** Unique identifier of search result. Could be identifier of entity or not. */
  id: Scalars['ID']['output'];
  item: SearchEntity;
  /** additional metadata for search item */
  meta?: Maybe<Scalars['String']['output']>;
  subTab?: Maybe<Scalars['String']['output']>;
  tab?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
};

export type SearchUserFilter = {
  amsRoles?: InputMaybe<Array<UserAmsRole>>;
};

export type SetHazardhubCachedIdResponse = {
  __typename?: 'SetHazardhubCachedIdResponse';
  success: Scalars['Boolean']['output'];
};

export type SetRocketReachIdResponse = {
  __typename?: 'SetRocketReachIdResponse';
  success: Scalars['Boolean']['output'];
};

export type SharedBatch = {
  __typename?: 'SharedBatch';
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  sharedBy: AuthUser;
  status: LossRunFolderStatus;
};

export type SicCode = {
  __typename?: 'SicCode';
  code: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
};

/** Base class for simple entities with id and name */
export type SimpleEntity = {
  __typename?: 'SimpleEntity';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type SimplePagination = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SourceCodes = {
  __typename?: 'SourceCodes';
  clientAgencyCodes: Array<AgencyCodeCategory>;
  policyAgencyCodes: Array<AgencyCodeCategory>;
  policySources: Array<AgencyCode>;
  retailAgencyCodes: Array<AgencyCodeCategory>;
};

export enum SourceDataColumnImportance {
  Required = 'REQUIRED',
  Suggested = 'SUGGESTED'
}

export type SourceDataGateAcknowledgementInput = {
  code: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};

export type SourceDataMapping = {
  __typename?: 'SourceDataMapping';
  columns: Array<SourceDataMappingEntry>;
  complete?: Maybe<Scalars['Boolean']['output']>;
  sheetName?: Maybe<Scalars['String']['output']>;
  unmappedSourceColumns: Array<Scalars['String']['output']>;
};

export type SourceDataMappingEntry = {
  __typename?: 'SourceDataMappingEntry';
  importance: SourceDataColumnImportance;
  sourceColumn?: Maybe<Scalars['String']['output']>;
  targetColumn: Scalars['String']['output'];
  targetLabel: Scalars['String']['output'];
};

export type SourceDataMappingInput = {
  sourceColumn: Scalars['String']['input'];
  targetColumn: Scalars['String']['input'];
};

export type SourceDataUpload = {
  __typename?: 'SourceDataUpload';
  amsType: AmsType;
  checks?: Maybe<SourceDataUploadChecks>;
  created: Scalars['Timestamp']['output'];
  discoveredColumns?: Maybe<Array<DiscoveredSourceColumn>>;
  downloadUrl?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  externalSystem: ExternalSystem;
  fileName: Scalars['String']['output'];
  gates: Array<SourceDataUploadGate>;
  id: Scalars['ID']['output'];
  mapping?: Maybe<SourceDataMapping>;
  metrics?: Maybe<SourceDataUploadMetrics>;
  sheetName?: Maybe<Scalars['String']['output']>;
  status: SourceDataUploadStatus;
  updated: Scalars['Timestamp']['output'];
  uploader?: Maybe<AuthUser>;
  validationReport?: Maybe<SourceDataValidationReport>;
};

export type SourceDataUploadCheck = {
  __typename?: 'SourceDataUploadCheck';
  actual?: Maybe<Scalars['Float']['output']>;
  deviationPercent?: Maybe<Scalars['Float']['output']>;
  expected?: Maybe<Scalars['Float']['output']>;
  passed?: Maybe<Scalars['Boolean']['output']>;
  percentOfExpected?: Maybe<Scalars['Float']['output']>;
  tolerancePercent?: Maybe<Scalars['Float']['output']>;
};

export type SourceDataUploadChecks = {
  __typename?: 'SourceDataUploadChecks';
  trailing12Premium?: Maybe<SourceDataUploadCheck>;
};

export type SourceDataUploadGate = {
  __typename?: 'SourceDataUploadGate';
  code: Scalars['String']['output'];
  current?: Maybe<Scalars['Float']['output']>;
  detail?: Maybe<Scalars['String']['output']>;
  percent?: Maybe<Scalars['Float']['output']>;
  previous?: Maybe<Scalars['Float']['output']>;
  thresholdPercent?: Maybe<Scalars['Float']['output']>;
};

export type SourceDataUploadInitResult = {
  __typename?: 'SourceDataUploadInitResult';
  uploadId: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type SourceDataUploadMetrics = {
  __typename?: 'SourceDataUploadMetrics';
  maxPolicyEndDate?: Maybe<Scalars['String']['output']>;
  minPolicyStartDate?: Maybe<Scalars['String']['output']>;
  trailing12Basis?: Maybe<Scalars['String']['output']>;
  trailing12Premium?: Maybe<Scalars['Float']['output']>;
  trailing12WindowEnd?: Maybe<Scalars['String']['output']>;
  trailing12WindowStart?: Maybe<Scalars['String']['output']>;
};

export enum SourceDataUploadStatus {
  Failed = 'FAILED',
  Mapping = 'MAPPING',
  Submitted = 'SUBMITTED',
  Uploading = 'UPLOADING',
  ValidationInProgress = 'VALIDATION_IN_PROGRESS',
  ValidationReview = 'VALIDATION_REVIEW'
}

export type SourceDataUploads = {
  __typename?: 'SourceDataUploads';
  accessibleSystems: Array<ExternalSystem>;
  availableReports: Array<AmsType>;
  byId?: Maybe<SourceDataUpload>;
  externalSystem?: Maybe<ExternalSystem>;
  history: Array<SourceDataUpload>;
  latest?: Maybe<SourceDataUpload>;
};


export type SourceDataUploadsAvailableReportsArgs = {
  externalSystemId?: InputMaybe<Scalars['ID']['input']>;
};


export type SourceDataUploadsByIdArgs = {
  externalSystemId?: InputMaybe<Scalars['ID']['input']>;
  uploadId: Scalars['String']['input'];
};


export type SourceDataUploadsExternalSystemArgs = {
  externalSystemId?: InputMaybe<Scalars['ID']['input']>;
};


export type SourceDataUploadsHistoryArgs = {
  externalSystemId?: InputMaybe<Scalars['ID']['input']>;
};


export type SourceDataUploadsLatestArgs = {
  externalSystemId?: InputMaybe<Scalars['ID']['input']>;
};

export type SourceDataValidationReport = {
  __typename?: 'SourceDataValidationReport';
  statistic?: Maybe<SourceDataValidationStatistic>;
  totals: SourceDataValidationTotals;
  warnings: Array<Scalars['String']['output']>;
};

export type SourceDataValidationStatistic = {
  __typename?: 'SourceDataValidationStatistic';
  carriers: SourceDataValidationStatisticEntry;
  clients: SourceDataValidationStatisticEntry;
  policies: SourceDataValidationStatisticEntry;
  premium: SourceDataValidationStatisticEntry;
  products: SourceDataValidationStatisticEntry;
  record: SourceDataValidationStatisticEntry;
  revenue: SourceDataValidationStatisticEntry;
};

export type SourceDataValidationStatisticEntry = {
  __typename?: 'SourceDataValidationStatisticEntry';
  passed?: Maybe<Scalars['Float']['output']>;
  skipped?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type SourceDataValidationTotals = {
  __typename?: 'SourceDataValidationTotals';
  carriers?: Maybe<Scalars['Int']['output']>;
  clients?: Maybe<Scalars['Int']['output']>;
  policies?: Maybe<Scalars['Int']['output']>;
  premium?: Maybe<Scalars['Float']['output']>;
  products?: Maybe<Scalars['Int']['output']>;
  recordCount?: Maybe<Scalars['Int']['output']>;
  revenue?: Maybe<Scalars['Float']['output']>;
  skippedCount?: Maybe<Scalars['Int']['output']>;
};

export type Specialist = {
  __typename?: 'Specialist';
  groupName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  role: Scalars['String']['output'];
  sourceRoleDescription: Scalars['String']['output'];
  user: User;
};

export type StoredDocumentsFilter = {
  __typename?: 'StoredDocumentsFilter';
  filter: DocumentsFilterOutput;
  id: Scalars['ID']['output'];
  lastUsed?: Maybe<Scalars['Timestamp']['output']>;
  name: Scalars['String']['output'];
  /** A tag to identify the page or context where the filter is used */
  tag: Scalars['String']['output'];
  type: StoredFilterType;
};

export type StoredFilter = {
  __typename?: 'StoredFilter';
  filter: PolicyFilterOutput;
  id: Scalars['ID']['output'];
  lastUsed?: Maybe<Scalars['Timestamp']['output']>;
  name: Scalars['String']['output'];
  type: StoredFilterType;
};

export enum StoredFilterType {
  Recent = 'RECENT',
  Saved = 'SAVED'
}

export type StoredFilters = {
  __typename?: 'StoredFilters';
  byId?: Maybe<StoredFilter>;
  recent: Array<StoredFilter>;
  saved: Array<StoredFilter>;
};


export type StoredFiltersByIdArgs = {
  id: Scalars['ID']['input'];
};


export type StoredFiltersRecentArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type StoredFiltersCreatePayload = {
  filter: PolicyFilter;
  /** Needed to simplify the migration from FE */
  lastUsed?: InputMaybe<Scalars['Timestamp']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type: StoredFilterType;
};

export type StoredFiltersCreateResponse = {
  __typename?: 'StoredFiltersCreateResponse';
  created: StoredFilter;
};

export type StoredFiltersDeleteResponse = {
  __typename?: 'StoredFiltersDeleteResponse';
  success: Scalars['Boolean']['output'];
};

export type StoredFiltersUpdateLastUserResponse = {
  __typename?: 'StoredFiltersUpdateLastUserResponse';
  success: Scalars['Boolean']['output'];
};

export type StoredFiltersUpdatePayload = {
  filter: PolicyFilter;
  name: Scalars['String']['input'];
  type: StoredFilterType;
};

export type StoredFiltersUpdateResponse = {
  __typename?: 'StoredFiltersUpdateResponse';
  updated: StoredFilter;
};

export type StoredFiltersV2 = {
  __typename?: 'StoredFiltersV2';
  documentsFiltersList: Array<StoredDocumentsFilter>;
  policyFiltersList: Array<StoredPolicyFilter>;
};


export type StoredFiltersV2DocumentsFiltersListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
  types: Array<StoredFilterType>;
};


export type StoredFiltersV2PolicyFiltersListArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
  types: Array<StoredFilterType>;
};

export type StoredPolicyFilter = {
  __typename?: 'StoredPolicyFilter';
  filter: PolicyFilterOutput;
  id: Scalars['ID']['output'];
  lastUsed?: Maybe<Scalars['Timestamp']['output']>;
  name: Scalars['String']['output'];
  /** A tag to identify the page or context where the filter is used */
  tag: Scalars['String']['output'];
  type: StoredFilterType;
};

export type Tableau = {
  __typename?: 'Tableau';
  dashboards: Array<TableauDashboard>;
};

export type TableauDashboard = {
  __typename?: 'TableauDashboard';
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type TableauToken = {
  __typename?: 'TableauToken';
  jwt: Scalars['String']['output'];
};

export type TargetIndustryOpportunity = {
  __typename?: 'TargetIndustryOpportunity';
  avgRevenuePerClient: Scalars['Float']['output'];
  clients: Scalars['Float']['output'];
  industrySubGroup: Industry;
  medianRevenuePerClient: Scalars['Float']['output'];
  productsPerClient: Scalars['Float']['output'];
  revenue: Scalars['Float']['output'];
};

export type TargetIndustryOpportunityV2 = {
  __typename?: 'TargetIndustryOpportunityV2';
  avgRevenuePerClient: Scalars['Float']['output'];
  clients: Scalars['Float']['output'];
  industry: Industry;
  medianRevenuePerClient: Scalars['Float']['output'];
  productsPerClient: Scalars['Float']['output'];
  revenue: Scalars['Float']['output'];
};

/** Mode for threshold calculation */
export enum ThresholdMode {
  Account = 'ACCOUNT',
  Policy = 'POLICY'
}

export type TopActivitiesResult = {
  __typename?: 'TopActivitiesResult';
  code: Scalars['String']['output'];
  codeDescription?: Maybe<Scalars['String']['output']>;
  count: Scalars['Int']['output'];
};

export type TopEntitiesWidgetParams = {
  __typename?: 'TopEntitiesWidgetParams';
  carrierLevel?: Maybe<CarrierLevel>;
  filter?: Maybe<PolicyFilterOutput>;
  mainEntity: WidgetEntity;
  metric: PolicyMetric;
  metricKeys?: Maybe<Array<PolicyMetric>>;
  radioValue?: Maybe<Scalars['String']['output']>;
  subEntity: WidgetEntity;
};

export type TopEntitiesWidgetParamsInput = {
  carrierLevel?: InputMaybe<CarrierLevel>;
  filter?: InputMaybe<PolicyFilter>;
  mainEntity: WidgetEntity;
  metric: PolicyMetric;
  metricKeys?: InputMaybe<Array<PolicyMetric>>;
  radioValue?: InputMaybe<Scalars['String']['input']>;
  subEntity: WidgetEntity;
};

export type Transaction = {
  __typename?: 'Transaction';
  amount: Amount;
  date: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  policy: Policy;
};

export type TrendDataPoint = {
  __typename?: 'TrendDataPoint';
  month: Scalars['SimpleDate']['output'];
  value: Scalars['Float']['output'];
};

export type Trends = {
  __typename?: 'Trends';
  byMonth: MonthlyTrends;
  retentionByMonth: RetentionMonthlyTrends;
};


export type TrendsByMonthArgs = {
  params: TrendsByMonthInput;
};


export type TrendsRetentionByMonthArgs = {
  params: RetentionTrendsByMonthInput;
};

export type TrendsByMonthInput = {
  filter: PolicyFilter;
  metric: PolicyMetric;
};

export enum UpcomingRenewalState {
  CannotCalculateMissingDates = 'CANNOT_CALCULATE_MISSING_DATES',
  InvalidPolicy = 'INVALID_POLICY',
  InProgress = 'IN_PROGRESS',
  Lost = 'LOST',
  NotApplicable = 'NOT_APPLICABLE',
  Pending = 'PENDING',
  PolicyRewritten = 'POLICY_REWRITTEN',
  RenewalNotApplicable = 'RENEWAL_NOT_APPLICABLE',
  Renewed = 'RENEWED',
  UpcomingCancellation = 'UPCOMING_CANCELLATION'
}

export type UpcomingRenewalsWidgetParams = {
  __typename?: 'UpcomingRenewalsWidgetParams';
  filter?: Maybe<PolicyFilterOutput>;
  tableEntity?: Maybe<WidgetEntity>;
  tableEntityId?: Maybe<Scalars['String']['output']>;
};

export type UpcomingRenewalsWidgetParamsInput = {
  filter?: InputMaybe<PolicyFilter>;
  tableEntity?: InputMaybe<WidgetEntity>;
  tableEntityId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProducerGoalPayload = {
  __typename?: 'UpdateProducerGoalPayload';
  updated: ProducerGoal;
};

export type UpdateUserReportPresetPayload = {
  __typename?: 'UpdateUserReportPresetPayload';
  updated: UserReportPreset;
};

export type UpsertDocumentsFilter = {
  filter?: InputMaybe<DocumentsFilter>;
  /** If id is provided, the record will be updated instead of created */
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** A tag to identify the page or context where the filter is used */
  tag?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<StoredFilterType>;
};

export type UpsertPolicyFilter = {
  filter?: InputMaybe<PolicyFilter>;
  /** If id is provided, the record will be updated instead of created */
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** A tag to identify the page or context where the filter is used */
  tag?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<StoredFilterType>;
};

export type UsedAdminCompanyWithChildren = {
  __typename?: 'UsedAdminCompanyWithChildren';
  children?: Maybe<Array<UsedAdminCompanyWithChildren>>;
  companyStatus: BrokerMarketStatus;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  primaryRelationship: InsuranceCompanyRelationshipType;
};

export type User = {
  __typename?: 'User';
  amsRoles: Array<UserAmsRole>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  metrics?: Maybe<EntityMetrics>;
  /** The same as fullName */
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  shortNames: Array<Scalars['String']['output']>;
};

export enum UserAmsRole {
  AccountExecutive = 'ACCOUNT_EXECUTIVE',
  AccountManager = 'ACCOUNT_MANAGER',
  Producer = 'PRODUCER'
}

export type UserFilterInput = {
  amsRoles?: InputMaybe<Array<UserAmsRole>>;
};

/** Uses OR logic inside */
export type UserFilters = {
  accountExecutiveIds?: InputMaybe<Array<Scalars['String']['input']>>;
  accountExecutiveIdsAndSourceCodes?: InputMaybe<Array<UserIdAndSourceCodes>>;
  accountExecutiveIsEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  accountManagerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  accountManagerIdsAndSourceCodes?: InputMaybe<Array<UserIdAndSourceCodes>>;
  accountManagerIsEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  producerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  producerIdsAndSourceCodes?: InputMaybe<Array<UserIdAndSourceCodes>>;
  producerIsEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserFiltersOutput = {
  __typename?: 'UserFiltersOutput';
  accountExecutiveIds?: Maybe<Array<Scalars['String']['output']>>;
  accountExecutiveIdsAndSourceCodes?: Maybe<Array<UserIdAndSourceCodesOutput>>;
  accountExecutiveIsEmpty?: Maybe<Scalars['Boolean']['output']>;
  accountManagerIds?: Maybe<Array<Scalars['String']['output']>>;
  accountManagerIdsAndSourceCodes?: Maybe<Array<UserIdAndSourceCodesOutput>>;
  accountManagerIsEmpty?: Maybe<Scalars['Boolean']['output']>;
  producerIds?: Maybe<Array<Scalars['String']['output']>>;
  producerIdsAndSourceCodes?: Maybe<Array<UserIdAndSourceCodesOutput>>;
  producerIsEmpty?: Maybe<Scalars['Boolean']['output']>;
};

export type UserIdAndSourceCodes = {
  sourceCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  userId: Scalars['String']['input'];
};

export type UserIdAndSourceCodesOutput = {
  __typename?: 'UserIdAndSourceCodesOutput';
  sourceCodes?: Maybe<Array<Scalars['String']['output']>>;
  userId: Scalars['String']['output'];
};

export type UserInfo = {
  __typename?: 'UserInfo';
  ennablEmployeeId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastActive?: Maybe<Scalars['Timestamp']['output']>;
  /** @deprecated Use permissions field instead */
  permissionIds: Array<Scalars['String']['output']>;
  permissions: Array<AppPermission>;
  profile?: Maybe<UserProfile>;
  /** Can be null in case if user has no access, and has no role */
  role?: Maybe<EnnablUserRole>;
  roleType: EnnablRoleType;
  roles: Array<EnnablRole>;
  tenantId: Scalars['String']['output'];
  tenantName: Scalars['String']['output'];
  timeZone?: Maybe<Scalars['String']['output']>;
};

export type UserKpi = {
  __typename?: 'UserKpi';
  created: Scalars['Timestamp']['output'];
  entity?: Maybe<UserKpiEntity>;
  entityDeclaration?: Maybe<UserKpiEntityDeclaration>;
  filteringMode: UserKpiFilteringMode;
  id: Scalars['String']['output'];
  metric: UserKpiMetric;
  name?: Maybe<Scalars['String']['output']>;
  period?: Maybe<UserKpiPeriod>;
  policyStatus?: Maybe<Array<UserKpiPolicyStatus>>;
  /** @deprecated Not supported on KPI level - use dashboard updated */
  updated: Scalars['Timestamp']['output'];
};

export enum UserKpiCarrierMode {
  Bco = 'BCO',
  Ico = 'ICO'
}

export type UserKpiDashboardCreateKpiInput = {
  entityDeclaration?: InputMaybe<UserKpiEntityDeclarationInput>;
  filteringMode?: UserKpiFilteringMode;
  id: Scalars['String']['input'];
  metric: UserKpiMetric;
  name?: InputMaybe<Scalars['String']['input']>;
  period?: InputMaybe<UserKpiPeriodInput>;
  policyStatus?: InputMaybe<Array<UserKpiPolicyStatus>>;
};

export type UserKpiDashboards = {
  __typename?: 'UserKpiDashboards';
  all: Array<KpiDashboard>;
  byId: KpiDashboard;
  currentDashboardId?: Maybe<Scalars['String']['output']>;
};


export type UserKpiDashboardsByIdArgs = {
  dashboardId: Scalars['String']['input'];
};

export type UserKpiEntity = Department | Industry | Market | Product | User;

export type UserKpiEntityDeclaration = {
  __typename?: 'UserKpiEntityDeclaration';
  carrierMode?: Maybe<UserKpiCarrierMode>;
  id: Scalars['String']['output'];
  type: UserKpiEntityType;
};

export type UserKpiEntityDeclarationInput = {
  carrierMode?: InputMaybe<UserKpiCarrierMode>;
  id: Scalars['String']['input'];
  type: UserKpiEntityType;
};

export enum UserKpiEntityType {
  AccountExecutive = 'ACCOUNT_EXECUTIVE',
  AccountManager = 'ACCOUNT_MANAGER',
  CarrierParent = 'CARRIER_PARENT',
  CarrierUltimate = 'CARRIER_ULTIMATE',
  Department = 'DEPARTMENT',
  Industry = 'INDUSTRY',
  IndustryGroup = 'INDUSTRY_GROUP',
  IndustrySubgroup = 'INDUSTRY_SUBGROUP',
  InsuranceSegment = 'INSURANCE_SEGMENT',
  IntermediaryChild = 'INTERMEDIARY_CHILD',
  IntermediaryParent = 'INTERMEDIARY_PARENT',
  IntermediaryUltimate = 'INTERMEDIARY_ULTIMATE',
  IssuingPaper = 'ISSUING_PAPER',
  Producer = 'PRODUCER',
  Product = 'PRODUCT',
  ProductGroup = 'PRODUCT_GROUP',
  ProductSuperGroup = 'PRODUCT_SUPER_GROUP'
}

export enum UserKpiFilteringMode {
  Book = 'BOOK',
  CrossSell = 'CROSS_SELL',
  Lost = 'LOST',
  Retention = 'RETENTION'
}

export enum UserKpiMetric {
  AccountExecutiveCount = 'ACCOUNT_EXECUTIVE_COUNT',
  AccountManagerCount = 'ACCOUNT_MANAGER_COUNT',
  AvgCommissionPct = 'AVG_COMMISSION_PCT',
  CarrierCount = 'CARRIER_COUNT',
  ClientCount = 'CLIENT_COUNT',
  DirectPremium = 'DIRECT_PREMIUM',
  GrowthRevenue = 'GROWTH_REVENUE',
  IndirectPremium = 'INDIRECT_PREMIUM',
  IndustryCount = 'INDUSTRY_COUNT',
  IntermediaryCount = 'INTERMEDIARY_COUNT',
  PolicyCount = 'POLICY_COUNT',
  Premium = 'PREMIUM',
  ProducerCount = 'PRODUCER_COUNT',
  ProductCount = 'PRODUCT_COUNT',
  Revenue = 'REVENUE'
}

export type UserKpiPeriod = {
  __typename?: 'UserKpiPeriod';
  amountType?: Maybe<PolicyAmountType>;
  /** Only for IN_FORCE */
  timestamp?: Maybe<Scalars['SimpleDate']['output']>;
  type: PeriodType;
};

export type UserKpiPeriodInput = {
  amountType?: InputMaybe<PolicyAmountType>;
  /** Only for IN_FORCE */
  timestamp?: InputMaybe<Scalars['SimpleDate']['input']>;
  type: PeriodType;
};

export enum UserKpiPolicyStatus {
  Cancelled = 'CANCELLED',
  CrossSell = 'CROSS_SELL',
  Lost = 'LOST',
  NetNew = 'NET_NEW',
  Renewal = 'RENEWAL'
}

export type UserListPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<UserSortingField>;
  /** Total count will be different if we use sorting by metric with permissions */
  sortOrder?: InputMaybe<SortOrder>;
};

export type UserManagement = {
  __typename?: 'UserManagement';
  appUserPermissions: Array<AppUserPermissionObject>;
  user: EnnablUser;
  users: Array<EnnablUser>;
  viewModes: Array<EnnablUserViewModeObject>;
};


export type UserManagementUserArgs = {
  id: Scalars['ID']['input'];
};

export type UserPaginatedResult = {
  __typename?: 'UserPaginatedResult';
  items: Array<User>;
  totalHits: Scalars['Int']['output'];
};

export type UserProfile = {
  __typename?: 'UserProfile';
  email?: Maybe<Scalars['String']['output']>;
  familyName?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type UserReport = {
  __typename?: 'UserReport';
  createdAt: Scalars['Timestamp']['output'];
  filename: Scalars['String']['output'];
  filterName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  presetDescription?: Maybe<Scalars['String']['output']>;
  presetId?: Maybe<Scalars['ID']['output']>;
  presetName?: Maybe<Scalars['String']['output']>;
  schedule?: Maybe<ReportSubscriptionSchedule>;
  status: UserReportStatus;
  type: UserReportType;
  /** for small reports operation is sync. URL returned in the payload */
  url?: Maybe<Scalars['String']['output']>;
};

export enum UserReportFileType {
  Csv = 'CSV',
  Pdf = 'PDF',
  Xlsx = 'XLSX'
}

export type UserReportGroup = {
  __typename?: 'UserReportGroup';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  presets: Array<UserReportPreset>;
  presetsCreatable: Scalars['Boolean']['output'];
  reportParameters: ReportParameters;
  skipPolicyFilter?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<UserReportType>;
};

/** This class allow users to create presets for the reports to download them later or schedule email */
export type UserReportPreset = {
  __typename?: 'UserReportPreset';
  createdByAdmin: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  group?: Maybe<UserReportGroup>;
  id: Scalars['ID']['output'];
  isPredefined: Scalars['Boolean']['output'];
  lastSent?: Maybe<Scalars['Timestamp']['output']>;
  name: Scalars['String']['output'];
  reportParameters: ReportParameters;
  reports?: Maybe<Array<UserReport>>;
  schedule?: Maybe<ReportSubscriptionSchedule>;
  type: UserReportType;
};

export type UserReportPresetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  reportParameters: ReportParametersInput;
  schedule?: InputMaybe<ReportSubscriptionScheduleInput>;
  type: UserReportType;
};

export type UserReportPresets = {
  __typename?: 'UserReportPresets';
  all: Array<UserReportPreset>;
  byId?: Maybe<UserReportPreset>;
  dataAudits: Array<UserReportPreset>;
  groups: Array<UserReportGroup>;
  subscribed: Array<UserReportPreset>;
};


export type UserReportPresetsByIdArgs = {
  presetId: Scalars['String']['input'];
};

export enum UserReportStatus {
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING',
  Ready = 'READY'
}

export enum UserReportType {
  AccountExecutiveTopIndustriesReport = 'ACCOUNT_EXECUTIVE_TOP_INDUSTRIES_REPORT',
  AccountExecutiveTopProductsReport = 'ACCOUNT_EXECUTIVE_TOP_PRODUCTS_REPORT',
  AccountLeaderboard = 'ACCOUNT_LEADERBOARD',
  AccountManager = 'ACCOUNT_MANAGER',
  AccountManagerAccountSize = 'ACCOUNT_MANAGER_ACCOUNT_SIZE',
  AccountManagerBookProfile = 'ACCOUNT_MANAGER_BOOK_PROFILE',
  AccountManagerProducerSupport = 'ACCOUNT_MANAGER_PRODUCER_SUPPORT',
  AccountManagerRenewal = 'ACCOUNT_MANAGER_RENEWAL',
  AccountManagerTopCarriers = 'ACCOUNT_MANAGER_TOP_CARRIERS',
  AccountManagerTopIndustries = 'ACCOUNT_MANAGER_TOP_INDUSTRIES',
  AccountManagerTopProducts = 'ACCOUNT_MANAGER_TOP_PRODUCTS',
  AccountReportAvgAccSize = 'ACCOUNT_REPORT_AVG_ACC_SIZE',
  AccountReportGrowth = 'ACCOUNT_REPORT_GROWTH',
  AccountReportLost = 'ACCOUNT_REPORT_LOST',
  AccountReportPremiumAccSize = 'ACCOUNT_REPORT_PREMIUM_ACC_SIZE',
  ActivityKpi = 'ACTIVITY_KPI',
  ActivityLeaderboard = 'ACTIVITY_LEADERBOARD',
  Aggregated = 'AGGREGATED',
  CarrierAppetite = 'CARRIER_APPETITE',
  /** @deprecated Carrier Downgrades report has been discontinued (AM Best data provider contract ended). */
  CarrierDowngrades = 'CARRIER_DOWNGRADES',
  CarrierPdfReport = 'CARRIER_PDF_REPORT',
  ClientNaics = 'CLIENT_NAICS',
  CrossSellRecommendations = 'CROSS_SELL_RECOMMENDATIONS',
  CustomAggregated = 'CUSTOM_AGGREGATED',
  CustomPlain = 'CUSTOM_PLAIN',
  CustomQuery = 'CUSTOM_QUERY',
  DataAudit = 'DATA_AUDIT',
  DataManagementAgenciesReport = 'DATA_MANAGEMENT_AGENCIES_REPORT',
  EnrichmentCompanyMappings = 'ENRICHMENT_COMPANY_MAPPINGS',
  Kpi = 'KPI',
  Leaderboard = 'LEADERBOARD',
  LifetimeMultipleClients = 'LIFETIME_MULTIPLE_CLIENTS',
  LifetimeMultipleIndustries = 'LIFETIME_MULTIPLE_INDUSTRIES',
  LifetimeSingleClient = 'LIFETIME_SINGLE_CLIENT',
  LocationPdfReport = 'LOCATION_PDF_REPORT',
  LossRunsPdfReport = 'LOSS_RUNS_PDF_REPORT',
  Mapping = 'MAPPING',
  MgaAccountReportGrowth = 'MGA_ACCOUNT_REPORT_GROWTH',
  MgaBookPerformance = 'MGA_BOOK_PERFORMANCE',
  MgaLeaderboard = 'MGA_LEADERBOARD',
  MgaPolicy = 'MGA_POLICY',
  MgaSubmissions = 'MGA_SUBMISSIONS',
  MonolineRatios = 'MONOLINE_RATIOS',
  MonolineRatioPolicies = 'MONOLINE_RATIO_POLICIES',
  OutflowInflowPolicies = 'OUTFLOW_INFLOW_POLICIES',
  Policy = 'POLICY',
  PremiumFlow = 'PREMIUM_FLOW',
  ProducerCredit = 'PRODUCER_CREDIT',
  ProducerGoals = 'PRODUCER_GOALS',
  ProducerTopIndustriesReport = 'PRODUCER_TOP_INDUSTRIES_REPORT',
  ProducerTopProductsReport = 'PRODUCER_TOP_PRODUCTS_REPORT',
  ProductionCredit = 'PRODUCTION_CREDIT',
  Prospect = 'PROSPECT',
  Retention = 'RETENTION',
  RetentionInsights = 'RETENTION_INSIGHTS',
  RoiCrossSell = 'ROI_CROSS_SELL',
  SavedOpportunities = 'SAVED_OPPORTUNITIES',
  Score_360Clients = 'SCORE_360_CLIENTS',
  Score_360Producers = 'SCORE_360_PRODUCERS',
  TargetIndustry = 'TARGET_INDUSTRY',
  UsersReport = 'USERS_REPORT'
}

export type UserReports = {
  __typename?: 'UserReports';
  byId?: Maybe<UserReport>;
};


export type UserReportsByIdArgs = {
  id: Scalars['String']['input'];
};

export enum UserSortingField {
  Commission = 'COMMISSION',
  FullName = 'FULL_NAME',
  Id = 'ID',
  Premium = 'PREMIUM',
  Revenue = 'REVENUE'
}

export type Users = {
  __typename?: 'Users';
  getByEmail?: Maybe<User>;
  /** @deprecated Use paginated instead */
  list: Array<User>;
  paginated: UserPaginatedResult;
};


export type UsersGetByEmailArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
};


export type UsersListArgs = {
  filter?: InputMaybe<UserFilterInput>;
  pagination?: InputMaybe<UserListPaginationInput>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type UsersPaginatedArgs = {
  filter?: InputMaybe<UserFilterInput>;
  pagination?: InputMaybe<UserListPaginationInput>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export enum WidgetEntity {
  AccountExecutive = 'ACCOUNT_EXECUTIVE',
  AccountManager = 'ACCOUNT_MANAGER',
  Carrier = 'CARRIER',
  Client = 'CLIENT',
  Department = 'DEPARTMENT',
  Industry = 'INDUSTRY',
  Intermediary = 'INTERMEDIARY',
  Monoline = 'MONOLINE',
  PolicyStatus = 'POLICY_STATUS',
  Producer = 'PRODUCER',
  Product = 'PRODUCT',
  WinBack = 'WIN_BACK'
}

export type WinBackOpportunityAggregationByClient = {
  __typename?: 'WinBackOpportunityAggregationByClient';
  client: Client;
  count: Scalars['Int']['output'];
  lostDate: Scalars['SimpleDate']['output'];
  producers: Array<User>;
  revenue: Scalars['Float']['output'];
};

export type WinBackOpportunityV2 = {
  __typename?: 'WinBackOpportunityV2';
  id: Scalars['ID']['output'];
  policy: Policy;
  saved?: Maybe<SavedOpportunityWinBack>;
};

export type WinBackOpportunityV2PaginatedResult = {
  __typename?: 'WinBackOpportunityV2PaginatedResult';
  items: Array<WinBackOpportunityV2>;
  totalHits: Scalars['Int']['output'];
};
